var log = WebAccess.utils.log;
/**
* Инициализация всех страниц.
*/
$('document').ready(function () {
  log.info('NAVIGATION', new WA.URL().asString());
  Core.migration.init();
  Core.agent.checkNotifications();

  switch (WA.getLocation()) {
    case 'login':
      setRealHeightAndWidth();
      break;

    case 'explorer':
      Core.agent.init();

      Core.header.actions.
        initAboutMenu().
        initSettingsMenu();

      Core.footer.
        initFastSearchFilter().
        initViewSwitchingMenu().
        initExtensionsMenu().
        initCurrentFolder();
      AfterSearch();

      new Core.objectList.dragging();
      Core.toolBars.objectList.initPreFiltersMenu();
      Core.contextmenu.createFolderContextMenu();
      break;

    case 'reference':
      Core.agent.init();
      Core.sideBar.initTabs();

      new Core.objectList.dragging();
      Core.cards.bindButtonsEnablingOnFormChange(['RefCardSave', 'RefCardSaveAndClose']);
      Core.cards.initResizablePreviewCard();
      break;

    case 'job':
    case 'task':
      Core.agent.init();
      new Core.objectList.dragging();
      break;

    case 'doc':
      Core.agent.init();
      Core.sideBar.initTabs();

      new Core.objectList.dragging();
      Core.documents.bindButtonsEnabling();
      Core.cards.initResizablePreviewCard();
      break;

    case 'settings':
      Core.settings.
        initPreviewSettings().
        initColoringRecordsSettings().
        initAutoCleaningSettings().
        initAgentControls().
        initDocDefaultAction().
        initManagedFoldersSettings();

      break;

    case 'referencerecords':
      Core.agent.init();
      WA.CR.window.bind('beforeClose', function () {
        var grid = WA.CR.objectList._grid;
        // В случае если справочник открыли как результат сценария (ориентируемся на параметр uid в урле), то освобождать Query не требуется.
        if (grid && (!(new WA.URL).getParam('uid'))) {
          WA.SRV.callSync("/Reference.asmx/FreeReferenceQuery", {
            ReferenceName: WA.CR.ReferenceCode,
            QueryInstanceId: WA.CR.objectList._grid.state.QueryInstanceID
          });
        }
      });
      break;

    case "folder":
      window.bindButtonsEnablingOnFormChange();
      break;
  }
});

// Старый mobile safari не может совладать со 100% шириной внутри flex'а, оставляя ее равной ширине родителя.
// Пришлось запилить такой фикс, чтобы гамбургер в списке объектов был виден и в старых версиях
WebAccess.ready(function () {
  if (WA.ENV.isIOS()
    && (WA.ENV.browser.name.toLowerCase().indexOf('safari') !== -1)
    && (parseInt(WA.ENV.browser.version) <= 8)) {
    $('.object-list-item__column_type_IconMenu').css('margin-left', '-130px');
  }
});

/**
* При смене ориентации устройства:
*   1. Если есть модальное окно и у него есть "засеренный" слой, его надо
*      поджимать при повороте, иначе его фиксированная ширина делает страницу
*      шире чем она есть и появляются белые зоны. Актуально для ipad.
*   2. Центируем открытые диалоги если такие есть.
*/
$(window).on("orientationchange", function (event) {
  fitDialogOverlayToPage();
  setTimeout(function () {
    moveOpenedDialogToCenter();
  }, 500); //полсекунды. больше - плохо, меньше - не работает.
})
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * При смене размеров окна:
  *   1. Создаем событие для $(window), которое вызовется, толко после завершения
  *      изменения размера.
  */
  .on("resize", function () {
    createResizeEndEvent($(this));
  })
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * После изменения размеров окна:
  *   1. Инициализация drag & drop раздвижения панели с деревом в проводнике.
  *   2. Сворачивание и разворачивание групп кнопок, в зависимости от размеров
  *      окна и их приоритета.
  *   3. Центирируем диалоги, если есть.
  */
  .on('resizeEnd', function () {
    if (WA.getLocation == "explorer") {
      InitExplorerSidebar(window.treeWidth);
    };
    moveOpenedDialogToCenter();
  });

/**
* Обработка статистики
*/
WebAccess.ready(function () {
  if (Core.isStatisticEnabled) {
    WA.CR.statistics.enable();
    var eventName = (WA.ENV.os.name.toLowerCase() === 'ios' || WA.ENV.os.name.toLowerCase() === 'android' ? 'touchstart' : 'mousedown');
    $(document).on(eventName + '.stat', function (event) {
      WA.CR.statistics.write(event.target);
    });
  };
});
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//



/* =Main==================================================================== */

// Эти две нижуказанные переменные могут быть установлены на бэкенде
var g_LeadJobID = 0;
var g_ViewOnlyMsg = '';

var MIN_WINDOW_WIDTH = $('body').hasClass('tablet') ? 770 : 930;
var MIN_WINDOW_HEIGHT = 600;
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* TODO: window.innerWidth есть во всех поддерживаемых браузерах, отдельная функция windowWidth() не нужна
*/
function windowWidth() {
  return window.innerWidth;
}
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
 * TODO: window.innerHeight есть во всех поддерживаемых браузерах, отдельная функция windowHeight() не нужна
*/
function windowHeight() {
  return window.innerHeight;
}
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

window.lastWindowWidth = $(window).width();
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Вычисление размеров полос прокрутки.
* TODO: возможно, стоит удалить. Почти нигде не используется
*/
(function () {
  var i = document.createElement('p');
  i.style.width = '100%';
  i.style.height = '200px';
  var o = document.createElement('div');
  o.style.top = 0;
  o.style.left = 0;
  o.style.visibility = 'hidden';
  o.style.width = '200px';
  o.style.height = '200px';
  o.style.overflow = 'hidden';
  o.appendChild(i);
  document.body.appendChild(o);
  var w1 = i.offsetWidth;
  var h1 = i.offsetHeight;
  o.style.overflow = 'scroll';
  var w2 = i.offsetWidth;
  var h2 = i.offsetHeight;
  if (w1 == w2) w2 = o.clientWidth;
  if (h1 == h2) h2 = o.clientWidth;
  document.body.removeChild(o);

  /**
  * Ширина полосы прокуртки
  * @global scrollbarWidth
  */
  window.scrollbarWidth = w1 - w2;

  /**
  * Высота полосы прокрутки
  */
  window.scrollbarHeight = h1 - h2;
})();
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

(function (global) {
  /**
  * Вычисление и перерисовка размеров элементов, для которых не удалось задать
  * нормальные кроссбраузерные параметры одной лишь версткой.
  * @global
  * @function setRealHeightAndWidth
  */
  global.setRealHeightAndWidth = () => {
    let location = WA.getLocation();

    if (location !== 'job' && location !== 'task') {
      adaptiveRules();

      setMainColumnsHeight();

      switch (location) {
        case 'explorer':
          setExplorerLayout();
          break;
        case 'doc':
        case 'documentpreview':
          setDocumentPreviewHeight();
          break;
        case 'referencerecords':
          setReferenceRecordsContainerHeight();
      }
    }

    $('html').trigger('OnSetRealHeightAndWidth');
  };

  /**
  * Правила скрытия и появления элементов, когда экран сильно необычный
  * 1. Если мобильник или планшет, то убираем overflow:hidden чтобы сделать
  * min-height/min-width сразу после загрузки.
  */
  function adaptiveRules() {
    if (WA.getLocation() === 'login') {
      return;
    }

    switch (WA.ENV.os.name) {
      case 'iOS':
        resetZoomForIpad();
        break;
      case 'Android':
        resetZoomForAndroid();
        break;
      default:
        applyExtraZoomForSurface();
    }

    /**
    * Zoom для Surface; Используется правило, которое
    * работает только в новых версиях ИЕ. При смене ориентации включается
    * css правило которое увеличивает все страницу пропорционально.
    * @inner
    * @function applyExtraZoom
    */
    function applyExtraZoomForSurface() {
      if (WA.ENV.isTouch()) {
        // При таком зуме проявляется дефект, когда нижняя панель в справочниках уезжает направо.
        $('#reference_footer .tc_right').width('auto');
      }
    }

    /**
    * В андроиде есть проблема: при смене ориентации меняются размеры страницы,
    * поэтому setRealHeightAndWidth неправильно масштабирует главные колонки.
    * Данная функция сбрасывает зум при каждом изменении экрана.
    * @function resetZoomForAndroid
    * @inner
    */
    function resetZoomForAndroid() {
      var jMeta = $('meta[name=viewport]');
      var reset = 'width=device-width, height=device-height, initial-scale=1.0' +
        ', minimum-scale=1.0';
      jMeta.attr('content', reset);
    };
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * В Ipad тоже есть проблема: при смене ориентации меняются размеры страницы,
    * Данная функция сбрасывает размер viewport-а на
    * минимальную ширину/высоту страницы, но не ломает масштабирование.
    * @see http://goo.gl/RC4HmF
    * @function resetZoomForAndroid
    * @inner
    */
    function resetZoomForIpad() {
      var denyScale, allowScale;
      var jMeta = $('meta[name=viewport]');
      if (jMeta) {
        denyScale = 'width=device-width, minimum-scale=1.0,' +
          'maximum-scale=1.0, initial-scale=1.0';
        jMeta.attr('content', denyScale);

        document.body.addEventListener('gesturestart', function () {
          allowScale = 'width=device-width, minimum-scale=0.25,' +
            'maximum-scale=1.6';
          jMeta.attr('content', allowScale);
        }, false);
      };
    };
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  };

  /**
   * У контейнеров предпросмотра убираем прокрутки и отступы.
   *
   * @function setDocumentPreviewHeight
   */
  function setDocumentPreviewHeight() {
    const view = GetParamInURL('view').toLowerCase();
    if (view && view !== 'preview') {
      return;
    }

    const mode = GetParamInURL('mode').toLowerCase();
    if (mode !== 'new') {
      $('#main_container').css({ overflowY: 'hidden' });
    }

    const jContentContainer = $('#contentContainer');
    if (jContentContainer.length > 0) {
      const iframeHeight = $(window).height() - jContentContainer.offset().top;
      const jRightColumn = $('#right_column');
      if (jRightColumn) {
        jRightColumn.height(iframeHeight + $('.preview-panel').outerHeight());
      }
    }
  }

  /**
  * Поведение страницы проводника, когда экран становится слишком маленьким,
  * для того, чтобы продолжать отображаться как прежде.
  * @function setExplorerLayout
  * @inner
  */
  function setExplorerLayout() {
    /**
    * Если места становится мало, то боковая панель, сворачивается
    * и наоборот, разворачивается если места достаточно.
    */
    if (WA.SideBarInit.state() === "resolved") {
      if ((windowWidth() < MIN_WINDOW_WIDTH && !$.cookie('SideBarCollapsed')) || $.cookie('SideBarCollapsed') == '1') {
        WA.current.sideBar.collapse();
      } else {
        if (!$.cookie('SideBarCollapsed') || $.cookie('SideBarCollapsed') == '0') {
          WA.current.sideBar.expand();
        }
      }
    }
  }
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Проверяет, не находится ли страница внутри ифрейма.
  * @function inIframe
  * @inner
  */
  function inIframe() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  /**
  * Подбор высоты основных колонок. Эти колонки есть почти на каждой странице
  * и имеют высоту 100%. Но 100% - растягивает их не на ширину доступной
  * области, а в высоту окна. Данная функция исправляет это.
  * Если область меньше минимальной, то высота должна быть фиксированной.
  * @function setMainColumnsHeight
  * @inner
  */
  function setMainColumnsHeight() {

    let appHeight = $(window).height();
    let isWindowSmall = !inIframe() && (appHeight < window.MIN_WINDOW_HEIGHT);
    let jHtml = $('html');
    let jBody = jHtml.find('body');
    let jMainContainer = $('#main_container');
    if (isWindowSmall && jBody.find('.history-table').length) {
      appHeight = $(document).height();
    } else {
      // установка дефолтных стилей, которые ломаются на вкладке истории и остаются
      // сломанными при переходе на другую вкладку, если здесь их не восстановить
      jMainContainer.css({
        overflow: 'auto',
      });
    }

    let jLeftColumn = $('#left_column');
    if (jLeftColumn.length > 0 && !jLeftColumn.hasClass('horizontal')) {
      jLeftColumn.height(appHeight - jLeftColumn.offset().top);
    }

    let QFilterHeight = 0;
    let jRightColumn = $('#right_column');

    if (jRightColumn.length > 0) {
      let toolbarPanelHeight = jRightColumn.find('.toolbar').height() ||
        jRightColumn.find('.toolbar-container').height() ||
        36; // 36px -- высота тулбара на случай если он не успел отрисоваться

      jRightColumn.height(appHeight - jRightColumn.offset().top);

      switch (WA.getLocation()) {
        case 'doc':
        case 'reference':
        case 'folder':
          jMainContainer.height(jRightColumn.height() - toolbarPanelHeight);
          break;
      }

      let jFiltrationArea = jBody.find('.filtration-area');
      if (jFiltrationArea.length) {
        QFilterHeight = jFiltrationArea.height() + 7;
        jRightColumn.css('padding-bottom', QFilterHeight);
        jRightColumn.height(appHeight - jRightColumn.offset().top - QFilterHeight - toolbarPanelHeight);
      }
    }

    let jFolderCover = $('#folder_cover_frame');
    if (jFolderCover.length > 0) {
      jRightColumn.height(appHeight - jRightColumn.offset().top - QFilterHeight + 9);
      //Когда отображена обложка, то под iframe появляется 2px какого-то отступа.
      jFolderCover.height(appHeight - jFolderCover.offset().top - 2);
    }
  }

  /**
  * Подгонка высоты грида в справочниках.
  * @function setReferenceRecordsContainerHeight
  * @inner
  */
  function setReferenceRecordsContainerHeight() {
    let jMainContainer = $('#main_container');
    let jRightColumn = $('#right_column');
    let fullHeight = jRightColumn.height();
    // 2px нужны, чтобы не появлялся вертикальный скролл
    jMainContainer.height(fullHeight - jRightColumn.find('.toolbar').height() - 2);
    jMainContainer.trigger('resizeEnd.grid');
  }

})(window);


(function () {

  var oldWidth = null;
  var oldHeight = null;

  // На планшетах ресайз вызывается, даже когда размер окна не меняется - при скроллинге. Не будем вызывать мега-функцию, если размер окна не изменился.
  window.setRealHeightAndWidthOnResize = function (ev) {
    var w = windowWidth();
    var h = windowHeight();
    if (oldWidth != w || oldHeight != h) {
      setRealHeightAndWidth(ev);
      oldWidth = w;
      oldHeight = h;
    }
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Если открыт какой-либо диалог, то эта функция переместит его в центр страницы
  * @global
  * @function moveOpenedDialogToCenter
  */
  window.moveOpenedDialogToCenter = function () {
    var jDialog = $(".ui-dialog-content");
    if (jDialog.length > 0) jDialog.dialog("option", "position", "center");
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Если открыт какой-либо диалог, то эта функция подожмет рамеры штрихованного
  * слоя, под размер страницы.
  * Делается только для ios,  в остальных местах все удовлетворительно.
  * @global
  * @function moveOpenedDialogToCenter
  */
  window.fitDialogOverlayToPage = function () {
    if (WA.ENV.os.name !== "iOS") return;
    var jOverlay = $(".ui-widget-overlay");
    jOverlay.css({ "width": "100%", "height": $(document).height() });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * При ресайзе окна, событие ресайза срабатывает очень часто.
  * Обычно такая скорость и огромное кол-во срабатываний не нужно.
  * Данная функция срабатывает лишь однажды, когда изменение размера окна
  * действительно было завершено.
  * @global
  * @function createResizeEndEvent
  * @param {Object} jWindow - jquery объект $(window)
  * @return {Object} $(window)
  */
  window.createResizeEndEvent = function (jWindow) {
    if (jWindow.width() != window.lastWindowWidth || jWindow.height() != window.lastWindowHeight) {
      window.lastWindowWidth = jWindow.width();
      window.lastWindowHeight = jWindow.height();
      jWindow.trigger('resizeEnd');
    }
    return jWindow;
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


})();

// Клавиатурная навигация активна?
var isKeyNavigationActive = false;

function GetEventsName(namespace) {
  var ns = (namespace != '' ? '.' + namespace : '');
  var hoverEventNames = ['mouseenter' + ns, 'mouseleave' + ns];
  if ("ontouchend" in document) {
    hoverEventNames = ['touchstart' + ns, 'touchend' + ns];
  }
  return hoverEventNames;
}

function InitMouseEvents() {
  if ($.ipad) return;
  var hoverEventNames = GetEventsName('hover_toolbar_item');
  $('.toolbar_item, .small_toolbar_item')
    .bind(hoverEventNames[0], function () { $(this).not('.disabled').addClass('hover'); })
    .bind(hoverEventNames[1], function () { $(this).not('.disabled').removeClass('hover'); });
  InitHoverForButtons();
}

function InitHoverForButtons(cont) {
  if ($.ipad) return;
  var hoverEventNames = GetEventsName('hover_buttons');
  var c;
  var buttons;

  if (cont) {
    c = cont;
  }
  else {
    c = $('body');
  }
  buttons = c.find('button, input[type=button], input[type=submit], input[type=reset]');

  // навешиваем событие нажатия на пробел и энтер только в диалогах, иначе будет на всех кнопках
  if (cont) {
    buttons.keydown(function (ev) {
      if (ev.keyCode == 13 || ev.keyCode == 32) {
        ev.preventDefault();
        ev.stopPropagation();
        return false;
      }
    }).keyup(function (ev) {
      if (ev.keyCode == 13 || ev.keyCode == 32) {
        $(this).click();
      }
    });
  }
  buttons
    .unbind(hoverEventNames[0]).bind(hoverEventNames[0], function () { $(this).not('.disabled').addClass('hover'); })
    .unbind(hoverEventNames[1]).bind(hoverEventNames[1], function () { $(this).not('.disabled').removeClass('hover'); })
    .unbind('mousedown.click_buttons').bind('mousedown.click_buttons', function () { $(this).not('.disabled').addClass('active'); })
    .unbind('mouseleave.click_buttons').bind('mouseleave.click_buttons', function () { $(this).not('.disabled').removeClass('active'); });
}


/* =Клавиатурная навигация============================================================================================================================ */

function IsListExist(callbackIfExist) {
  if (/explorer\.aspx/i.test(location.pathname)) {
    var res = $('.List').length > 0;
  } else {
    var res = $('.List.selected,.List.hover').length > 0;
  }
  if (res) {
    if (callbackIfExist) callbackIfExist();
    return false;
  } else {
    return true;
  }
}

function SelectAll() {
  return IsListExist(function () {
    var chk = $('#chkAll');
    if (WA.ENV.browser.name.toLowerCase() === 'ie') {
      chk.attr('checked', !chk.is(':checked')).click().attr('checked', !chk.is(':checked'));
    } else {
      chk.attr('checked', !chk.is(':checked')).change();
    }
  });
}

function InitKeyNavigation() {
  if ($.ipad) return;
  // Получает элемент со скролингом.
  function GetScroller() {
    var maincont = $('.dataTables_scrollBody').first();
    if (maincont.length == 0) {
      maincont = $('#main_container');
    }
    return maincont;
  }

  function ArrowKeyNavigation(IsDownPressed, IsPageUpDown) {
    isKeyNavigationActive = true;

    var maincont = GetScroller();
    var maincont_h = maincont.height();

    var hovered = $('.List.hover');
    var next = null;
    if (hovered.length == 0) {
      hovered = null;
      if (IsPageUpDown) {
        if (!IsListExist()) {
          next = $('.List:first');
        }
      }
      else next = $('.List:first');
    } else {
      if (IsDownPressed) {
        if (!IsPageUpDown) {
          //down
          next = hovered;
          do {
            next = next.next();
            if (next.length > 0 && next.hasClass('SubBounds') && next.is(':visible')) {
              var newNext = next.find('.List:first');
              if (newNext.length > 0) next = newNext;
            }
          } while (next.length > 0 && !next.hasClass('List'));

          // Выделение с шифтом.
          if (key.shift) {
            CheckHovered(hovered);
          }
        } else {
          //pagedown
          next = hovered;
          var oldnext;
          do {
            oldnext = next;
            // Выделение с шифтом.
            if (key.shift) {
              CheckHovered(oldnext);
            }
            next = next.next(".List");
          } while (next.length > 0 && next.position().top < maincont_h && (next.position().top + next.height()) < maincont_h);
          // Если дошли до конца, то выделяем последний.
          if (next.length == 0) {
            next = oldnext;
          }
        }
      } else {
        if (!IsPageUpDown) {
          //up
          next = hovered;
          do {
            next = next.prev();
            if (next.length == 0 && hovered.parents('.SubBounds:first').length > 0) {
              var newNext = hovered.parents('.SubBounds:first').prev();
              if (newNext.length > 0) next = newNext;
            }
          } while (next.length > 0 && !next.hasClass('List'));
          // Выделение с шифтом.
          if (key.shift) {
            CheckHovered(hovered);
          }
        } else {
          //pageup
          next = hovered;
          var oldnext;
          do {
            oldnext = next;
            // Выделение с шифтом.
            if (key.shift) {
              CheckHovered(oldnext);
            }
            next = next.prev(".List");
          } while (next.length > 0 && next.position().top > 0);
          // Если дошли до конца, то выделяем последний.
          if (next.length == 0) {
            next = oldnext;
          }
        }
      }
    }
    if (next && next.length > 0) {
      if (hovered && hovered.length > 0) hovered.trigger('mouseout', [true]).trigger('mouseleave', [true]);
      next.addClass('hover').trigger('mouseover', [true]).trigger('mouseenter', [true]);

      //Скрываем контекстное меню.
      ContextMenu.hide();

      // Прокрутка до следующего элемента.
      var next_top = Math.ceil(next.position().top);
      var next_h = next.height() || null;

      // При движении вверх.
      if (next_top <= 0) {
        maincont.scrollTop(maincont.scrollTop() + next_top + (IsPageUpDown ? (next_h - maincont_h) : 0));
      }
      // При движении вниз.
      if (next_top > maincont_h || (next_top + next_h) > maincont_h) {
        maincont.scrollTop(maincont.scrollTop() + next_top + (IsPageUpDown ? 0 : (next_h - maincont_h)));
      }

      //console.debug([next_top, next_h, maincont_h, maincont.scrollTop()]);
    }
    else if (next.length == 0 && IsDownPressed) maincont.scrollTop(maincont.scrollTop() + 100);
  }

  function CheckHovered(toCheck) {
    const jHovered = (!!toCheck) ? toCheck : $('.List.hover');
    window.ToggleFolderItem(jHovered);
  }

  function OpenBounds() {
    isKeyNavigationActive = true;
    var hovered = $('.List.hover');
    var b = hovered.find('div[col="BOUND_PLUS"]');
    if (b && b.length > 0) {
      b.click();
    }
  }

  function PerformDefaultAction() {
    var hovered = $('.List.hover');
    if (hovered.length > 0) {
      if ($('div.ui-dialog').filter(':visible').length == 0) {
        var nameCont = hovered.find('div[col="NAME"]');
        if (nameCont.length > 0) {
          nameCont.click();
        } else {
          // для списка версий
          var defaultAction = hovered.children('td:last').find('a.default');
          if (defaultAction.length == 0) {
            // для справочников.
            defaultAction = hovered.children('td:last').find('a');
          }
          defaultAction.click();
        }
      }
    }
  }

  function KeyboardActionWithLink(toolBarBtnSelector, miniToolbarBtnSelector, needCheckIsListExist) {
    const selection = window.getSelection();
    if (selection.toString()) {
      return selection;
    }

    const f = () => {
      // Если мы находимся в справочнике, то ссылки удалять нельзя, поэтому меняем действие на удаление записи.
      if (toolBarBtnSelector === 'DeleteLinks' && typeof grid !== 'undefined') {
        toolBarBtnSelector = 'RefRecDelete';
      }

      let functionText;
      let toolBtn;
      // Ищем сначала в большом тулбаре (риббоне) кнопку.
      if (WA.ToolBarInit.state() === 'resolved') {
        toolBtn = WA.CR.toolBar.buttons[toolBarBtnSelector];
      }
      // Если не нашли, ищем в маленьком тулбаре (для вложений и ListRequisite).
      if (toolBtn) {
        functionText = toolBtn._jObject.attr('onclick');
      } else {
        toolBtn = $(miniToolbarBtnSelector)[0];
        if (toolBtn) {
          functionText = toolBtn.getAttribute('onclick');
        }
      }
      // Если нашли, то вызываем ее вычисления.
      if (!!toolBtn) {
        // Выполняем вычисления напрямую, не вызывая события click, чтобы не дожидаться доступности кнопки, 
        // т.к. в FF и Safari копирование в буфер можно вызывать только внутри короткоживущего обработчика события, сгенерированного пользователем.                 
        Function(functionText).apply(toolBtn);
      }
    };

    if (needCheckIsListExist === undefined || needCheckIsListExist) {
      return IsListExist(f);
    } else {
      return f();
    }
  }

  function OpenCard() {
    // window.open все равно заблокирует.
    var hovered = $('.List.hover');
    if (hovered.length > 0) {
      var openCardLnk = hovered.find('a[data-name="ShowCard"]');
      if (openCardLnk.length > 0) {
        // Выполняем действие "Открыть карточку".
        var t = openCardLnk.attr('target');
        if (!t || t == '') t = '_self';
        window.open(openCardLnk.attr('href'), t);
      } else {
        //Если действий нет, то открываем карточку явно.
        var Kind = hovered.attr('kind');
        // Открываем карточку.
        ShowObjectCard({ id: +hovered.attr('id'), kind: Kind }, 'view=Card');
      }
    }
  }

  function SaveCard() {
    var btn = $('div[name="Save"]');
    if (btn.length > 0) {
      btn.click();
    }
  }

  var shortcutBind = function (actionname, shortcut, scope, handler) {
    key(shortcut, scope, function () {
      if (!WA.CR.statistics.isDisabled()) {
        var hovered = $('.List.hover, .List.selected');
        //var actionPostfix = (hovered.length == 0 ? '' : (hovered.length == 1 ? ' (one)' : ' (multiple)'));
        if (Core.isStatisticEnabled) {
          WA.CR.statistics.write({
            page: WA.getLocation(),
            action: actionname, // + actionPostfix,
            area: 'KeyboardShortcut',
            target: (hovered.length > 0 ? hovered.get(0) : null)
          });
        };
      }
      return handler();
    });
  };

  var scope = 'common';
  shortcutBind('Navigation', 'down, shift+down', scope, function () { ArrowKeyNavigation(true, false); return false; });
  shortcutBind('Navigation', 'up, shift+up', scope, function () { ArrowKeyNavigation(false, false); return false; });
  shortcutBind('Navigation', 'pagedown, shift+pagedown', scope, function () { ArrowKeyNavigation(true, true); return false; });
  shortcutBind('Navigation', 'pageup, shift+pageup', scope, function () { ArrowKeyNavigation(false, true); return false; });
  shortcutBind('SelectItem', 'space', scope, function () { CheckHovered(); return false; });
  shortcutBind('OpenBounds', 'right, left', scope, function () { OpenBounds(); return false; });
  shortcutBind('Open', 'enter', scope, function () { PerformDefaultAction(); return false; });
  shortcutBind('SelectAll', 'ctrl+a', scope, function () { WA.current.objectList.selectAll(); return false; });

  if (WA.ENV.os.name.toLowerCase() === 'mac os') {
    shortcutBind('CopyLinks', 'command+c', scope, function () { return KeyboardActionWithLink('CopyLinks', '.copy_btn'); });
    shortcutBind('PasteLinks', 'command+v', scope, function () { return KeyboardActionWithLink('PasteLinks', '.paste_btn', false); });
    shortcutBind('CutLinks', 'command+x', scope, function () { return KeyboardActionWithLink('CutLinks', '.cut_btn', false); });
  } else {
    shortcutBind('CopyLinks', 'ctrl+c', scope, function () { return KeyboardActionWithLink('CopyLinks', '.copy_btn'); });
    shortcutBind('PasteLinks', 'ctrl+v', scope, function () { return KeyboardActionWithLink('PasteLinks', '.paste_btn', false); });
    shortcutBind('CutLinks', 'ctrl+x', scope, function () { return KeyboardActionWithLink('CutLinks', '.cut_btn', false); });
  }

  shortcutBind('DeleteLinks', 'del', scope, function () {
    if (WA.getLocation() != 'referencerecords') DeleteLinks();
    else DeleteSelectedRecords();
  });
  shortcutBind('OpenCard', 'ctrl+enter', scope, function () { OpenCard(); return false; });
  shortcutBind('SaveCard', 'ctrl+s', scope, function () { SaveCard(); return false; }, true);

  // В keymaster модификаторы снимаются на keyup, поэтому если нажать на Alt+Tab модификатор остается, т.к. keyup возникает уже в другом окне. Пока не пофиксят будет так:
  shortcutBind('Navigation', 'alt+down, alt+shift+down', scope, function () { ArrowKeyNavigation(true, false); return false; });
  shortcutBind('Navigation', 'alt+up, alt+shift+up', scope, function () { ArrowKeyNavigation(false, false); return false; });
  shortcutBind('Navigation', 'alt+pagedown, alt+shift+pagedown', scope, function () { ArrowKeyNavigation(true, true); return false; });
  shortcutBind('Navigation', 'alt+pageup, alt+shift+pageup', scope, function () { ArrowKeyNavigation(false, true); return false; });
  shortcutBind('SelectItem', 'alt+space', scope, function () { CheckHovered(); return false; });
  shortcutBind('OpenBounds', 'alt+right, alt+left', scope, function () { OpenBounds(); return false; });
  shortcutBind('Open', 'alt+enter', scope, function () { PerformDefaultAction(); return false; });
  shortcutBind('SelectAll', 'alt+ctrl+a', scope, function () { return SelectAll(); });
  shortcutBind('CopyLinks', 'alt+ctrl+c', scope, function () { return KeyboardActionWithLink('CopyLinks', '.copy_btn'); });
  shortcutBind('PasteLinks', 'alt+ctrl+v', scope, function () { return KeyboardActionWithLink('PasteLinks', '.paste_btn', false); });
  shortcutBind('CutLinks', 'alt+ctrl+x', scope, function () { return KeyboardActionWithLink('CutLinks', '.cut_btn', false); });
  shortcutBind('DeleteLinks', 'alt+del', scope, function () { return KeyboardActionWithLink('DeleteLinks', '.delete_btn'); });
  shortcutBind('OpenCard', 'alt+ctrl+enter', scope, function () { OpenCard(); return false; });
  shortcutBind('SaveCard', 'alt+ctrl+s', scope, function () { SaveCard(); return false; });
  key.setScope(scope);
  // Снимаем запрет на выделение мышкой.
  $('body').bind('mousemove.keynavigation', function () { isKeyNavigationActive = false; });
}

/* =================================================================================================================================================== */
/* =================================================================================================================================================== */

function OpenInDesktopClient() {
  DoAction('Desktop=1&-view', false);
}

function CloseDocWindow(msg, edocId) {
  BaseCloseDocWindow(edocId);
  try {
    //Вызывает освобождение объекта явно, т.к. перезагрузка окна прерывает "анализатор открытости окна".
    if (WA.ENV.browser.name.toLowerCase() === 'opera') {
      FreeEDoc(edocId);
    }
    CloseWindow();
  } catch (ex) { }
  return false;
}

function CloseTaskWindow(msg, taskId) {
  CloseBaseTaskWindow(taskId);
  try {
    //Вызывает освобождение объекта явно, т.к. перезагрузка окна прерывает "анализатор открытости окна".
    if (WA.ENV.browser.name.toLowerCase() === 'opera') {
      FreeTask(taskId);
    }
    CloseWindow();
  } catch (ex) { }
  return false;
}
function CloseJobWindow(msg, jobId) {
  CloseBaseJobWindow(jobId);
  try {
    //Вызывает освобождение объекта явно, т.к. перезагрузка окна прерывает "анализатор открытости окна".
    if (WA.ENV.browser.name.toLowerCase() === 'opera') {
      FreeJob(jobId);
    }
    CloseWindow();
  } catch (ex) { }
  return false;
}
function CloseWizardWindow(confmsg, wizardKey) {
  ConfirmDialogNew(confmsg, function () {
    if (wizardKey != null)
      CloseBaseWizardWindow(wizardKey);
    try {
      if (WA.ENV.browser.name.toLowerCase() === 'opera') {
        FreeWizard(wizardKey);
      }
      window.close();
    } catch (e) {
      location.href = "/";
    }
  });

  return false;
}

/** @deprecated *******/
var showTopSpinnerTimer = null;
function ShowTopSpinnerMessageIfVeryLongQuery(callback) {
  if (showTopSpinnerTimer) clearTimeout(showTopSpinnerTimer);
  showTopSpinnerTimer = setTimeout(callback, 400);
}

function IsModalShown() {
  var dlg = $('.ui-dialog:visible');
  return dlg.length > 0;
}


/** @deprecated */
function ShowTopSpinner(msg, instant, inModal) {
  $.when(WA.FormControlsInit).done(function () {
    var spinner = WA.CR.spinner;
    if (inModal) {
      if (instant) {
        spinner.showInDialog();
      } else {
        spinner.showInDialog(2000);
      }
    } else {
      if (instant) {
        spinner.show();
      } else {
        spinner.showDelayed(2000);
      }
    }
    return spinner;
  });
};

/** @deprecated */
function ShowTopSpinnerResult(msg, delay, func, inModal) {
  ShowTopSpinnerMessageIfVeryLongQuery(function () {
    if (delay == null) delay = 2000;
    HideTopSpinner(msg, delay, func, inModal);
  });
};

/** @deprecated */
function HideTopSpinner(msg, delay, func, inModal) {
  $.when(WA.FormControlsInit).done(function () {
    WA.CR.spinner.hide(msg, delay, func);
  });
}

/* =================================================================================================================================================== */
/* =================================================================================================================================================== */

/* =Explorer.aspx===================================================================================================================================== */
function ShowAllRows() {
  DoAction('show=full', false);
}
function ShowAllRowsPostback() {
  DoAction('', true, ChangeParamInURL(window.location.href, "show", "full"));
}

// Возвращает имя страницы, которая отвечает за отображение объекта.
function GetPageNameByKind(kind) {
  switch (kind[0].toUpperCase()) {
    case "E": return "doc.asp";
    case "F": return "folder.asp";
    case "J": return "job.asp";
    case "T": return "task.asp";
    case "R": return "reference.asp";
  }
  return "";
}

function MakeHref(link) {
  var pagename;
  if (link.Type)
    pagename = GetPageNameByKind(link.Type);
  else
    pagename = GetPageNameByKind(link.Kind);
  return 'http://' + g_WebServerName + '/' + pagename + '?sys=' + g_SysCode + ((link.CompCode != '') ? '&compcode=' + utf8_decode(link.CompCode) : '') + "&id=" + link.ID + "\r\n";
}

//utf8 to 1251 converter (1 byte format, RU/EN support only + any other symbols) by drgluck
function utf8_decode(aa) {
  var bb = '', c = 0;
  for (var i = 0; i < aa.length; i++) {
    c = aa.charCodeAt(i);
    if (c > 127) {
      if (c > 1024) {
        if (c == 1025) {
          c = 1016;
        } else if (c == 1105) {
          c = 1032;
        }
        bb += '%' + (c - 848).toString(16);
      }
    } else {
      bb += '%' + c.toString(16);
    }
  }
  return bb;
}

function MakeHrefsFromLinks(links) {
  return $.map(links, MakeHref).join('');
}

function GetSelectedID(selected) {
  var links = [];
  var hrefs = [];

  if (typeof selected === "undefined") {
    selected = $(".List.selected").filter(':visible');
    if (selected.length == 0) {
      selected = $(".List.hover");
    }
  }

  selected.each(function () {
    var item = $(this);
    var id = item.data('recid') ? item.data('recid') : item.attr('id');
    var compcode = item.attr('compcode');
    var kind = item.attr('kind').toUpperCase();

    if (compcode == null) compcode = '';

    var link = { ID: id, Kind: kind, CompCode: compcode, Desc: item.find('div.objectname').text() };
    links.push(link);
    hrefs.push(MakeHref(link));
  });
  return { hrefs: hrefs.join(''), links: links }
}

function InitTree() {
  $('#Tree').find('li').each(function () {
    $(this).addClass("CorrectTreeLi");
  });
}

//============ тулбар ===============
/* Прокрутка дерева папок */
var scrollTimeout;
function incScroll(side) {
  var tr = $('#TreeFixedWidth');
  tr.scrollLeft(tr.scrollLeft() + (10 * side));
  scrollTimeout = setTimeout('incScroll(' + side + ')', 80);
}
function InitToolbar() {
  //Скрипт для тулбара.
  if ($.ipad) return;
  $('.ToolbarActionDiv').hover(function () { if (!$(this).hasClass("disabled")) { $(this).addClass('over'); } }, function () { $(this).removeClass('over'); });
}
//Установка выделенным элемент тулбара.
function SetElementToolBar(el, deselect) {
  if ($(el).hasClass('selected') || deselect) {
    $(el).removeClass('selected');
  } else {
    $(el).addClass('selected');
  }
}
function ClearSelectedElements(el) {
  $(el).parent().find('div').each(function () { SetElementToolBar(this, true); });
}

/** @depecated */
function CreateTask(opt_withoutAttachments) {
  return Core.toolBars.main.createTask(opt_withoutAttachments);
}

/** @depecated */
function CreateFolder() {
  return Core.toolBars.main.createFolder();
}

function CreateTaskTM() {
  var folder_id = GetParamInURL("id");
  if (folder_id == "") folder_id = OutboxFolderID;
  window.open("Task.aspx?mode=NewSR&folder=" + folder_id, "CreateTaskTM");
}

function CreateFromTemplate(folder_id) {
  var folder_id = GetParamInURL("id");
  if (folder_id == "") folder_id = FavoritesFolderID;
  CreateNewDocument("template", folder_id);
  //window.open("doc.aspx?op=createtempl&folder=" + folder_id);
}
function CreateFromFile(folder_id) {
  var folder_id = GetParamInURL("id");
  if (folder_id == "") folder_id = FavoritesFolderID;
  CreateNewDocument("file", folder_id);
  //window.open("doc.aspx?op=createfile&folder=" + folder_id);
}

function CreateFromTemplateOrFile(folder_id) {
  var folder_id = GetParamInURL("id");
  if (folder_id == "") folder_id = FavoritesFolderID;
  CreateNewDocument("create", folder_id);
}


/////////////////////////////////////////////////////////
function BindToRecord(RecordID, RefName, callback) {
  WA.agent.isPluginAvailable("clipboard").always(function (isAvailableResponse) {
    if (isAvailableResponse) {
      Core.clipboard.getLinksFromClipboard().done(function (links) {
        if (links.length > 0 && typeof links != 'string') {
          WA.SRV.call('/Session.asmx/BindLinksToRefRecord', { Record: { ID: RecordID, Kind: 'REF', CompCode: RefName }, Links: links })
            .success(function (res) {

              if (res == 0) HideTopSpinner(L('NOT_LINKS_TO_BIND'), 2000);

              if (typeof callback != 'undefined') {
                callback();
              }
              else if (res > 0) {
                $('form:first').submit();
              }
            });
        }
        else if (links.length == 0) {
          HideTopSpinner(L('NOT_LINKS_TO_BIND'), 2000);
        }
      }).fail(function (error) {
        ShowError(error);
      });
    } else {
      // Агента или плагина нет.
      if (g_ViewOnlyMsg != '') {
        ShowTopSpinnerResult(g_ViewOnlyMsg, 2000);
      } else {
        if (typeof callback == 'undefined')
          ShowTopSpinner(L("BIND_LINKS"));
        //if (RecordID == null) RecordID = GetParamInURL("id");
        $.ajax({
          type: "post",
          dataType: "json",
          contentType: "application/json; charset=utf-8",
          url: "/Session.asmx/BindToRecord",
          data: "{'RecordID': " + RecordID + ", 'ReferenceName': '" + RefName + "'}",
          cache: false,
          success: function (res) {
            if (!CheckForLoginPage(res)) {
              if (res.d.Result != 0) {
                if (typeof callback != 'undefined')
                  callback();
                else
                  $('form:first').submit();
              } else {
                if (typeof callback == 'undefined')
                  HideTopSpinner(L("NOT_LINKS_TO_BIND"), 2000);
              };
            }
          }
        });
      }
    }
  });
}

function UnBindFromRecord(RecordID, RefName, callback) {
  var submit = (typeof needSubmit == 'undefined' ? "" : needSubmit);
  var sourceFol = (typeof SourceID == 'undefined' ? "" : SourceID);

  if (g_ViewOnlyMsg != '') {
    ShowTopSpinnerResult(g_ViewOnlyMsg, 2000);
  } else {
    var r;
    var chkAll = $('#chkAll');
    var DeleteAll = chkAll.length > 0 && chkAll.is(':checked') && !chkAll.hasClass('notallyet');
    if (!DeleteAll) {
      if (typeof Links == "undefined")
        r = GetSelectedID().links;
      else
        r = Links;
    } else {
      r = [{ 'ID': 0, 'Kind': 'ALL' }];
    }


    if (r.length > 0) {
      ConfirmDialogNew({
        text: L('CONFIRM_DELETE_LINKS', r.length),
        ok: function () {
          ShowTopSpinner(L("DELETE_LINKS"));
          CallService("/Session.asmx/UnBindFromRecord", { Links: r, RecordID: (RecordID), ReferenceName: RefName }, function (res) {
            if (res.Success) {
              res = res.Result;
              if (res != 0) {
                if ((typeof needSubmit == 'undefined') || (submit)) {
                  if (typeof callback != 'undefined')
                    callback();
                  else
                    $('form:first').submit();
                }
              }
              else {
                if (typeof needSubmit == 'undefined') HideTopSpinner(L("NO_RIGHT_DELETE_LINKS"), 2000);
              }
            } else {
              HideTopSpinner(res.Error, 2000);
            }
          });
        },
        cancel: null,
        width: 'auto'
      });
    } else {
      ShowTopSpinnerResult(L("OBJECTS_NOT_SELECTED"), 2000);
    }
  }
}

//=========================

//---- leftPanel toggle
function ShowFolder(el) {
  var tree = $('#Tree');
  $('.show-folder-link').hide();
  $('.explorer-header__logo').show();
  $('#Search').hide();
  $('.quick-search').removeClass('disabled');
  $('#RunList').hide();
  $('#NameFilter').hide();
  tree.show();
  $('#spinner').hide();

  ShowFolderTree(el);
  WA.CR.folderTree.selectNodeByPath(GetParamInURL('fpath'), true);

  $('#tree_container').redraw();
  $('#main_container').redraw();
}

function ShowReferences(el) {
  ClearSelectedElements(el);
  SetElementToolBar(el);

  $.ajax({
    type: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: "/Reference.asmx/GetAllReferences",
    data: "{}",
    success: function (res) {
      if (!CheckForLoginPage(res)) {
        if (res.d.Success) {
          var refs = res.d.Result;
          $("#Search").empty();
          template("ReferenceList", "#Search", { 'HeaderText': L("REFERENCES"), 'IconAlt': L("REFERENCE"), 'refs': refs }, {});
        }
      }
    }
  });

  $('#Tree').hide();
  $('div.SizeLeftRegion:first').css("overflow", "visible");
}

function FindParam(aoData, name) {
  for (var i = 0, count = aoData.length; i < count; i++) {
    if (aoData[i].name == name) return aoData[i].value;
  }
}

function ShowReferenceRecords(refCode, additional, el) {
  var defaultAction = function () {
    //ShowTopSpinner(L('PLEASE_WAIT'));
    var url = 'mode=RefRecords&compcode=' + refCode + '&-ID&-filter&-refview&-fpath&' + additional;
    if (el && $(el).data('ex')) {
      var ex = $(el).data('ex');
      url = PrepareUrl("/ReferenceRecords.aspx" + window.location.search, url);
      url = RemoveParamInURL(url, "caption");
      if (url.charAt(url.length - 1) == '&')
        url = url.substr(0, url.length - 1);
      if (ex.refview) {
        url += '&refview=' + encodeURIComponent(ex.refview);
      }
      if (ex.filter) {
        url += '&filter=' + encodeURIComponent(ex.filter);
      }
      if (ex.caption) {
        url += "&caption=" + ex.caption;
      }
      window.open(url);
    } else {
      DoAction(url);
    }
    return false;
  };

  var linkData = $(el).data('ex');
  if (!linkData) {
    defaultAction();
    return false;
  }

  var jsAction = linkData.jsAction;
  //Если кто-то прописал свой js-action в веб-модуле
  if (!!jsAction) {
    var action = new Function(jsAction);
    linkData.continueDefaultAction = defaultAction;
    if (action.call(linkData) === false) return false;
  }

  defaultAction();
  return false;
}

function CreateRefRecord(RefCode, parent) {
  Reference_CreateRecord(RefCode, parent);
}

function Reference_CreateRecord(RefCode, parent, fillreq, refview, afterCreateCallback, envVars, params) {
  var parentParam = '';

  if (parent != null) {
    if (WA.CR.form.isExist()) {
      var parentReq = WA.CR.form.getRequisiteByControlId(parent);
      if (parentReq === null) {
        for (var tableName in WA.CR.form.controls.tables) {
          parentReq = WA.CR.form.controls.tables[tableName].getRequisiteByControlId(parent);
        };
      };
      if (parentReq !== null) {
        parentParam = "&parent=" + parentReq.fullName;
      }
    } else {
      parentParam = "&parent=" + parent;
    }
  }
  if (typeof fillreq == 'undefined') {
    fillreq = null;
  }
  if (typeof params == 'undefined') {
    params = null;
  }

  let view = refview;
  // Это нужно только если ссылку формируют из списка записей справочника.
  if (!view && WA.getLocation() === 'referencerecords') {
    view = GetParamInURL('refview');
  }

  ShowTopSpinner(L('PLEASE_WAIT'), true);

  if (IsUseOurFirm(RefCode)) {

    var firms = GetAllOurFirms();
    if (firms.length > 1) {
      var form = CreateOurFirmSelectForm(firms);
      var dialog = new WA.components.dialogs.BaseDialog();
      dialog.title = L("OUR_FIRMS");
      dialog.html = form.render();
      dialog.isShowCancelButton = true;
      dialog.ok = function () {
        ShowTopSpinner(L('PLEASE_WAIT'), true);
        SetOurFirmID(form.getValue('FIRM_SELECT'));
        NewRecordService(RefCode, fillreq, view, parentParam, firms, afterCreateCallback, envVars, params);
      };
      dialog.show();
    } else {
      if (firms.length == 1) {
        SetOurFirmID(firms[0].ID);
      }
      NewRecordService(RefCode, fillreq, view, parentParam, firms, afterCreateCallback, envVars, params);
    }
  } else {
    NewRecordService(RefCode, fillreq, view, parentParam, null, afterCreateCallback, envVars, params);
  }
}

function CreateOurFirmSelectForm(firms) {
  let form = new WA.CMP.forms.FormBuilder('filter_save_modal');
  let pickRequisites = firms.reduce((map, firm) => {
    map[firm.ID] = firm.Name;
    return map;
  }, {});
  form.addPick('FIRM_SELECT', pickRequisites);
  return form;
}

function IsUseOurFirm(RefCode) {
  var useOurFirm = false;
  CallServiceSync("/Reference.asmx/IsUseOurFirm", { ReferenceCode: RefCode }, function (res) {
    useOurFirm = res;
  });
  return useOurFirm;
}

function GetAllOurFirms() {
  var firms = null;
  CallServiceSync("/OurFirm.asmx/GetOurFirmList", {}, function (res) {
    firms = res;
  });
  return firms;
}

function SetOurFirmID(FirmID) {
  CallServiceSync("/OurFirm.asmx/SetOurFirm", { OurFirmID: FirmID });
}

function NewRecordService(RefCode, fillreq, view, parentParam, firms, afterCreateCallback, envVars, params) {
  if (typeof envVars === 'undefined') {
    envVars = null;
  }

  if (typeof params === 'undefined') {
    params = null;
  }

  CallServiceSync("/Reference.asmx/NewRecordWithEnvironmentAndParams", { ReferenceCode: RefCode, RequisiteValuesJSON: fillreq, EnvironmentVarsJSON: envVars, ParamsJSON: params }, function (res) {
    if (res.Success) {
      if (firms != null && firms.length > 1) {
        CallServiceSync("/OurFirm.asmx/ClearOurFirm", {});
      }
      var RecID = res.Result;
      if (afterCreateCallback) afterCreateCallback(RecID);

      var customTitle = '';
      // Это нужно только если ссылку формируют из списка записей справочника.
      if (WA.getLocation() === 'referencerecords') {
        var currentCaption = $(".card-header__label").data('pluraltitle');
        if (currentCaption) {
          customTitle = "&title=" + encodeURI(currentCaption);
        }
      }

      window.open("/Reference.aspx?sys=" + g_SysCode + "&ext=" + g_ExtName + "&compcode=" + encodeURI(RefCode) + "&id=" + RecID + "&refview=" + view + customTitle + parentParam, 'Ref' + RecID);
    } else {
      // TODO Переделать, чтобы с сервера возвращался сразу MESSAGE_TYPE
      let severity;
      if (res.Severity !== '-1') severity = Number(res.Severity);
      WA.CR.inlineHint.show(res.Error, null, severity, INLINE_HINT_PRIORITY.PRIMARY);
    }
    HideTopSpinner();
  });
}

//-------------------------------

//=========== Обзор объекта ===============
function ShowAddRegion(obj, isDoc, reload) {
  var tr;
  if (!reload)
    tr = $(obj).parent().parent();
  else
    tr = $(obj);
  var trAdd;
  var tdAdd;
  var id = tr.attr('id');
  var kind = tr.attr('kind');
  var isAdded = tr.next().hasClass('AddRegion');
  if (!isAdded) {
    tr.after('<tr id="' + id + '" kind="' + kind + '" class="AddRegion">' +
      '<td class="StatusRgn"></td>' +
      ((tr.children().length > 3) ? '<td colspan=' + (tr.children().length - 3) + '></td>' : '') +
      '<td colspan="3"/></tr>');
    if (isDoc && tr.hasClass("t_even")) {
      var added = tr.next();
      added.addClass("t_even");
    }
  }
  trAdd = tr.next();
  if (trAdd.is(':hidden') || !isAdded || reload) {
    var helper = L("PLEASE_WAIT");
    trAdd.show();
    if (!isDoc) {
      trAdd.css('text-align', 'center');
      trAdd.css('vertical-align', 'middle');
    }

    tdAdd = $(trAdd.children()[2]);
    tdAdd.html('<img src="/images/spinner.gif" class="AjaxImg"><span class="AjaxTextHelper AddText">&nbsp;' + helper + '</span>');
    LoadAddRegion(tdAdd, id, kind, "SHOWVERLIST");
    if (!isDoc) {
      var img = $(obj).children().find('img');
      $(img).attr("src", "/App_Sprites/Circle_ArrowUp.png");
    }
    tr.addClass("RegionAdded");
  } else {
    if (!isDoc) {
      var img = $(obj).children().find('img');
      $(img).attr("src", "/App_Sprites/Circle_ArrowDown.png");
    }
    trAdd.hide();
    tr.removeClass("RegionAdded");
  }
  tr.attr('ShowAddRegion', '1');
}

function DocShowAddRegion(obj) {
  ShowAddRegion(obj, true);
}
function LoadAddRegion(obj, id, kind, view) {
  $.ajax({
    type: "GET",
    dataType: "html",
    url: "DynControl.ashx?c=addRegion&ID=" + id + "&kind=" + kind + "&view=" + view,
    cache: false,
    success: function (res) {
      if (!CheckForLoginPage(res)) {
        var el = obj.parent().prev();
        if (el.hasClass('unread')) {
          el.removeClass('unread');
          ChangeUnreadCountInTree(-1);
        }
        obj.html(res);
      }
    }
  });
}
function AddRegionTo(obj, view) {
  var td = $(obj).parents(".AddRegion_Table").parent();
  var tr = td.parent();
  LoadAddRegion(td, tr.attr('id'), tr.attr('kind'), view);
};
function MakeReadedWhenClick(el) {
  var tr = $(el).parents('.List:first');
  //Убираем признак только на клиенте, на сервере сам убирается
  if (tr.hasClass('unread')) {
    tr.removeClass('unread');
    // Задерживаем обновление значения в дереве, чтобы серверное значение успело обновиться.
    setTimeout(function () {
      ChangeUnreadCountInTree(-1);
    }, 700);
  }
}
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

/**
* Изменение счетчика непрочитанных элементов папки, в дереве папок.
* @function ChangeUnreadCountInTree
* @global
* @param {integer} d - вычитаемое или добавляемое число (напр. 1, -1, 2);
*/
function ChangeUnreadCountInTree(d) {
  // Обновить счетчик непрочитанных для текущей папки
  WA.CR.folderTree.updateUnreadJobCount(WA.CR.ID);
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

// Используется для открытия инструкций.
function wopenf(url, name, withoutmenu, width, height) {
  try {
    if (withoutmenu) {
      var left = (window.screen.availWidth - width) / 2;
      var top = (window.screen.availHeight - height) / 2;
      var oSize = 'left=' + left + 'px,top=' + top + 'px,width=' + width + 'px,height=' + height + 'px,';
      oWindow = window.open(url, name, oSize + "resizable=yes,toolbar=0,location=0,status=0,menubar=0,directories=0,scrollbars=yes");
    }
    else {
      oWindow = window.open(url, name, "resizable=yes,toolbar=1,location=1,status=1,menubar=1,directories=1,scrollbars=yes");
    }
    if (oWindow != null) { oWindow.focus(); }
    else { alert(g_ErrMes); }
  } catch (e) { alert(e.message); };
  return false;
}
/* =================================================================================================================================================== */
/* =================================================================================================================================================== */

/* =Doc.aspx========================================================================================================================================== */
// Тулбар
function UnlockEDoc() {
  DoAction('__POSTBACK_ACTION=UnlockEDoc', true);
}
function LockEDoc() {
  DoAction('__POSTBACK_ACTION=LockEDoc', true);
}
/* =================================================================================================================================================== */
/* =================================================================================================================================================== */

/* =Job.aspx========================================================================================================================================== */
function SaveInJob() {
  UnbindBeforeUnload();
  Core.jobs.SaveInBaseJob(false);
}

function SaveAndCloseJob() {
  UnbindBeforeUnload();
  Core.jobs.SaveInBaseJob(true);
}

function AcceptContolJob() {
  UnbindBeforeUnload();
  if ('undefined' != typeof (g_LeadJobID) && g_LeadJobID != 0) {
    if ($("#modal").length == 0)
      $("body").append('<div id="modal"></div>')

    var msg = g_ConfirmParam.Content;

    var $dialog = $("#modal")
      .html(msg)
      .dialog({
        resizable: false,
        modal: true,
        autoOpen: true,
        width: 510,
        title: L("CONFIRMATION"),
        buttons:
          [
            {
              text: L("PERFORM"), click: function () { BaseAcceptContolJob(1); $(this).dialog("close"); }
            },
            {
              text: L("NOT_PERFORM"), click: function () { BaseAcceptContolJob(2); $(this).dialog("close"); }
            },
            {
              text: L("OPEN"), click: function () { BaseAcceptContolJob(3); $(this).dialog("close"); }
            },
            {
              text: L("CANCEL"), click: function () { $(this).dialog("close"); }
            }
          ]
      });
    AdjustDialogIfIpad(500);
    InitHoverForButtons($dialog.next());
  } else {
    BaseAcceptContolJob(null);
  }
}

function Job_SetFocusToEditText() {
  var el = $('textarea.Job_Edit_Text_Area_Control');
  if (!$.ipad && el.length == 1) {
    el.focus();
  }
}

/* =================================================================================================================================================== */
/* =================================================================================================================================================== */

/* =Task.aspx========================================================================================================================================= */
/*function ChangeStandartRoute(el) {
BaseChangeStandartRoute(el, 'selected');
}*/
function CancelStandartRoute() {
  BaseCancelStandartRoute(function () {
    CloseWindow();
  });
}
function Task_SetFocusToEditText() {
  var el = $('textarea.Card_Task_EditText');
  if (!$.ipad && el.length == 1) {
    el.focus();
  }
}
/* =================================================================================================================================================== */
/* =================================================================================================================================================== */

/* =Reference.aspx========================================================================================================================================= */

function ReferenceCard_ShowTab(el, Num) {
  var tab = $('#RefCardTab' + Num);
  if (tab.length == 0) {
    DoAction('TabNum=' + Num, false);
  } else {
    $('.ViewPanel_Tr_card').removeClass('ViewPanel_Tr_Selected_card');
    $('.Reference_Tab').hide();

    $(el).addClass('ViewPanel_Tr_Selected_card');
    tab.show();
  }
}

function ReferenceCard_ShowDefaultTab(Num) {
  DoAction('TabNum=' + Num, false);
}

function Reference_IsDisabled(btn) {
  return $(btn).hasClass('disabled');
}

function Reference_GetPrefix() {
  return $('.ReferenceCard').data('prefix');
}

/**
 * Получить имя справочника.
 *
 * @global
 * @function Reference_GetName
 * @returns {string} Код справочника.
 */
function Reference_GetName() {
  // В тех случаях, когда грид представлен на одной из закладок справочника,
  // WA.CR.getReferenceCode() вернет код справочника, к которому относится
  // данная запись, а не код справочника, грид которого отрисован на вкладке.
  if (Core.grid.reference.hasOwnProperty('state')) {
    return Core.grid.reference.state.ReferenceName;
  } else {
    return WA.CR.getReferenceCode();
  }
}

function Reference_GetView() {
  return WA.CR.getReferenceView();
}

function Reference_GetRecordID() {
  return WA.CR.getID();
}

function Reference_Save(btn, SuccessCallback, isAutoSave) {
  function getNewRecordName() {
    var result = "";
    CallServiceSync("/Reference.asmx/GetRecords", {
      "ReferenceCode": WA.CR.getReferenceCode(),
      "FilterExpression": "[" + L("REQID") + "] = " + WA.CR.getID(),
      "FilterValue": "",
      "Requisites": [L("REQNAME")],
      "RecordsCount": 1,
      "StartFromRecord": 0,
      "SortIndex": 0,
      "SortDirection": 0
    }, function (res) {
      result = res.Result[0].Requisites[0].Value;
    });
    return result;
  }

  if (!Reference_IsDisabled(btn)) {

    if (isAutoSave) {
      WA.CR.form.save(function (ok) {
        if (ok && SuccessCallback) SuccessCallback();
      }, false);
    } else {
      ShowTopSpinner(L("REF_REC_SAVING"));
      $('html').trigger('CardFormSave');
      var parentId = decodeURI(decodeURI(GetParamInURL('parent')));


      var button = new WA.CMP.wrappers.toolBar.ToolBarButton(btn);
      button.disable();

      WA.CR.form.save(function (ok) {
        button.enable();

        HideTopSpinner();
        if (ok) {
          if (!!window.opener) {
            if (!!parentId) {
              var name = getNewRecordName();
              window.opener.document.setOpenersRequisite(parentId, WA.CR.getID(), name);
            } else {
              window.opener.NeedUpdateOnChildClose = true;
            }
          }

          if (SuccessCallback) {
            SuccessCallback();
          }
        }
      }, true);
    }
  }
}

var setOpenersRequisite = window.document.setOpenersRequisite = function (reqName, value, displayValue) {
  if (!reqName) return;

  if (WA.CR.form.isExist()) {

    var req = WA.CR.form.requisites[reqName];
    if (!req) req = WA.CR.form.getRequisiteByControlId(reqName);
    if (!req) {
      var tables = WA.CR.form.controls.tables;
      for (name in tables) {
        if (!$.isFunction(tables[name]) && tables[name].className) {
          req = tables[name].getRequisiteByControlId(reqName);
          if (req) break;
        };
      };
    }

    if (req) {
      req.setValue(value, displayValue);
    };

  } else {
    $("#" + reqName).SetValue(['' + value, '' + displayValue, '' + displayValue, {}])
    ProcessEmptyChecks();
  }
};

function Reference_SaveAndClose(btn, successCallback) {
  Reference_Save(btn, function () {
    if (successCallback) successCallback();

    setTimeout(function () {
      var parentId = decodeURI(decodeURI(GetParamInURL('parent')));
      if (window.opener && (parentId == null || parentId === '')) {
        try {
          WA.CR.window.updateParentExplorerContent();
          WA.CR.window.unbind('beforeClose');
          window.close();
        } catch (e) {
          console.error($.toJSON(e));
        }
      } else {
        WA.CR.window.close();
      }
    }, 100);
  });
}

function Reference_ForceUpdateRequisitesFromDatabase(callback) {
  CallServiceSync("/Reference.asmx/ForceUpdateRequisitesFromDatabase", { RefCode: $("#RefCode").val(), RecID: GetParamInURL("id") }, function (res) {
    if (res.Success) {
      if (callback) callback();
    }
  });
}

function Reference_ContextMenu_Card_OnCreate(item, menu) {
  var el = menu.lastElement;
  var RefCode = el.data('refcode');
  var RecID = el.data('recid');
  item.href = "/Reference.aspx?sys=" + g_SysCode + "&ext=" + g_ExtName + "&compcode=" + RefCode + "&id=" + RecID;
  item.target = "Ref" + RefCode + RecID;
}

function Reference_ContextMenu_Copy_OnCreate(item, menu) {
  var el = menu.lastElement;
  var RefCode = el.data('refcode');
  var RecID = el.data('recid');
  item.onClick = function () {
    Reference_CopyRecord(RefCode, RecID);
  }
}


function Reference_ContextMenu_Delete_OnCreate(item, menu) {
  var el = menu.lastElement;
  var RefCode = el.data('refcode');
  var RecID = el.data('recid');

  item.onClick = function () {
    Reference_ContextMenu_Delete(RefCode, RecID);
  }
}

/**
* Удаление записи справочника из грида или вложений ЗЗУ.
*/
function Reference_ContextMenu_Delete(referenceCode, recordId) {
  referenceCode = referenceCode || WA.CR.getReferenceCode();

  ConfirmDialogNew({
    text: L('CONFIRM_RECORD_DELETE'),
    okText: L('YES'),
    cancelText: L('NO'),
    ok: function () {
      WA.SRV.reference.deleteRecord(referenceCode, recordId).success(() => {
        switch (WA.getLocation()) {
          case 'job':
            WA.CR.openReactTab(TAB_TYPE.JOB_CARD, true);
            break;
          case 'task':
            WA.CR.openReactTab(TAB_TYPE.TASK_CARD, true);
            break;
          case 'explorer':
            WA.CR.objectList.reload();
            break;
          default:
            Core.grid.reference.reloadData()
            setTimeout(() => {
              WA.CR.objectList.fire('itemUnSelect', {});
            }, 500);
            break;
        }
      });
    }
  });
}


/**
 * Удаление записи справочника.
 * В списке записей мы окно не закрываем. * Когда удаялем из карточки, то закрываем её.
 *
 * @global
 * @function Reference_DeleteRecord_ToolItemClick
 * @param {int} recordId идентификатор записи
 * @param {string} refCode код справочника
 */
function Reference_DeleteRecord_ToolItemClick(recordId, refCode) {

  ConfirmDialogNew({
    text: L("CONFIRM_RECORD_DELETE"),
    okText: L("YES"),
    cancelText: L("NO"),
    ok: function () {
      var referenceCode = refCode || WA.current.getReferenceCode();
      WA.SRV.reference.deleteRecord(referenceCode, recordId).success(function () {
        //Закрытие текущей страницы происходит только если мы находимся в карточке и удаляем текущую запись.
        //при удалении на странице со списком записи справочника и на вкладке карточки с компонентой справочника закрытие страницы не требуется
        if (WA.getLocation() === "referencerecords") {
          Core.grid.reference.reloadData();
          Core.grid.reference.grid.getSelectedRows([]);
        } else {
          if (window.opener && window.opener.Core.grid.reference.grid) {
            window.opener.Core.grid.reference.reloadData();
            window.opener.Core.grid.reference.grid.getSelectedRows([]);
          } else {
            UnbindBeforeUnload();
            WA.CR.window.updateParentExplorerContent().reloadParentGrid();
          }
          WA.CR.window.close();
        }
      });
    }
  });
}

/**
 * Удаляет выделенные записи справочника.
 */
function DeleteSelectedRecords() {
  var items = WA.CR.objectList.getSelectedItems();
  if (items.length > 0) {
    var confirmDialogMessage = (items.length === 1) ? L("CONFIRM_RECORD_DELETE") : L("CONFIRM_SELECTED_RECORDS_DELETE");
    ConfirmDialogNew({
      text: confirmDialogMessage,
      okText: L("YES"),
      cancelText: L("NO"),
      ok: function () {
        var deferreds = [];
        items.forEach(function (item) {
          deferreds.push(WA.SRV.reference.deleteRecord(item.referenceCode, item.id));
        });

        //когда все записи удалятся, обновляем грид
        $.when.apply($, deferreds).always(function () {
          Core.grid.reference.reloadData();
          Core.grid.reference.grid.getSelectedRows([]);
        });
      }
    });
  }
  else {
    HideTopSpinner(L("OBJECTS_NOT_SELECTED"), 2000);
  }
}

function Reference_CopyRecord(RefCode, RecID, callback) {
  ShowTopSpinner(L("REF_REC_COPYING"));
  CallServiceSync("/Reference.asmx/CopyRecord", { ReferenceCode: RefCode, SourceRecordID: RecID }, function (res) {
    if (res.Success) {
      if (res.Warning) {
        WA.CR.inlineHint.showWarning(res.Warning, null, INLINE_HINT_PRIORITY.PRIMARY);
      }
      HideTopSpinner(L("REF_REC_COPYING_COMPLETE"), 2000);
      var view = GetParamInURL("refview");
      // Открываем новую запись.
      window.open("/Reference.aspx?sys=" + g_SysCode + "&ext=" + g_ExtName + "&compcode=" + encodeURI(RefCode) + "&id=" + res.Result + "&refview=" + view, 'Ref' + res.Result);
    } else {
      let severity;
      if (res.Severity !== '-1') severity = Number(res.Severity);
      WA.CR.inlineHint.show(res.Error, null, severity, INLINE_HINT_PRIORITY.PRIMARY);
      HideTopSpinner("", 0);
    }
  }, function () { HideTopSpinner("", 0); });
}

function Reference_CopyRecord_ToolItemClick(RecID) {
  Reference_CopyRecord(WA.CR.ReferenceCode, RecID);
}

function BaseCloseRecordCard(RefName, RecID) {
  window.onunload = function () { FreeRecord(RefName, RecID); }
}

function CloseRecordCardWindow(msg, RefName, RecID) {
  BaseCloseRecordCard(RefName, RecID);
  try {
    //UnbindBeforeUnload();
    //Вызывает освобождение объекта явно, т.к. перезагрузка окна прерывает "анализатор открытости окна".
    if (WA.ENV.browser.name.toLowerCase() === 'opera') {
      FreeRecord(RefName, RecID);
    }
    CloseWindow();
    //BindBeforeUnload();
  } catch (ex) { }
  return false;
}
function FreeRecord(RefName, RecID) {
  var R;
  var WSSParam = GetWSSParam(location.href, true);
  $.ajax({
    type: "POST",
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    url: "/Reference.asmx/FreeRecord" + WSSParam,
    data: "{'ReferenceCode':'" + RefName + "','RecordID':'" + RecID + "'}",
    async: false,
    success: function (res) {
      R = res.d;
    }
  });
  CheckForLoginPage(R);
  return R;
}

/* =================================================================================================================================================== */
/* =================================================================================================================================================== */


/* =Folder.aspx=======================================================================================================================================*/
function CloseFolderCardWindow(msg, folderId) {
  BaseCloseFolderCardWindow(folderId);
  try {
    //UnbindBeforeUnload();
    //Вызывает освобождение объекта явно, т.к. перезагрузка окна прерывает "анализатор открытости окна".
    if (WA.ENV.browser.name.toLowerCase() === 'opera') {
      FreeFolder(folderId);
    }
    CloseWindow();
    //BindBeforeUnload();
  }
  catch (ex) { }
  return false;
}
/* =================================================================================================================================================== */
/* =================================================================================================================================================== */

function SideItem_Click() {
  $(document).on("click", "#sidebar_container .sidebar_item", function () {
    $('.toolbar_group').find('.hover').removeClass('hover');
  });
}

function Ext_Click(el, ext, notInExplorer) {
  notInExplorer = notInExplorer || false;
  var RemoveParamsStr = "";
  // При смене расширения с результатами поиска, переходит на папки в которой были раньше.
  if (GetParamInURL("mode").toLowerCase() === 'search') {
    RemoveParamsStr = "-mode&-searchname&-sort&";
  }
  if (!$(el).hasClass('selected') || notInExplorer) DoAction(RemoveParamsStr + 'ext=' + ext);
}

function cancelBubble(event) {
  event.cancelBubble = true; if (event.stopPropagation) event.stopPropagation();
}


/**
* Место где происходит создание ссылки для объектов проводника
* @important
*/
function MakeActionListItemHyperlink(item, obj) {
  var hyperlink = '';
  if (typeof item.hyperlink != 'undefined') {
    hyperlink = item.hyperlink + (item.hyperlink.indexOf('?') == -1 ? '?' : '&');
    hyperlink += 'sys=' + g_SysCode;
    // Для записи справочника добавлем код справочника.
    if (obj.kind == 'ref') hyperlink += '&compcode=' + obj.refcode;
    if (obj.kind == 'fol') hyperlink += '&fpath=' + obj.id + '-' + GetParamInURL('fpath');
    if ((obj.kind == 'job' || obj.kind == 'task') && !GetParamInURL("mode")) { hyperlink += '&opener=' + WA.CR.getID(); }
    hyperlink += '&id=' + obj.id;
    hyperlink += '&ext=' + g_ExtName;
  }
  return hyperlink;
}

function DoFirstAction(nameLink, objType) {

  var sett = listActionsSettings[objType];
  if (sett && sett.items.length > 0) {
    if (objType == 'EDocument') return DoDefaultAction(nameLink, objType);
    var number = 0;
    var item;
    while (sett.items[number].hasOwnProperty('needshow')) {
      if ((new Function("return " + sett.items[number]['needshow'] + '();'))()) {
        item = sett.items[number];
        break;
      }
      else number++;
    }
    item = sett.items[number];
    StartAction(item, nameLink);
  };
  return false;
};

function DoDefaultAction(nameLink, objType) {
  var sett = listActionsSettings[objType];
  if (sett && sett.items.length > 0) {
    var defaultAction;
    for (var i = 0; i < sett.items.length; i++) {

      //Шамов А.: Как в настройках, если агент не доступен, то открываем предпросмотр.
      //Шамов А.: Решили пока это не делать, т.к. для пользователя будет не понятно почему вдруг открылся предпросмотр, если агент упал.
      //Barkova_YN: Делаем, так как отсутствие реакции при клике по названию документа непонятно для пользователя.
      var currentDefaultAction = g_defaultListAction;
      var needDisableAgentSetts = !WA.agent.isAvailable();
      if (needDisableAgentSetts && (currentDefaultAction != 'showcard')) {
        currentDefaultAction = 'preview';
      }

      if (sett.items[i].id.toLowerCase() == currentDefaultAction) {
        defaultAction = sett.items[i];
        break;
      }
    }

    StartAction(defaultAction, nameLink);
  }
  return false;
}

function StartAction(item, nameLink) {
  var proxy = GetObjectInfoFromRow($(nameLink).parents('.List:first'));
  // Выполняем гиперссылку, если нужно.
  if (typeof item.hyperlink != 'undefined') {
    var hyperlink = MakeActionListItemHyperlink(item, proxy);
    var mode = GetParamInURL('mode');
    var isSearch = WA.getLocation() == 'explorer' && (mode == 'search' || mode == 'placedin');
    window.open(hyperlink, (item.innewwindow == 'True' || isSearch || WA.getLocation() != 'explorer' ? (proxy.kind + proxy.id) : '_self'));
  }

  // Выполняем JS, если нужно.
  if (item.jsaction != 'undefined') {
    var f = new Function('CurrentActionHTMLElement', item.jsaction);
    f.call(proxy, $(nameLink));
  }
}
/* =================================================================================================================================================== */

/* = Текст ЗЗУ ======================================================================================================================================= */
function ExpandCollapseButtonMouseDown(Button) {
  SetExpandCollapseButtonImage(Button, 3);
}
function ExpandCollapseButtonMouseOver(Button) {
  SetExpandCollapseButtonImage(Button, 2);
}
function ExpandCollapseButtonMouseLeave(Button) {
  SetExpandCollapseButtonImage(Button, 1);
}
function SetExpandCollapseButtonImage(Button, DestImageType) {
  ArrowImages = new Array(2);
  ArrowImages[0] = ["Circle_ArrowUp", "Circle_ArrowUp.png", "Circle_ArrowUpOver.png", "Circle_ArrowUpClick.png"];
  ArrowImages[1] = ["Circle_ArrowDown", "Circle_ArrowDown.png", "Circle_ArrowDownOver.png", "Circle_ArrowDownClick.png"];
  var btn = $(Button);
  for (j = 0; j < ArrowImages.length; j++) {
    if (btn.length > 0 && btn[0].className.indexOf(ArrowImages[j][0]) != -1) {
      RemoveAllCircleArrowClasses(btn).addClass(ArrowImages[j][DestImageType]);
      break;
    }
  }
}
function RemoveAllCircleArrowClasses(btn) {
  return btn.removeClass(function (index, classes) {
    var reg = new RegExp("Circle_.+", "i");
    var matches = classes.match(reg);
    return (matches.join(' '));
  });
}
function ApplyStyle(el, StyleName) {
  el.className = StyleName;
}
function ChangeItemTextsVisible(Button) {
  var btn = $(Button);
  if (btn.length > 0) {
    if (btn[0].className.indexOf('Circle_ArrowDown') != -1) {
      RemoveAllCircleArrowClasses(btn).addClass("Circle_ArrowUp.png");
    } else {
      RemoveAllCircleArrowClasses(btn).addClass("Circle_ArrowDown.png");
    }
    var id = Button.id;
    var first = id.indexOf("_");
    $("div[id^='TextBlock" + id.substr(first, id.length - first) + "']").toggle();
  }
}
function ChangeItemExpandCollapse(Button) {
  var btn = $(Button);
  var sub_divs = btn.parents('div:first');
  var jSvgIcon = btn.find('use');

  if (jSvgIcon.length != 0 || btn.hasClass('att_minus.png') || btn.hasClass('att_plus.png')) {
    if (jSvgIcon.length == 0)
      btn.toggleClass('att_plus.png').toggleClass('att_minus.png');
    else {
      if (jSvgIcon.attr('xlink:href') === '#expand')
        jSvgIcon.attr('xlink:href', '#collapse');
      else
        jSvgIcon.attr('xlink:href', '#expand');
    }

    sub_divs.children('div').each(function () {
      var me = $(this);
      // Пишем свою toggle, т.к. стандартная $('..').toggle() не работает для вложенных элементов, если родительский скрыт.
      if (me.css('display') != 'none') {
        $(me).data('olddisplay', me.css('display')).css('display', 'none');
      } else {
        if (!$(me).data('olddisplay')) me.css('display', 'block');
        else me.css('display', $(me).data('olddisplay'));
      }
    });
  }
}

/* =================================================================================================================================================== */

/* Контекстное меню */

var ShowContextMenu = function (el, options, coords, isRightButton) {
  window.Core.contextmenu.show(el, options, coords, isRightButton);
};

// функции для работы с документами
var EDocument;

(function () {
  var lockUnlockRunning = false;
  var EDocumentClass;

  EDocument = function (src) {
    return new EDocumentClass(src);
  };

  EDocumentClass = function (src) {
    $.extend(this, src);
    var el_name = this.hasOwnProperty('tr') ? this.tr.find('[col="NAME"]') : "";
    //var el_name = this.tr.find('[col="NAME"]');
    if (el_name.length)
      this.name = el_name.html();
  };

  EDocumentClass.prototype = {
    CopyDoc: function () {
      var sourceID = this.id;

      function DoIt(decryptedKey) {
        var folder_id = GetParamInURL("id");
        if (folder_id == "") folder_id = FavoritesFolderID;

        //window.open("doc.aspx?op=copydoc&folder=" + folder_id + "&id=" + id);
        CreateNewDocument("copy", folder_id, sourceID, null, decryptedKey);
      }

      // Копирование зашифрованных документов не поддерживается.
      var encoding = this.tr.attr('encoding');
      if (encoding > 0) {
        ShowError(L("ERR_ENCRYPTED_DOCUMENT_COPY_UNSUPPORTED"), null, 400);
        return;
      }

      DoIt();
    },

    LockUnlock: function () {
      if (lockUnlockRunning)
        return false;
      else
        lockUnlockRunning = true;
      var me = this;
      var tr = this.hasOwnProperty('tr') ? this.tr : "";
      var id = this.id;
      var lock = this.hasOwnProperty('islocked') ? !(this.islocked == "1") : !(tr.attr('islocked') == "1");
      ShowTopSpinner(lock ? L("EDOC_LOCKING") : L("EDOC_UNLOCKING"));
      var result = true;

      $.ajax({
        type: "POST",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        url: lock ? "/Document.asmx/Lock" : "/Document.asmx/Unlock",
        data: "{DocumentID:" + id + ", UseGlobalLock:false}",
        async: false,
        cache: false,
        success: function (res) {
          res = res.d;
          if (CheckForLoginPage(res)) return;
          if (res.Success) {
            if (me.hasOwnProperty('tr'))
              tr.attr('islocked', lock ? "1" : "0");
            else
              $("#islocked").val(lock ? "1" : "0")
            HideTopSpinner("", 0);
            return true;
          }
          else {
            HideTopSpinner("", 0);
            WA.CR.inlineHint.showWarning(res.Error, null, INLINE_HINT_PRIORITY.PRIMARY);
            result = false
          }
          return false;
        }
      });

      return result;

    },

    LockUnlockOnCreate: function () {
      return { disabled: this.tr.attr('canlockunlock') != '1', text: this.GetLockUnlockText() }
    },

    GetLockUnlockText: function () {
      return this.tr.attr('islocked') == '1' ? 'MENU_UNLOCK' : 'MENU_LOCK';
    },

    EnsureVersions: function (callback) {
      function handle() {
        this.currentVersionNumber = this.tr.data('currentVersionNumber');
        if (!this.currentVersionNumber)
          this.SetCurrentVersionNumber(this.GetActualVersionNumber());
        callback.call(this);
      }

      this.versions = this.tr.data('versions');
      if (!this.versions) {
        this.tr.addClass('please_wait');
        this.GetVersions(function () {
          this.tr.removeClass('please_wait');
          this.tr.data('versions', this.versions);
          handle.call(this);
        });
      } else {
        handle.call(this);
      }
    },

    UpdateVersions: function (callback) {
      this.tr.data('versions', false);
      this.EnsureVersions(function () { if (callback) callback.call(this); });
    },

    GetContextMenu: function (menu, callback) {
      var me = this;

      //FIXME: убрал ветвление, т.к. содержимое контекстного меню не должно зависеть от состояния объекта, к тому же тут лишняя дорогая загрузка данных
      $.extend(menu.getItemById('EditReturn'), {
        text: "RETURN_EDOC_VERSION",
        icon: "/App_Sprites/ToolbarAndTab/ImportDocument_16.png",
        jsaction: "EDocument(this).ImportVersion()"
      });
      $.extend(menu.getItemById('EditReturn'), {
        text: "OPEN_FOR_EDIT",
        icon: "/App_Sprites/ToolbarAndTab/EditDocument_16.png",
        jsaction: "EDocument(this).OpenEdit()"
      });

      if (typeof FirstValidCertificate !== "undefined") {
        var i = $.inArray(menu.getItemById('LockUnlockVer'), menu.items);
        if (i != -1 && !menu.getItemById('Sign')) {
          menu.getItemById('LockUnlockVer').separator = false;
          menu.items.splice(i + 1, 0, {
            id: "Sign",
            text: "SIGN",
            icon: "/App_Sprites/Sign_16.png",
            onClick: function () {
              me.SignVersion();
            },
            separator: true
          });
        }
      }
      callback();

      //this.EnsureVersions(function () {
      //var ver = this.GetCurrentVersion();
      //if (ver) {
      //  if (ver.IsLocked) {
      //    $.extend(menu.getItemById('EditReturn'), {
      //      text: "RETURN_EDOC_VERSION",
      //      icon: "/App_Sprites/ToolbarAndTab/ImportDocument_16.png",
      //      jsaction: "EDocument(this).ImportVersion()"
      //    });
      //  } else {
      //    $.extend(menu.getItemById('EditReturn'), {
      //      text: "OPEN_FOR_EDIT",
      //      icon: "/App_Sprites/ToolbarAndTab/EditDocument_16.png",
      //      jsaction: "EDocument(this).OpenEdit()"
      //    });
      //  }
      //}
      //  if (typeof FirstValidCertificate !== "undefined") {
      //    var i = $.inArray(menu.getItemById('LockUnlockVer'), menu.items);
      //    if (i != -1 && !menu.getItemById('Sign')) {
      //      menu.getItemById('LockUnlockVer').separator = false;
      //      menu.items.splice(i + 1, 0, {
      //        id: "Sign",
      //        text: "SIGN",
      //        icon: "/App_Sprites/Sign_16.png",
      //        onClick: function () {
      //          me.SignVersion();
      //        },
      //        separator: true
      //      });
      //    }
      //  }
      //  callback();
      //});
    },

    //GetVersionsMenu: function (menu, callback) {
    //  var me = this;

    //  function getVerText(ver) {
    //    return '<div style="margin: 4px 0 4px -10px; white-space:nowrap">' +
    //      ver.Number + '. ' + ver.SignImage +
    //        '<span class="' + ver.cssClass + '">' + ver.Note + '</span>' +
    //        '<div style="position:relative">' +
    //            '<span class="action_panel_ver_list_size">' + ver.LockImage + ver.Size + ' ' + ver.SizeLabel + '</span>' +
    //        '</div>' +
    //        '<div class="AddText" style="margin-left: -10px; margin-top: 2px">' +
    //            L('MODIFIED') + ': <span class="AddText">' + formatDateTime(ver.TextModified) + '</span> ' +
    //            L('AUTHOR') + ': <span class="AddText">' + ver.Author + '</span></div>' +
    //        '</div>';
    //  }

    //  var vs = me.tr.find('.version_select');
    //  vs.addClass('hover');
    //  me.EnsureVersions(function () {
    //    var menuItems = $.map(me.versions, function (ver) {
    //      return {
    //        text: getVerText(ver),
    //        icon: /src\=\"(.*?)\"/.exec(ver.Ico)[1],
    //        onClick: function () {
    //          me.SetCurrentVersionNumber(ver.Number);
    //        }
    //      };
    //    });
    //    $.extend(menu, {
    //      items: menuItems,
    //      width: 450,
    //      shiftY: 20,
    //      shiftX: 0,
    //      onHide: function () { vs.removeClass('hover') }
    //    });
    //    if (callback) callback();
    //  });
    //},

    GetCurrentVersion: function () {
      return this.GetVersionByNumber(this.currentVersionNumber);
    },

    SetCurrentVersionNumber: function (num) {
      var me = this;
      me.currentVersionNumber = num;
      me.tr.data('currentVersionNumber', num);
    },

    GetVersionLockImage: function (ver) {
      var imgHTML = '<img style="margin-right:10px;" src="{0}" alt="{1}" title="{1}" />';
      if (ver.IsLocked)
        return format(imgHTML, "/App_Sprites/Doc/LockDocument_16.png", L("VERSION_LOCK"));
      else
        return "";
    },

    GetVersions: function (callback) {
      var id = this.id;
      var _this = this;
      CallService("/EDocument.asmx/GetVersionList", { EDocID: id, ShowAllVersions: true }, function (res) {
        if (res.Success) {
          _this.versions = res.Result.Versions;
          _this.versions.sort(function (x, y) { return y.Number - x.Number });
          if (callback) callback.call(_this);
        }
      });
    },

    GetActualVersionNumber: function () {
      var ver = this.versions.slice(); // копируем массив версий, чтоб не испортить.
      ver.sort(function (x, y) {
        if (x.LifeStage != y.LifeStage) {
          var priority = [1, 0, 2]; // сначала действующие, потом в разработке, потом устаревшие.
          return priority[x.LifeStage] - priority[y.LifeStage];
        } else {
          return y.Number - x.Number; // в обратном порядке по номеру
        }
      });
      if (ver.length > 0) return ver[0].Number;
      return -1;
    },

    GetVersionByNumber: function (num) {
      return $.grep(this.versions, function (ver) { return ver.Number == num; })[0];
    },

    /**
     * Открыть на чтение.
     *
     * @method OpenRead
     * @return {Deferred<boolean>} True - все прошло успешно, иначе False.
     * @see https://api.jquery.com/category/deferred-object/
     */
    OpenRead: function () {
      var me = this;
      var d = $.Deferred();
      // Если плагин доступен, то проверим локальные копии.
      WebAccess.agent.isPluginAvailable('DocumentPlugin').done((isAvailable) => {
        var localCopiesCount = 0;
        WA.agent.edms.checkDocumentHasLocalCopy(me.id).done(function (localCopies) {
          localCopiesCount = localCopies.length;
          if (localCopiesCount > 0) {
            GetEDocumentObject(me.id, function (docObj) {
              AskForActionOnDocument(docObj, localCopies, false);
            });
          }
        });
        // Отобазить предпросмотр.
        d.resolve(!isAvailable || localCopiesCount == 0);
      }).fail(function () {
        d.resolve(true);
      });

      d.done(function (isShowPreview) {
        if (isShowPreview) ExportEDoc(me.id, true, 0, true);
      });
    },

    OpenEdit: function () {
      OpenWithAgent(this, true);
    },

    ViewInEditor: function () {
      OpenWithAgent(this, false);
    },

    Export: function (needSendMail = false) {
      const docID = this.id;
      const encoding = parseInt(this.tr.attr('encoding'));
      const pluginName = this.tr.attr('encpluginname');
      const callback = function (decryptedKey) {
        ExportEDoc(docID, false, null, null, null, null, decryptedKey, needSendMail);
      };

      getDecryptedKey(docID, encoding, pluginName, callback);
      this.tr.data('versions', false);
    },

    Import: function () {
      var docID = this.id;
      var callback = function (decryptedKey) {
        ImportEDocNew(docID, 'import', null, null, null, decryptedKey);
      };
      var encoding = parseInt(this.tr.attr('encoding'));
      var pluginName = this.tr.attr('encpluginname');
      getDecryptedKey(docID, encoding, pluginName, callback);
    },

    ImportVersion: function () {
      ImportEDocNew(this.id, 'return_showversions');
    },

    LockUnlockVersion: function () {
      this.EnsureVersions(function () {
        var me = this;
        var ver = this.GetCurrentVersion();
        if (ver.ReturnDoc_CanClick) {
          function doAction() {
            ShowTopSpinner(ver.IsLocked ? L("EDOC_UNLOCKING") : L("EDOC_LOCKING"));
            CallService("/EDocument.asmx/VersionLockUnlock", { EDocID: me.id, VerNum: ver.Number },
              function (res) {
                if (res.Warning || res.Error)
                  HideTopSpinner(res.Warning || res.Error, 5000);
                else
                  HideTopSpinner();
                me.UpdateVersions();
              });
          }
          if (!ver.IsLocked)
            ConfirmDialogNew(L("EDOC_VER_CONFIRM_LOCK", ver.Number, me.name), doAction);
          else
            doAction();
        } else {
          ShowTopSpinnerResult(ver.ReturnDoc_CanClick_Reason, 5000);
        }
      });
    },

    SignVersion: function () {
      this.EnsureVersions(function () {
        var me = this;
        var ver = this.GetCurrentVersion();
        ConfirmDialogNew(L("EDOC_VER_CONFIRM_SIGN", ver.Number, me.name), function () {
          me._SignVersion(ver, FirstValidCertificate, function () { HideTopSpinner(); me.UpdateVersions(); });
        });
      });
    },

    _SignVersion: function (ver, cert, callback) {
      var _this = this;

      ShowTopSpinner(L("EDOC_SIGNING"));
      WrapToShowErrors(function () {
        var dc = GetCryptoObject();
        try {
          var certObj = dc.GetCertificateFromStorage(cert.plugin, cert.id);
        } catch (e) {
          if (e.message.indexOf('E_CERTIFICATE_NOT_FOUND_MESSAGE') != -1) {
            certObj = null;
          } else {
            throw e;
          }
        }
        if (certObj == null)
          throw L("PRIVATE_KEY_CERTIFICATE_HAS_NOT_BEEN_FOUND_IN_LOCAL_PERSONAL_STORAGE");
        CallService("/EDocument.asmx/GetVersionDataEx", { EDocID: _this.id, VersionNum: ver.Number, NeedLock: false }, WrapToShowErrors(function (res) {
          if (res.Success) {
            var data = res.Result;
            var signResult = dc.Sign(certObj, data);
            CallService("/EDocument.asmx/AddSignature", {
              EDocID: _this.id,
              VersionNum: ver.Number,
              SignStr: signResult,
              UserCertificateStr: cert.plugin,
              Comment: "",
              IsApprovingSign: false,
              IsSubstituted: false,
              SubstUser: ""
            }, WrapToShowErrors(function (res) {
              if (!res.Success) throw res.Error;
              else {
                HideTopSpinner();
                if (callback) callback();
              }
            }));
          } else {
            throw res.Error;
          }
        }));
      })();
    },

    CreateVersion: function () {
      var encoding = this.tr.attr('encoding');
      var docID = this.id;
      var pluginName = this.tr.attr('encpluginname');
      CreateVersionToolbar(docID, null, encoding, pluginName);
    }
  }
})();

// функции для работы с версиями документа.
var EDocumentVersion;

(function () {
  var EDocumentVersionClass;

  EDocumentVersion = function (src) {
    return new EDocumentVersionClass(src);
  };

  EDocumentVersionClass = function (src) {
    $.extend(this, src);
  };

  EDocumentVersionClass.prototype = {
    GetDocID: function () {
      return +this.id.split('_')[0];
    },

    GetCurrentVersion: function () {
      return this.tr.data('verinfo');
    },

    GetContextMenu: function (menu, callback) {
      var me = this;
      var ver = this.GetCurrentVersion();
      if (ver.IsLocked) {
        $.extend(menu.getItemById('EditReturn'), {
          text: "RETURN_EDOC_VERSION",
          icon: "/App_Sprites/ToolbarAndTab/ImportDocument_16.png",
          jsaction: "EDocumentVersion(this).ReturnVersion()"
        });
        $.extend(menu.getItemById('LockUnlockVer'), {
          text: "UNLOCK_EDOCUMENT_VERSION",
          icon: "documentUnblock-16"
        });
      } else {
        $.extend(menu.getItemById('EditReturn'), {
          text: "OPEN_FOR_EDIT",
          icon: "/App_Sprites/ToolbarAndTab/EditDocument_16.png",
          jsaction: "EDocumentVersion(this).OpenForEdit()"
        });
        $.extend(menu.getItemById('LockUnlockVer'), {
          text: "LOCK_EDOCUMENT_VERSION",
          icon: "documentBlock-16"
        });
      }
      callback();
    },

    OpenRead: function () {
      var ver = this.GetCurrentVersion();
      //Открываем закладку предпросмотра
      //location.href = format("Doc.aspx?sys={code}&ext={ext}&ID={doc_id}&view=Preview&VersionNum={ver_num}", { code: g_SysCode, ext: g_ExtName, doc_id: this.GetDocID(), ver_num: ver.Number });
      ExportEDocNow(this.GetDocID(), ver.Number, false, false);
    },

    ReturnVersion: function () {
      var ver = this.GetCurrentVersion();
      ImportEDocNew(this.GetDocID(), "return", ver.Number);
      //window.open(format("Doc.aspx?sys={code}&ext={ext}&ID={doc_id}&op=ImportDoc&ver={ver_num}&mode=WithUnlock&place=explorer", { code: g_SysCode, ext: g_ExtName, doc_id: this.GetDocID(), ver_num: ver.Number }));
    },

    OpenForEdit: function () {
      /*var me = this;
      var ver = this.GetCurrentVersion();
      location.href = format("Doc.aspx?sys={code}&ext={ext}&ID={doc_id}&view=ShowVerList&ver={ver_num}&mode=EDITLOCK", { code: g_SysCode, ext: g_ExtName, doc_id: this.GetDocID(), ver_num: ver.Number });*/
      var ver = this.GetCurrentVersion();
      var me = this;
      setTimeout(function () {
        me.UpdateVersions();
      }, 1000);
      ExportEDocNow(this.GetDocID(), ver.Number, true, false);
    },

    LockUnlockVersion: function () {
      var me = this;
      var ver = me.GetCurrentVersion();
      function doAction() {
        ShowTopSpinner(ver.IsLocked ? L("EDOC_UNLOCKING") : L("EDOC_LOCKING"));
        CallService("/EDocument.asmx/VersionLockUnlockNew", { EDocID: me.GetDocID(), VerNum: ver.Number },
          function (res) {
            if (!!res.Warning) {
              WA.CR.inlineHint.showWarning(res.Warning, null, INLINE_HINT_PRIORITY.PRIMARY);
            }
            else if (!!res.Error) {
              WA.CR.inlineHint.showError(res.Error, null, INLINE_HINT_PRIORITY.PRIMARY);
            } else {
              me.UpdateVersions();
            }
            HideTopSpinner('', 0);
          });
      }
      if (!ver.IsLocked) {
        ConfirmDialogNew(L("EDOC_VER_CONFIRM_LOCK_WITHOUT_NAME", ver.Number), doAction);
      } else {
        doAction();
      }
    },

    CreateNew: function () {
      var version = this.GetCurrentVersion();
      var encoding = WA.Document.Encoding;
      var pluginName = WA.Document.PluginName;
      CreateVersionToolbar(this.GetDocID(), version.Number, encoding, pluginName);
    },

    Export: function (needSendMail = false) {
      const ver = this.GetCurrentVersion();
      const docID = this.GetDocID();
      const encoding = WA.CR.Encoding;
      const pluginName = WA.CR.PluginName;
      const callback = function (decryptedKey) {
        ExportEDoc(docID, false, ver.Number, null, null, null, decryptedKey, needSendMail);
      };
      getDecryptedKey(docID, encoding, pluginName, callback);
    },

    Import: function () {
      //$('#__DOC_VER_SELECTED_' + this.GetDocID()).val(this.id);
      var ver = this.GetCurrentVersion();
      ImportEDocNew(this.GetDocID(), "import", ver.Number);
    },

    Sign: function () {
      SignEDoc(this.GetDocID(), this.GetCurrentVersion().Number);
    },

    Delete: function () {
      var me = this;
      if (WA.getLocation() == 'doc' && !WA.current.CanChange) {
        ShowError(L('DOCVER_NO_MODIFY_ACCESS'), null, 350);
        return;
      }
      var ver = me.GetCurrentVersion();

      if (ver.IsLocked === true) {
        ShowWarning(L('WRN_CANT_DELETE_DOC_VER_LOCKED', ver.Number, WA.Document.ClientName, ver.DBLock.LockedByUser, formatDateTime(new Date(ver.DBLock.LockTime))));
      } else {
        ConfirmDialogNew(format(L("CONFIRM_DELETE_VERSION"), { '0': ver.Number }), function () {
          ShowTopSpinner(L("DELETING_VERSION"));
          CallService("/EDocument.asmx/DeleteVersion", { EDocID: me.GetDocID(), VerNum: ver.Number }, function (res) {
            if (res.Success) {
              ShowTopSpinnerResult(L("VERSION_DELETE_COMPLETE"));
              me.UpdateVersions();
            } else {
              HideTopSpinner('', 0);
              let severity;
              if (res.Severity !== '-1') severity = Number(res.Severity);
              WA.CR.inlineHint.show(res.Error, null, severity, INLINE_HINT_PRIORITY.PRIMARY);
            }
          });
        });
      }

    },

    // Изменения состояния версии
    SetState: function (state) {
      var me = this;
      var ver = me.GetCurrentVersion();

      if (WA.Document.Lock.IsLocked && !WA.Document.Lock.IsLockedByMe) {
        let message = L(
          'WARN_DOCUMENT_LOCKED',
          WA.Document.Lock.LockedByUser,
          formatDateTime(new Date(WA.Document.Lock.LockTime))
        );
        WA.CR.inlineHint.showWarning(message, null, INLINE_HINT_PRIORITY.PRIMARY);
        return;
      }

      ShowTopSpinner();
      WA.services.document.version.setState(me.GetDocID(), ver.Number, state).done(function () {
        me.UpdateVersions();
        me.ChangeCountActualVersions(ver.Number, state);
        HideTopSpinner();
      }).fail(function () {
        HideTopSpinner();
      });
    },

    //Изменение количества действующих версий
    ChangeCountActualVersions: function (num, state) {
      if (state == 2) {
        WA.current.CountActiveVersions += 1;
        WA.current.Versions[num - 1].CurrentLifestage = state;
      } else {
        if (WA.current.Versions[num - 1].CurrentLifestage == 2) {
          WA.current.Versions[num - 1].CurrentLifestage = state;
          WA.current.CountActiveVersions -= 1;
        }
      }
    },

    // Изменения примечания
    ChangeNote: function () {
      var me = this;
      var ver = me.GetCurrentVersion();

      // Если нет прав на изменение, выходим с ошибкой.
      if (WA.Document.CanChange === false) {
        WA.CR.inlineHint.showError(L('DOCVER_NO_MODIFY_ACCESS'), null, INLINE_HINT_PRIORITY.PRIMARY);
        return;
      }

      // Если документ заблокирован, выходим с ошибкой.
      if (WA.Document.Lock.IsLocked && !WA.Document.Lock.IsLockedByMe) {
        let message = L('WARN_DOCUMENT_LOCKED', WA.Document.Lock.LockedByUser, formatDateTime(new Date(WA.Document.Lock.LockTime)));
        WA.CR.inlineHint.showError(message, null, INLINE_HINT_PRIORITY.PRIMARY);
        return;
      }

      var f = new WA.components.forms.FormBuilder('CHANGE_NOTE_FORM');
      f.setOrientation('vertical');
      f.addInput('NOTE');
      var d = new WA.components.dialogs.BaseDialog();
      d.title = L('CHANGE_NOTE');
      d.isShowOkButton = true;
      d.isShowCancelButton = true;
      d.ok = function () {
        ShowTopSpinner();
        WA.services.document.version.setNote(me.GetDocID(), ver.Number, f.getValue('NOTE')).done(function () {
          me.UpdateVersions();
          HideTopSpinner(L('MSG_CHANGE_NOTE_COMPLETE'), 2000);
        }).fail(function () {
          HideTopSpinner();
        });
      };
      d.bind('onOpen', function () {
        // Установим старое примечание в поле.
        f.setValue('NOTE', me.tr.find('.Version_Name').text());
      });
      d.setHtml(f.render());
      d.show();
    },

    UpdateVersions: function () {
      if (typeof ReloadVersionList != 'undefined') ReloadVersionList();
    },

    executeDefaultAction() {
      let eDocVersion = EDocumentVersion(GetObjectInfoFromRow(this));
      if (['showcard', 'preview'].includes(window.g_defaultListAction)) {
        eDocVersion.OpenRead();
      } else {
        SendVersionToAgent(eDocVersion, g_openDocForEditByDefault);
      }
    }
  }

})();


// функции для работы с заданиями
var Job;

(function () {
  var JobClass;

  Job = function (src) {
    return new JobClass(src);
  };

  JobClass = function (src) {
    $.extend(this, src);
  };

  JobClass.prototype = {
    MarkAsReadOnCreate: function () {
      return {
        text: this.tr.hasClass('unread') ? "MENU_MARK_AS_READ" : "MENU_MARK_AS_UNREAD",
        icon: this.tr.hasClass('unread') ? "markRead-16" : "markUnread-16"
      }
    },

    MarkAsRead: function (link) {
      var _this = this;
      var tr = _this.tr;
      if (typeof tr == "undefined")
        tr = $(link).parents('.List');
      if (typeof link == "undefined") {
        link = tr.find('a[data-name="MarkAsRead"]');
      }

      var unread = tr.hasClass('unread');
      ShowTopSpinner(L("PLEASE_WAIT"));
      CallService("/Job.asmx/MarkAsRead", { JobID: _this.id, IsRead: unread }, function (res) {
        if (res.Success) {
          if (unread) {
            tr.removeClass('unread');
            ChangeUnreadCountInTree(-1);
            if (link) $(link).text(L('MENU_MARK_AS_UNREAD'));
          } else {
            tr.addClass('unread');
            ChangeUnreadCountInTree(1);
            if (link) $(link).text(L('MENU_MARK_AS_READ'));
          }
          HideTopSpinner();
        } else {
          HideTopSpinner(L("ERROR_MSG", res.Error), 5000);
        }
      });
    },

    Sign: function () {

    }

  }

})();

/**
 * Получает описание объекта системы (id, kind, refcode) из атрибутов DOM-элемента списка объектов.
 *
 * @param {HTMLElement} tr DOM-элемент
 * @return {object} compcode-объект
 */
function GetObjectInfoFromRow(tr) {
  const jObject = $(tr);
  const refcode = jObject.attr('compcode') || '';
  return {
    id: jObject.data('recid') || jObject.attr('id'),
    kind: (jObject.attr('kind') || '').toLowerCase(),
    refcode,
    tr: jObject,
  };
}

function GetObjectCardUrl(obj, options) {
  var page = GetPageNameByKind(obj.kind);

  var customTitle = '';
  // Это нужно только если ссылку формируют из списка записей справочника.
  if (WA.getLocation() === 'referencerecords') {
    var currentCaption = $(".card-header__label").data('pluraltitle');
    if (currentCaption) {
      customTitle = "&title=" + encodeURI(currentCaption);
    }
  }

  var url = page + "x?sys=" + g_SysCode +
    "&ext=" + g_ExtName +
    "&id=" + obj.id +
    (obj.kind == "FOL" ? "&view=Card" : "") +
    (obj.refcode ? "&compcode=" + encodeURI(obj.refcode) +
      (obj.refview ? "&refview=" + encodeURI(obj.refview) : "") : "") +
    customTitle +
    (options ? "&" + options : "");
  return url;
}

// Открыть карточку объекта.
function ShowObjectCard(obj, options) {
  window.open(GetObjectCardUrl(obj, options), obj.kind + obj.id);
}

// Открывает содержимое папки в текущем окне.
function OpenFolder(obj) {
  var jItem = obj.tr;
  var newFolderPath;

  if (!obj.node && (!jItem || jItem.hasClass('List'))) {
    // В списке объектов.
    var fpathParam = GetParamInURL('fpath');
    var mode = GetParamInURL('mode');
    newFolderPath = obj.id + '-'
    if (fpathParam !== '' && mode !== 'placedin' && mode !== 'search') {
      newFolderPath += fpathParam;
    }
  } else {
    // В дереве папок.
    newFolderPath = obj.node.key;
  }

  // Если папка открывается в новом окне, то для корректного определения её доступности заполнять fpath не нужно
  var fpath = '';
  if (newFolderPath !== '')
    fpath = '&fpath=' + newFolderPath;

  var url = '/explorer.aspx?sys=' + g_SysCode + '&ext=' + g_ExtName + '&id=' + obj.id;

  if (WA.getLocation() === 'explorer' || WA.getLocation() === 'folder') {
    url += fpath;
    // Сначала пытаемся открыть по folder path из дерева, чтобы корректно изменить состояние дерева.
    if (!WA.CR.folderTree.selectNodeByPath || !WA.CR.folderTree.selectNodeByPath(newFolderPath, true)) {
      var folderTitle = jItem.find('.objectname').text();
      // Иначе сами генерируем событие перехода.
      var state = {
        type: 'explorer',
        folderID: obj.id,
        title: folderTitle,
        path: newFolderPath,
        hasCover: false,
        hasCoverOnly: false
      };

      WA.history.pushState(state, folderTitle, url);
    }
  } else {
    window.open(url, '_blank');
  }
}

/**
 * Отправить объект вложением в задачу.
 *
 * @function SendAsAttachment
 * @param {{id: number, kind: OBJECT_TYPE, refcode: string}} obj Модель отправляемого объекта.
 * @param {string} routecode ТМ, по которому следует отправить задачу.
 * @param {string} subject Тема задачи.
 */
function SendAsAttachment(obj, routecode, subject) {
  if (!$.isArray(obj)) {
    obj = [obj];
  }
  var attach = encodeURIComponent($.toJSON($.map(obj, function (o) { return o.refcode ? [[o.id, o.kind, o.refcode]] : [[o.id, o.kind]] })));
  var wnd = window.open("task.aspx?sys=" + g_SysCode + "&ext=" + g_ExtName + "&val=" + attach + "&mode=newattach&folder=" + GetParamInURL('id') + '&routecode=' + encodeURIComponent(routecode));
  if (subject) {

    var setSubject = function () {
      $('input#ctl00_MainContent_CardContrrolSubject', wnd.document).val(subject).trigger('change');
    };
    // Lysenko_YN: в опере и ие не работает событие онлоад , без setTimeout не устанавливается значение subject
    var browser = WA.ENV.browser.name.toLowerCase();
    if (browser === 'opera' || browser === 'ie') {
      $(wnd.document).ready(function () {
        setTimeout(setSubject, 1000);
      });
    }
    else {
      wnd.onload = setSubject;
    }
  }
}

// Находится в папках.
function ShowInsideFolders(obj) {
  var url = 'mode=placedin' + '&id=' + obj.id + '&objtype=' + obj.kind + (obj.refcode ? "&refcode=" + obj.refcode : "");
  if (/explorer\.aspx/i.test(location.pathname)) {
    DoAction(url, false);
  } else {
    window.open('explorer.aspx?' + url);
  }
}

// Вложено в задачи.
function ShowAttachedToTasks(obj) {
  var lowerKind = obj.kind.toLowerCase();
  if (lowerKind === 'edoc' || lowerKind === 'ref') {
    // Открываем в карточке.
    ShowObjectCard(obj, 'view=AttachedTasks');
  } else {
    //Открывается в проводнике.
    var url = 'mode=attachedtotask' + '&id=' + obj.id + '&objtype=' + obj.kind + (obj.refcode ? "&refcode=" + obj.refcode : "");
    if (/explorer\.aspx/i.test(location.pathname)) {
      DoAction(url, false);
    } else {
      window.open('explorer.aspx?' + url);
    }
  }
}

// Копировать ссылку.
function ObjCopyLink(obj) {
  CopyLinks(obj, false);
}

// Удалить ссылку.
function ObjDeleteLink(obj, CurrentActionHTMLElement, callback, msg) {
  var tr = obj.tr;
  if (typeof tr == "undefined")
    tr = $(CurrentActionHTMLElement).parents('.List');

  var lrList = tr.parents('.ListRequisite');
  if (lrList.length) // мы в списке объектов ListRequisite
  {
    var id = lrList.attr('id');
    // Shamov_AN: удалил, т.к. не работало удаление вложений из контекстного меню.
    //id = id.substr(0, id.length - 5);
    ListRequisite(id).DeleteLink(obj, callback, msg);
  } else {
    if (WA.getLocation() == "reference") {
      UnBindFromRecord('' + WA.current.getID(), WA.current.getReferenceCode());
    } else {
      if (WA.getLocation() == "reference") {
        UnBindFromRecord('' + WA.current.getID(), WA.current.getReferenceCode());
      } else {
        DeleteLinks('', [{ ID: obj.id, Kind: obj.kind, CompCode: obj.refcode || '' }]);
      }
    }
  }
}

// Возвращает ActiveX объект для подписания документов.
function GetCryptoObject() {
  if ($('#NpoComputerCrypto').length == 0) {
    $('body').append('<div style="display: none;"><object id="NpoComputerCrypto" codebase="Common/SBWebEncryption.cab#version=7,10,2,2210" classid="clsid:E738D6C9-557C-4419-9D2A-8423EB9C0FE6" ><span style="color: red">Ошибка при загрузке ActiveX!</span></object></div>');
  }
  return $('#NpoComputerCrypto')[0];
}

// Возвращает обертку для функции, которая ловит исключения и отображает их в top spinner.
function WrapToShowErrors(func) {
  return function () {
    try {
      return func.apply(this, arguments);
    } catch (ex) {
      HideTopSpinner(L("ERROR_MSG", typeof ex == "object" ? ex.message : ex.toString()), 5000);
    }
  }
}

// Периодически посылает запрос на поддержание кэша.
function CacheKeepAlive(cache_id, interval) {
  function update() {
    CallService("/Entity.asmx/CacheKeepAlive", { Key: cache_id }, function (res) {
      if (res.Success)
        setTimeout(update, interval);
    });
  }
  setTimeout(update, interval);
}

// Периодически посылает запрос на поддержание кэша.
function SearchCacheKeepAlive(SearchGUID, interval) {
  function update() {
    CallService("/Session.asmx/SearchCacheKeepAlive", { UniqueID: SearchGUID }, function (res) {
      if (res.Success) {
        setTimeout(update, interval);
      }
    });
  }
  setTimeout(update, interval);
}


// ==========================================================================================================
// ==========================================================================================================
/** @deprecated */
function OpenReference(refcode) {
  if (refcode == null) {
    refcode = $('#RefCode').val();
  }
  if (refcode != null && refcode != '') {
    window.open("/explorer.aspx?sys=" + g_SysCode + "&ext=" + g_ExtName + "&mode=RefRecords&compcode=" + encodeURI(refcode) + "&toolitem=Run", '_blank');
  }
}

/** @deprecated
Kychanov_SA: метод по прежнему используется! */
function ExitBtnClick(msg, callbackFunc) {
  var exit = function (message) {
    if ($("#ExitForm").length == 0)

      ConfirmDialogNew({ text: message, width: 400, height: 'auto' }, function () {
        WA.logout();
      });
  }

  if (WA.agent.isSessionInitialized()) {
    WA.agent.isPluginAvailable('DocumentPlugin').done((isAvailable) => {
      if (isAvailable) {
        WA.agent.transmitRequest('CheckCurrentDocuments', 'DocumentPlugin', {}).done((response) => {
          if (response.result) {
            msg = L('CONFIRM_EXIT_WHILE_OPEN_DOCUMENTS_EXISTS');
          }
        });
      }
    }).always(function () {
      exit(msg);
    });
  } else {
    exit(msg);
  }
}

/** @deprecated */
function logout() {
  $('html').append("<form id='ExitForm' method='post' action='explorer.aspx'><input id='SignOut' type='hidden' name='SignOut'/></form>");
  $.cookie('lang', null);

  Core.agent.getPlugin().done(function (plugin) {
    WebAccess.agent.transmitRequest('CheckCurrentDocuments', 'DocumentPlugin', {}).done((response) => {
      if (response.result) {
        $.cookie('WAUID', null);
        $.cookie('WEBACCESSSAUTH', null);
        CallService("UserLogin.asmx/Disconnect", {}, function () { window.location = "Login.aspx"; });
      }
    });
  }).fail(function () {
    //Сообщаем агенту о выходе
    WebAccess.agent.endSession();

    //Закрываем сессию
    $("#SignOut").val("SignOut");
    $('#ExitForm').submit();
  });
};

/* DEPRECATED */
function InitTheme(ThemeName) {
  return false;
}

(function (global) {
  var regionalSettings = {};

  var getSelectedLang = function (selectedLangSelector) {
    var newLang = $(selectedLangSelector).val();
    $.datepicker.setDefaults($.datepicker.regional[newLang]);
    $.timepicker.setDefaults($.datepicker.regional[newLang]);
    return newLang;
  };

  regionalSettings.setNewLang = function (selectedLangSelector) {
    var newLang = getSelectedLang(selectedLangSelector);

    $.when(WA.AgentInit).done(function () { WebAccess.agent.setLanguage(newLang.split("-")[0]); });

    if ($('#lang').length == 0) {
      $('form:first').append('<input id="lang" name="lang" type="hidden"/>');
    };
    DoAction("lang=" + newLang, true);
  };

  regionalSettings.cancelNewLang = function (selectedLangSelector) {
    var newLang = getSelectedLang(selectedLangSelector);
    $.cookie('lang', newLang);
  };

  // Public
  global.regionalSettings = regionalSettings;
})(window);

function ViewPreviewSettingsModal_DisableControls() {
  if ($("#chkOpenPreviewFromList").is(":checked") || $("#chkOpenCardFromList").is(":checked")) {
    //$("#chkOpenFullscreenPreview").attr("disabled", false).parent("label").removeClass("field_disabled");
    $('#chkOpenDocForReadingDefault,#chkOpenDocForEditingDefault').attr('disabled', "disabled").next("label").addClass('field_disabled');
  } else {
    //$("#chkOpenFullscreenPreview").attr("disabled", true).parent("label").addClass("field_disabled");
    $('#chkOpenDocForReadingDefault,#chkOpenDocForEditingDefault').attr('disabled', false).next("label").removeClass('field_disabled');
  }
}

function ViewPreviewSettingsModal_ChangePreviewSettings(radio) {
  if ($(radio).is(":checked")) {
    Core.agent.getPlugin('DocumentPlugin').done((plugin) => {
      ViewPreviewSettingsModal_DisableControls();
    }).fail(function () {
      ReloadWindowToLoadPlugin = function () {
        WebAccess.agent.stop();
        WebAccess.agent.start();
      };
    });
  }
  else {
    ReloadWindowToLoadPlugin = null;
  }
}

var ReloadWindowToLoadPlugin;

function RegisterUserMenuHelpItem(title, url) {
  if (title !== '' && url !== '') {
    g_UserMenuHelpItem = {
      text: title,
      onClick: function () {
        window.open(url);
      }
    };
  }
}

function InitExplorerSidebar() {
  // Скрывем либо отображаем логотип в зависимости от режима открытия страницы,
  // дизейблим quick search если открыт custom search.
  if (Core.toolBars.main.isSearchMode() && !Core.toolBars.main.isIntegratedSearchMode()) {
    $('.explorer-header__logo').hide();
    $('.show-folder-link').show();
    $('.quick-search').addClass('disabled');
  } else {
    $('.show-folder-link').hide();
    $('.explorer-header__logo').show();
  }
}

(function () {
  var lastCount = 0; // количество объектов в списке после фильтрации.
  var lastTotalCount = 0; // всего объектов в списке.
  var lastIsFiltered = false;

  var GetRowsCount = window.GetRowsCount = function () {
    //Shirobokov_AV: раньше было lastTotalCount.
    return lastCount;
  }

  var GetTotalRowsCount = window.GetTotalRowsCount = function () {
    return lastTotalCount;
  }

  var ShowRowsCount = window.ShowRowsCount = function (count, totalCount, isFiltered) {
    lastCount = count;
    lastTotalCount = totalCount;
    lastIsFiltered = isFiltered;
    //var visible = $('.object_contents .folder_item, .dxgvDataRow[id]', $('#main_container')).length;

    //if (isFiltered) {
    //  $('#RowCount').html(L("OBJECTS_TOTAL", L("SELECTED_OF_TOTAL", count, totalCount)));
    //  $('#RowCount').html(L("OBJECTS_TOTAL", L("SELECTED_OF_TOTAL", count, totalCount)));
    //}
    //else {
    //  $('#RowCount').html(L("OBJECTS_TOTAL", count) + '&nbsp;');
    //}
    if (WA.getLocation() !== "referencerecords") $('#RowCount').html("(" + count + ")")
    else $('#RowCount').html(L("RECORDS_TOTAL", count));
  }

  var UpdateRowsCount = window.UpdateRowsCount = function () {
    ShowRowsCount(lastCount, lastTotalCount, lastIsFiltered);
  }

  var ModifyRowsCount = window.ModifyRowsCount = function (addCount) {
    if (lastCount != '1000+') {
      lastCount = parseInt(lastCount, 10) + addCount;
    }
    if (lastCount != '1000+') {
      lastTotalCount = parseInt(lastTotalCount, 10) + addCount;
    }
    ShowRowsCount(lastCount, lastTotalCount, lastIsFiltered);
  }
})();

// Диалоговое окно с кнопкой OK.
// text - текст сообщения
// title - заголовок сообщения
// OK - callback по нажатию на OK.
function ShowMessage(text, title, ok, buttonText, width, onClose, isError) {
  title = title || "";
  var okFunc = null;
  var settings = {
    title: title,
    resizable: false,
    modal: true,
    autoOpen: true,
    buttons: [
      {
        text: buttonText || L("OK"),
        click: function () { $(this).dialog("close"); if (okFunc) okFunc(); }
      }
    ],
    width: width || 600,
    close: function () { if (onClose) onClose(); clearAllModalDivs(); }
  };
  if ($.isPlainObject(ok)) {
    $.extend(settings, ok);
  } else {
    okFunc = ok;
  }

  var bgClass = '', iconClass = '';
  if (isError === true) {
    bgClass = 'ui-state-error';
    iconClass = 'errp';
  }
  if (isError === false) {
    bgClass = 'ui-state-highlight';
    iconClass = 'wrnp';
  };

  var errHTML;
  if (bgClass !== '') {
    errHTML = '<div class="' + bgClass + ' ui-corner-all error_div_msg" style="width:auto;"><p id="' + iconClass + '"><span style="float: left; margin-right: .3em;" class="ui-icon ui-icon-alert"></span>' + text + '</p></div>';
  } else {
    errHTML = text;
  }

  var res = $("<div />", { html: errHTML }).dialog(settings);
  AdjustDialogIfIpad(settings.width);
  InitHoverForButtons(res.next());
}

// Диалоговое окно с кнопкой OK.
// text - текст сообщения
function ShowError(text, okClick, width, onClose) {
  var mbox = new WA.CMP.dialogs.MessageBox();
  mbox.width = !!width ? width : 600;
  mbox.okButton(okClick);
  mbox.showError(text, null, L('ERROR'), onClose);
  //ShowMessage(text,
  //  L('ERROR'), !!okClick ? okClick : null,
  //  null,
  //  !!width ? width : null,
  //  !!onClose ? onClose : null,
  //  true);
}

// Диалоговое окно с кнопкой OK.
// text - текст сообщения
function ShowWarning(text, okClick, width, onClose) {
  var mbox = new WA.CMP.dialogs.MessageBox();
  mbox.width = !!width ? width : 400;
  mbox.okButton(okClick);
  mbox.showWarning(text, null, L('WARNING'), null, onClose);
  //ShowMessage(text,
  //  L('WARNING'),
  //  !!okClick ? okClick : null,
  //  null,
  //  !!width ? width : null,
  //  !!onClose ? onClose : null,
  //  false);
}


// Диалоговое окно с кнопкной Закрыть
// text - текст сообщения, может состоять из двух частей разделенных знаком ^
// title - заголовок окна. по-умолчанию - Информация
// onClose - функция обратного вызова на закрытие окна
function ShowInfo(text, title, width, height, onClose) {
  var mbox = new WA.CMP.dialogs.MessageBox();
  if (width) mbox.width = width;
  if (height) mbox.height = height;
  mbox.showInfo(text, null, title, onClose);
}

// Показывает диалог подтверждения.
// Вариант 1: ConfirmDialog("Вы хотите удалить все документы?", function() { DeleteAllDocuments(); });
// Вариант 2: ConfirmDialog({
//              text: "Вы хотите удалить все документы?",
//              ok: function() { DeleteAllDocuments(); }
//            });
function ConfirmDialog(text, ok, cancel) {
  var settings = {
    title: L("CONFIRMATION"),
    text: "",
    okText: L("YES"),
    cancelText: L("NO"),
    ok: function () { },
    cancel: function () { },
    resizable: false,
    modal: true,
    enterOk: true,
    onOpen: function () { },
    isShowOkButton: true,
    isShowCancelButton: true
  };
  if ($.isPlainObject(text)) {
    $.extend(settings, text);
  } else {
    settings.text = text;
  }
  if (ok) settings.ok = ok;
  if (cancel) settings.cancel = cancel;

  var modalWindowButtons = [];
  if (settings.isShowOkButton) {
    modalWindowButtons.push({
      text: settings.okText,
      click: function () { if (settings.ok(this) === false) { return; }; $(this).dialog("close"); $(this).remove(); },
      'class': 'primary'
    });
  };
  if (settings.isShowCancelButton) {
    modalWindowButtons.push({
      text: settings.cancelText,
      click: function () { if (settings.cancel(this) === false) { return; }; $(this).dialog("close"); $(this).remove(); }
    });
  };


  var res = $("<div />", { html: settings.text }).dialog({
    zIndex: 1000,
    title: settings.title,
    resizable: settings.resizable,
    height: settings.height,
    width: settings.width,
    modal: settings.modal,
    open: function () {
      key.setScope('keysoff');
      hideAllPopups();
      if (settings.onOpen) settings.onOpen();
    },
    autoOpen: true,
    close: function () { key.setScope('common'); if (settings.close) settings.close(); clearAllModalDivs(); },
    buttons: modalWindowButtons
  });
  AdjustDialogIfIpad(settings.width);
  var buttons = res.next();
  if (settings.enterOk) {
    res.parents('.ui-dialog').find('.ui-dialog-buttonpane button').keyup(function (ev) {
      if (ev.keyCode == 13 || ev.keyCode == 32) {
        $(this).click();
      }
    });
  }
  InitHoverForButtons(buttons);
  AppendDialogHelpIcon(res);
}

// Показывает диалог подтверждения c иконкой
// Вариант 1: ConfirmDialog("Вы хотите удалить все документы?", function() { DeleteAllDocuments(); });
// Вариант 2: ConfirmDialog({
//              text: "Вы хотите удалить все документы?",
//              ok: function() { DeleteAllDocuments(); }
//            });
function ConfirmDialogNew(text, ok, cancel) {
  var settings = {
    text: '',
    ok: ok,
    cancel: cancel,
    close: function () { },
    width: '',
    height: ''
  };
  if ($.isPlainObject(text)) {
    $.extend(settings, text);
  } else {
    settings.text = text;
  }
  var mbox = new WA.CMP.dialogs.MessageBox();
  if (settings.width) mbox.width = settings.width;
  if (settings.height) mbox.height = settings.height;
  mbox.onClose = settings.close;
  mbox.yesNoButtons(settings.ok, settings.cancel);
  mbox.showQuestion(settings.text);
}

// То же самое, что ConfirmDialog, но с width = 300.
function ShowDialog(html, ok, cancel) {
  var settings = {
    text: html,
    ok: ok,
    cancel: cancel,
    width: 300
  }
  if ($.isPlainObject(html)) {
    if (html.html) {
      html.text = html.html;
      delete html.html;
    }
    $.extend(settings, html);
  }
  ConfirmDialog(settings);
}

// Ресайзим окно инcтрукции
function InstructionResize() {
  var $ins = $('.instruction_container');
  if ($ins.length) {
    var cont = $('body');
    $ins.height(cont.height() - $ins.position().top - 25);
  }
}


// Сделать datepicker-ы
function CreateDatePicker(clientId, showTime, onUpdate, settings) {
  if (typeof clientId == "string") {
    var cntl = $("#" + clientId);
  } else {
    var cntl = $(clientId);
  }

  // Инициализизуем локализацию datepicker.
  $.datepicker.setDefaults($.datepicker.regional[currentCultureName]);
  $.timepicker.setDefaults($.timepicker.regional[currentCultureName]);

  var isClosing = false;

  // Общие настройки.
  settings = $.extend({
    beforeShow: function (input, inst) {
      var d = cntl.attr('readonly') ? 'none' : 'auto';
      setTimeout(function () {
        $('#ui-datepicker-div').css('display', d);
      }, 50);
    },
    onSelect: function (d, datepicker, needTriggerChange) {
      var input = (datepicker.input || datepicker.$input);
      // Если используем timepicker, то скрывать календарь при нажатии на уже выбранную дату
      if (showTime) {
        setTimeout(
          function () {
            $('.ui-datepicker-current-day').bind('click', function () { input.datepicker('hide'); });
          }, 0
        );
      }
      // Для статистики
      if (Core.isStatisticEnabled) {
        WA.CR.statistics.write({
          page: WA.getLocation(),
          action: "DateSelect",
          area: (showTime ? 'DateTimePicker' : 'DatePicker'),
          target: (typeof datepicker.input !== 'undefined' ? datepicker.input.get(0) : '')
        });
      }
      if ($.isFunction(onUpdate)) {
        onUpdate.apply(this, arguments);
      }
      if (needTriggerChange !== false && typeof datepicker.input !== 'undefined') {
        input.trigger('change');
      }


    },
    onClose: function (dateText, inst) {
      if (!isClosing) {
        isClosing = true;
        // setTimeout нужен, т.к. в этом событии в input еще присутствует выбранное значение, даже если нажали Отмена.
        //setTimeout(function () {
        SetValidDate(inst.input);
        isClosing = false;
        //}, 10);
      }
    }
  }, settings);

  if (showTime) {
    settings = $.extend({
      showOn: "button",
      buttonImageOnly: true,
      buttonText: ''
    }, settings);

    cntl.datetimepicker(settings);
  } else {
    settings = $.extend({
      showOn: "button",
      showButtonPanel: false
    }, settings);
    cntl.datepicker(settings);
  }

  cntl.on('blur.DatePickerInitializator', () => {
    if (!cntl.hasClass('Req_Disabled') && !cntl.datepicker('widget').is(':visible')) {
      // вызываем SetValidDate только если мы вне формы; или на форме, но форма уже была изменена
      if (!WA.CR.form || WA.CR.form.isChanged()) {
        SetValidDate(cntl);
      }
    }
  }).on('keydown.DatePickerInitializator', function (ev) {
    var key = ev.which || ev.keyCode;
    //ENTER
    if (key === 13) {
      SetValidDate($(this));
      // Вызовем событие изменения. Проверки needTriggerChange нет, т.к. его значение определяется в выпадайке с таймпикером (false, если время не выбрано)
      cntl.trigger('change');
    }
  });

  cntl.addClass('inited').trigger('Init');
}

function SetValidDate(inp) {
  function setDate(date) {
    inp.datepicker("setDate", date);
    inp.data('selDate', date);
  }

  var d = ParseDateTime(inp);
  setDate(d);
}

// timeArr = ["time"[, "AMPM"]]
function ParseTime(timeArr, timeFormat) {
  var h = -1;
  var m = -1;
  var s = -1;
  var time = timeArr[0].split(":");
  var TT = (timeArr.length == 2 ? timeArr[1] : "");
  // Регулярка для проверки введено am, pm или нет.
  var re = new RegExp("^([aApP]?|[aApP]{1}[mM]?)$");

  h = parseInt(time[timeFormat.indexOf("h")], 10);
  m = parseInt(time[timeFormat.indexOf("m")], 10);
  s = parseInt(time[timeFormat.indexOf("s")], 10);

  // Если ввели корректно am/pm => формат американский и продолжаем парсить
  if (!re.test(TT))
    TT = null;

  h = (h >= 0 && h <= 23 ? h : 0);
  m = (m >= 0 && m <= 59 ? m : 0);
  s = (s >= 0 && s <= 59 ? s : 0);

  if (TT && TT.toLowerCase() == 'am' && h == 12) {
    h = 0;
  }
  if (TT && TT.toLowerCase() == 'pm' && h != 12) {
    h += 12;
  }

  return [h, m, s];
}

// Проверяет установленные даты в компоненте поиска и предупреждает если дата ПО установлена меньше
function CheckPeriod(dateText, inst) {
  var id = inst.input.attr('id');
  var idPO;
  var d, dPO;
  if (id.indexOf('PO') >= 0) { idPO = id; id = id.substr(0, id.indexOf('PO')); }
  else { idPO = id + 'PO'; }
  d = $('#' + id).datepicker('getDate');
  dPO = $('#' + idPO).datepicker('getDate');
  if (dPO != null && d != null) {
    if (dPO.getTime() < d.getTime()) {
      // строку локализации для сообщения потом изменим
      ShowMessage(L("CHECK_PERIOD"), L("WARNING"), function () { $('#' + id).focus(); }, null, null, null, false);
    }
  }
};
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

$(document).bind('click', function (el, ev) {
  var needHide = (!$(el.target).hasClass("toolbar_group_header") && $(el.target).parent(".toolbar_group_header").length == 0);
});

function ShowSetDocumentRightsDialog(callback) {
  var mbox = new WA.CMP.dialogs.MessageBox();
  mbox
    .addButton('set_rights_btn', L('SET_EDOC_RIGHTS'), function () {
      DoAction('mode=edit&view=RightsList', false);
    })
    .addButton('proceed_btn', L('PROCEED_SAVING'), function () {
      if (callback) callback();
    })._setDefaultButton('set_rights_btn');
  mbox.isShowCancelButton = false;
  mbox.isShowOkButton = false;
  mbox.showWarning(L('EDOC_SET_RIGHTS_MSG'));

  AdjustDialogIfIpad(450);
}

function CopyInfoToClientBuffer() {
  var info = "";
  $("div.settings-params").find('p,li').each(function () {
    info += (this.nodeName == 'LI' ? '- ' : '') + $(this).text() + '\n';
  });
  Core.clipboard.copyTextToClipboard(info);
}

(function () {

  function make(msgType) {
    return '<div class="error_msg_container ui-state-' + msgType + ' ui-corner-all" style="padding: 10px; margin-bottom: 10px">' +
      '<span class="ui-icon ui-icon-alert" style="float: left; margin-right: .3em;"></span></div>';
  }

  function CreateMessageHtml(msg, type) {
    var mainText = msg;
    var secondText = '';
    var splitterIndex = msg.indexOf('^');
    if (splitterIndex != -1) {
      mainText = msg.substring(0, splitterIndex);
      secondText = (msg.substring(splitterIndex + 1, msg.length)).fromISBuilderToNormal();
    }
    if (!type) type = '';
    var messageHtml = ''; //'<span class="ui-icon ui-icon-alert" style="float: left; margin-right: .3em;"></span>';
    messageHtml += '<div class="message-text error-mbox ' + type + '">';
    messageHtml += '<div class="message-main-text upper-area-text">' + mainText + '</div>';
    messageHtml += '<div class="message-second-text">' + secondText + '</div>';
    messageHtml += '</div>';
    return messageHtml;
  }

  // Возвращает предупреждение (html-элемент).
  window.MakeWarningMessage = function (msg) {
    var res = $(make('highlight'));
    res.append(CreateMessageHtml(msg, 'wrn'));
    //res.find('.error_msg').html(msg);
    return res;
  };

  window.MakeErrorMessage = function (msg) {
    var res = $(make('error'));
    res.append(CreateMessageHtml(msg, 'err'));
    //res.find('.error_msg').html(msg);
    return res;
  };

  window.MakeInfoMessage = function (msg) {
    var res = $(make('info'));
    res.append(CreateMessageHtml(msg, 'info')).children().first().attr('class', 'Information_16.png');
    //res.find('.error_msg').html(msg).prev().attr('class', 'Information_16.png');
    return res;
  };

})();

// Показ модального окна.
// name - название контроля для отображения.
function ShowModalWindow(name, options) {
  var handlerExecuted = false;
  var hideReferenceDropDown = function () {
    hideAllPopups();
    if (!handlerExecuted) {
      handlerExecuted = true;
      return settings.cancel();
    }
  };

  // если высоту не задали явно, то пусть будет auto. Раньше всегда была auto.
  var settings = {
    title: "", // Заголовок окна.
    params: null, // Параметры, передаваемые контролю.
    okText: L("OK"), // Текст на кнопке "ОК"
    cancelText: L("CANCEL"), // Текст на кнопке "CANCEL"
    ok: function () { }, // Функция, которая выполнится при нажатии на "ОК"
    cancel: function () { }, // Функция, которая выполнится при нажатии на "CANCEL"
    drag: function () { },
    width: 600, // Ширина окна
    height: "auto",
    resizable: false, // Можно ли изменять размеры окна
    position: "default", // Позиционирование окна
    autoOpen: true,
    close: hideReferenceDropDown
  };


  function executeAndCloseFunc(handler) {
    return function () {
      var needClose = true;
      try {
        handlerExecuted = true;
        if (handler() === false)
          needClose = false;
      } catch (_) { }
      if (needClose) {
        $(this).dialog('close');
      };
    };
  };

  var hh = null;

  function showMessage(errMsg, msgType) {
    if (!wnd.is(':visible') && errMsg != null && errMsg != '')
      wnd.dialog('open');
    if (hh === null) {
      hh = wnd.height();
    }
    if (typeof errMsg === 'undefined' || errMsg === null || errMsg === '') {
      wnd.find('.error_msg_container').hide();
      wnd.height(hh);
    } else {
      wnd.find('.error_msg_container').remove();
      if (msgType === 'error') {
        wnd.prepend(MakeErrorMessage(errMsg));
      } else if (msgType === 'info') {
        wnd.prepend(MakeInfoMessage(errMsg));
      } else {
        wnd.prepend(MakeWarningMessage(errMsg));
      }
      if (msgType == 'warning') msgType = 'highlight';
      wnd.find('.error_msg_container').removeClass('ui-state-error').removeClass('ui-state-highlight').removeClass('ui-state-info').addClass('ui-state-' + msgType).show();
      wnd.css('height', hh + wnd.find('.error_msg_container').outerHeight() + 10);
    }
  }

  var shownMessageType = '';

  function showError(errMsg) {
    shownMessageType = (errMsg ? 'error' : '');
    showMessage(errMsg, 'error');
  }

  function showWarning(warnMsg) {
    // Не показываем warning если уже была показана ошибка.
    if (shownMessageType === 'error') return;

    shownMessageType = (warnMsg ? 'warning' : '');
    showMessage(warnMsg, 'warning');
  }

  function showInformation(infoMsg) {
    // Не показываем info если уже была показана ошибка или предупреждение.
    if (shownMessageType === 'error' || shownMessageType === 'warning') return;

    shownMessageType = (infoMsg ? 'info' : '');
    showMessage(infoMsg, 'info');
  }

  $.extend(settings, options);

  $('div#modal_window').remove();
  var wnd = $('<div id="modal_window" style="overflow-x: hidden; overflow-y:auto"><div class="spinner"></div></div>');
  var ready = false;

  var needShowButtons = (typeof settings.showButtons === 'undefined' || settings.showButtons === true);

  // Было еще height: settings.height, но из-за него высота была слишком большой.
  $(function () {
    wnd.dialog({
      zIndex: 1000,
      title: settings.title,
      resizable: settings.resizable,
      width: settings.width,
      height: settings.height,
      maxHeight: Math.floor($(window).height() * 0.95), // максимальная высота диалога в 95% высоты браузера
      modal: true,
      autoOpen: settings.autoOpen,
      // TODO Требется рефакторинг закрытия, т.к. сейчас диалог из разметки не удаляется.
      close: function () { if (settings.close) settings.close(); key.setScope('common'); },
      closeText: L('CLOSE'),
      dragStart: function () {
        hideAllPopups();
      },
      drag: settings.drag,
      buttons: (needShowButtons ? [
        {
          text: settings.okText,
          click: executeAndCloseFunc(settings.ok),
          'class': 'primary',
          'data-name': 'OkButton'
        },
        {
          text: settings.cancelText,
          click: executeAndCloseFunc(settings.cancel),
          'data-name': 'CancelButton'
        }
      ] : [])
    }).data('error', showError).data('info', showInformation).data('warning', showWarning).data('disable_ok', function () {
      $('#modal_window').next().find('.ui-button:first').data('uiButton').disable();
    }).data('enable_ok', function () {
      $('#modal_window').next().find('.ui-button:first').removeClass('active hover').data('uiButton').enable();
    });
    AdjustDialogIfIpad(settings.width);

    // Для статистики.
    var jModalWindowContainer = wnd.parents('.ui-dialog');
    jModalWindowContainer.find('.ui-dialog-titlebar').addClass('stat_Title');
    jModalWindowContainer.find('.ui-dialog-titlebar-close').attr('data-name', 'CloseIcon');
    jModalWindowContainer.find('.ui-dialog-content').addClass('stat_Content');
    jModalWindowContainer.find('.ui-dialog-buttonpane').addClass('stat_Buttons');

    // TODO Bessolcyn_FI: надо как то исправить эту затычку
    if (name != 'askable_params' && WA.getLocation() == 'task') key.setScope('modalwindow');
  });
  InitHoverForButtons(wnd.next());

  CallServiceSync("/ModalWindow.asmx/Create", { ControlName: name, Params: $.toJSON(settings.params) }, function (res) {
    if (res.Success) {
      res = res.Result;
      var jModalWindowContainer = wnd.parents('.ui-dialog');

      // Для статистики.
      jModalWindowContainer.addClass('stat_ModalWindow_' + name).attr("data-stataction", 'ModalWindow');

      wnd.html(res.html);
      //Добавляем "?" для вызова справки.
      AppendDialogHelpIcon(wnd);
      jModalWindowContainer.find('.DialogHelpIco').attr('data-name', 'HelpIcon');

      // Устанавливаем position тут, т.к. диалог выравнивается неправильно до добавления html-контента.
      if (wnd.hasClass('ui-dialog-content')) wnd.dialog('option', 'position', { my: 'center center', at: 'center center', of: window });

      if (name === 'sign') {
        wnd.css('position', 'static');
      }
      if (res.initJs) {
        var f = new Function(res.initJs);
        var cnt = this;
        setTimeout(function () {
          f.apply(cnt);
        }, 10);
      }
      ready = true;
    } else {
      wnd.empty();
      showError(res.Error);
      $(function () {
        wnd.data('disable_ok')();
      });
    }
    if (settings.afterOpen) settings.afterOpen();
  }, function (err) { showError(err); });

  return wnd;
}

//Добавляет "?" для вызова справки.
function AppendDialogHelpIcon(wnd, isCustomDlg) {
  if (wnd && wnd.length > 0) {
    var el;
    if (isCustomDlg === true) {
      el = wnd;
    } else {
      el = wnd.parent().find('.ui-dialog-titlebar');
    };
    if (el.find('.DialogHelpIco').length == 0) {
      el.append('<a href="#" class="DialogHelpIco ui-dialog__help-button" onclick="return false;"><svg class="ui-dialog__help-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#help-16"></use></svg></a>');
    };
  };
};

/**
* Вычислить задержку перед закрытием диалога-спинера.
* @global
* @function setSpinnerDialogDelay
* @param {Object} lastTimestamp - время, когда диалог был показан.
*/
const setSpinnerDialogDelay = (lastTimestamp) => {
  let spinnerDelay = 2000 - (Date.now() - lastTimestamp);
  if (spinnerDelay < 0) {
    spinnerDelay = 0;
  }
  return spinnerDelay;
};

/**
* Экспорт документа без модального окна.
* @global
* @function ExportEDocNow
* @param {Object} eDocId - ид документа.
* @param {Object} verNumber - номер версии.
* @param {Object} needLock - признак экспорта с блокировкой.
* @param {Object} needExport - признак открытия на чтение/изменение или экспорт.
* @param {Object} transform - тип преобразования.
* @param {Object} toEsd - в формат esd.
* @param {Object} withOnlyApprovingSigns - признак с утверждающими подписями.
* @param {boolean} [needSendMail = false] - признак отправить вложением в письмо.
*/
function ExportEDocNow(eDocId, verNumber, needLock, needExport, transform, toEsd, withOnlyApprovingSigns, needSendMail = false) {
  var mode = needLock ? (needExport ? "EXPLOCK" : "EDITLOCK") : (needExport ? "EXPORT" : "VIEW");
  var url = "";
  var openPreview = false;

  if (mode == "VIEW") {
    openPreview = true;
    url = GetPreviewEDocUrl(eDocId, verNumber);
  }
  else {
    url = format("Doc.aspx?sys={code}&ext={ext}&ID={doc_id}&view=ShowVerList&ver={ver_num}{explock}{transformName}{toEsd}{withOnlyApprovingSigns}",
      { code: g_SysCode, ext: g_ExtName, doc_id: eDocId, ver_num: verNumber, explock: "&mode=" + mode, transformName: "&transform=" + transform, toEsd: "&toEsd=" + toEsd, withOnlyApprovingSigns: "&withOnlyAppSings=" + withOnlyApprovingSigns });
  }

  if (needLock && !needExport) {
    setTimeout(function () {
      ShowMessage(L("OPEN_FOR_EDIT_TITLE"), L("TAKE_OUT_DOCUMENT_VERSION"), null, null, 500, null, false);
    }, 500);
  }

  UnbindBeforeUnload();

  if ((openPreview)) {
    if (openPreview) ShowTopSpinner(L("PLEASE_WAIT"), true);
    window.open(url, 'EDoc' + eDocId);
    if (openPreview) HideTopSpinner("", 1);
  } else {
    setTimeout(function () {
      if (needLock && WA.getLocation() == 'doc' && GetParamInURL('view').toLowerCase() == 'showverlist') {
        ReloadVersionList();
      }
    }, 100);

    let dialog = new WA.CMP.dialogs.BaseDialog;
    dialog.isShowOkButton = false;
    dialog.width = 'auto';
    dialog.height = 'auto';
    dialog.closeOnEscape = false;

    // Невидимая кнопка для того, чтобы сработал setScope и нельзя было на клавиатуре по странице гулять.
    dialog.modalWindowButtons.push({
      id: "hiddenButton",
      text: "",
      click: buttonClick = function () { return false; },
      Class: "dialog_hidden_button"
    });

    dialog.setSpinner(L('PLEASE_WAIT_DONT_CLOSE_PAGE'));
    dialog.setTitle(L('UI_DOCUMENT_EXPORT_SPINNER_TITLE'));
    dialog.removeCloseButton();
    let needShowSpiner = true;
    let lastTimestamp = 0;
    let fileLink;

    let promise = new Promise((resolve, reject) => {
      CallService('/Document.asmx/GetDocumentBodyLink', {
        DocumentID: eDocId,
        VersionNumber: verNumber,
        LockDocument: needLock,
        TransformationName: transform,
        ToEsd: toEsd,
        WithApprovingSigns: withOnlyApprovingSigns,
      }, res => {
        if (!res.Success && res.Error) {
          reject(res.Error);
        }
        if (res.Success && res.Result) {
          fileLink = res.Result;
          resolve("OK");
        }
      }, () => {
        reject(L('ERR_CONNECTION_RESET'));
      });
    });

    promise.then(
      result => {
        needShowSpiner = false;
        // Если показали диалог с ожиданиме экспорта, то крутим его минимум 2 секунды.
        const spinnerDelay = setSpinnerDialogDelay(lastTimestamp);
        setTimeout(() => {
          dialog.close();
          var toastMsg = new WA.CMP.notifications.Toast();
          toastMsg.show(L('UI_EXPORT_CONFIRMATION'));
          if (needSendMail) {
            WebAccess.agent.edms.sendEmail(fileLink, false);
          } else {
            if (WA.ENV.isIOS()) {
              window.open(fileLink);
            } else {
              location.href = fileLink;
            }
          }
        }, spinnerDelay);
      },
      error => {
        needShowSpiner = false;
        // Если показали диалог с ожиданиме экспорта, то крутим его минимум 2 секунды.
        const spinnerDelay = setSpinnerDialogDelay(lastTimestamp);
        setTimeout(() => {
          dialog.close();
          ShowError(error);
        }, spinnerDelay);
      });
    // Если документ экспортировался за секунду, то показывать диалог с ожиданием экспорта не нужно. 
    setTimeout(() => {
      if (needShowSpiner) {
        dialog.show();
        lastTimestamp = Date.now();
      }
    }, 1000);
  }

}

function GetPreviewEDocUrl(id, versionNumber) {
  var useFullScreen = (g_isFullscreenPreview) || ($('body').width() <= 800);
  return format("{page}.aspx?sys={code}&ext={ext}&ID={doc_id}&view=Preview&VersionNum={ver_num}",
    { page: useFullScreen ? "DocumentPreview" : "Doc", code: g_SysCode, ext: g_ExtName, doc_id: id, ver_num: versionNumber });
}

/**
* Экспорт документа.
* @global
* @function ExportEDoc
* @param {Number} id - ид документа.
* @param {Boolean} hideLock - признак скрытия галочки "заблокировать".
* @param {Number} verNumber - номер версии.
* @param {Boolean} openRead - признак открытия на чтение.
* @param {Function} OkFunc - функция вызова на кнопке ОК.
* @param {Function} AgentCallback - функция обратного вызова.
* @param {String} encryptionKey - ключ для дешифрования.
* @param {Boolean} [needSendMail=False] - признак отправить вложением в письмо..
*/
function ExportEDoc(id, hideLock, verNumber, openRead, OkFunc, AgentCallback, encryptionKey, needSendMail = false) {

  const exportFunc = function () {
    id = id || GetParamInURL('id');
    // если не нужно показывать чекбокс с блокировкой, то попытаться экспортировать, одну версию документа.
    if (hideLock && tryExportSingleVersion(id, openRead, AgentCallback, needSendMail))
      return;
    exportEDocWithDialog(id, hideLock, verNumber, openRead, OkFunc, AgentCallback, encryptionKey, needSendMail);
  }

  if (needSendMail) {
    Core.agent.getPlugin('mailplugin')
      .done(() => {
        exportFunc();
      })
      .fail(() => {
        log.error('Can not send document. Mail plugin is not available');
      }
      );
  }
  else {
    exportFunc();
  }

}

/**
* Экспорт одной версии документа.
* @function tryExportSingleVersion
* @param {Number} id - ид документа.
* @param {Boolean} openRead - признак открытия на чтение.
* @param {Function} AgentCallback - функция обратного вызова.
* @param {String} encryptionKey - ключ для дешифрования.
* @param {Boolean} [needSendMail=False] - признак отправить вложением в письмо..
*/
function tryExportSingleVersion(id, openRead, AgentCallback, needSendMail = false) {
  var result = false;

  CallServiceSync("/EDocument.asmx/HasOnlyOneVersion", { EDocID: id }, function (res) {
    if (!res.Success && res.Error) {
      result = true;
      let severity;
      if (res.Severity !== '-1') severity = Number(res.Severity);
      WA.CR.inlineHint.show(res.Error, null, severity, INLINE_HINT_PRIORITY.PRIMARY);
      return;
    }

    if (res.Success && res.Result) {
      //Здесь умышленно оставлено "==", т.к. может прийти "2" в строке
      if (!openRead && res.Result == 2) {
        if (AgentCallback) {
          AgentCallback();
          result = true;
        }
        return;
      }
      if (AgentCallback) AgentCallback();
      else ExportEDocNow(id, "lastver", !openRead && res.Result == 1, false, needSendMail);
      result = true;
    }

    /**
    * Всегда открывать последнуюю версию без модалки,
    * если необходим предпросмотр
    * @since 5.0.4
    * @see Замечание #74358
    */
    if (!AgentCallback) {
      ExportEDocNow(id, "lastver", !openRead && res.Result == 1, false, needSendMail);
      result = true;
    };

  });
  return result;
}

/**
* Экспорт документа c диалогом.
* @function exportEDocWithDialog
* @param {Number} id - ид документа.
* @param {Boolean} hideLock - признак скрытия галочки "заблокировать".
* @param {Number} verNumber - номер версии.
* @param {Boolean} openRead - признак открытия на чтение.
* @param {Function} OkFunc - функция вызова на кнопке ОК.
* @param {Function} AgentCallback - функция обратного вызова.
* @param {String} encryptionKey - ключ для дешифрования.
* @param {Boolean} [needSendMail=False] - признак отправить вложением в письмо..
*/
function exportEDocWithDialog(id, hideLock, verNumber, openRead, OkFunc, AgentCallback, encryptionKey, needSendMail = false) {
  const showLock = !hideLock;
  const decryptKey = !!encryptionKey ? encryptionKey : '';
  var OK = OkFunc ? OkFunc : function () {
    var modalWindow = $('#modal_window');
    var verNumberCheckedRadio = modalWindow.find('input[type="radio"]:checked');
    var verNumber = verNumberCheckedRadio.val();
    let verSize = verNumberCheckedRadio.data('size_in_bytes');
    if (showLock)
      var explock = modalWindow.find('#lock:checked').length != 0;
    else
      var explock = !openRead && verNumberCheckedRadio.data('islocked') != '1';

    var transform = modalWindow.find('#hiddtransformation').val();

    var toEsd = modalWindow.find("#export_to_esd_checkbox:checked").length != 0;
    var withOnlyApprovingSigns = false;
    if (toEsd) {
      withOnlyApprovingSigns = modalWindow.find("#export_with_only_approving_signature_checkbox").prop("checked");
    }

    if (verNumber) {
      // Значение 5242880 взяли из исходников платформы.
      if (++verSize > 5242880 && (transform != L('NO') || toEsd)) {
        let dialog = new WA.CMP.dialogs.BaseDialog;
        dialog.isShowOkButton = true;
        dialog.isShowCancelButton = true;
        dialog.height = 'auto';
        dialog.height = 'auto';
        dialog.enterOk = true;
        dialog.closeOnEscape = true;
        dialog.okText = L('CONTINUE');
        dialog.setTitle(L('CONFIRMATION'));
        dialog.setHtml(L('UI_LARGE_DOCUMENT_TRANSFORMATION_MESSAGE'));
        dialog.bind(WebAccess.components.dialogs.BaseDialog.EVENT.AFTER_CLOSE_BY_OK, function () {
          requestAnimationFrame(() => {
            ExportEDocNow(id, verNumber, explock, showLock, transform, toEsd, withOnlyApprovingSigns, needSendMail);
          });
        });
        dialog.show();
      } else {
        ExportEDocNow(id, verNumber, explock, showLock, transform, toEsd, withOnlyApprovingSigns, needSendMail);
      }

    }
  };

  ShowModalWindow("export", {
    title: showLock ? L("EXPORT_DOCUMENT_VERSION") : (openRead ? L("VIEW") : L("EDITING")),
    okText: showLock ? L("OK") : (openRead ? L("OK") : L("OPEN")),
    afterOpen: function () {
      BindHelpIcoClickOnModalWindow('Export');
      key.setScope('baseDialog');
      var transformationsPick = new WebAccess.components.wrappers.form.requisites.Pick('transformation', 'transformation');
      transformationsPick.disable();
      UpdateExportDialog.call($('#modal_window input[type="radio"]:checked'));

      var jExportWithOnlyApprovingSignature = $("#export_with_only_approving_signature_checkbox");
      var jExportToEsd = $("#export_to_esd_checkbox");
      // Управление состояниями checkbox В структуированном виде и Только утверждающие подписи
      jExportToEsd.on("change", function () {
        if (!$(this).prop("checked"))
          if (jExportWithOnlyApprovingSignature.prop("checked"))
            jExportWithOnlyApprovingSignature.prop("checked", false);
      });
      jExportWithOnlyApprovingSignature.on("change", function () {
        if ($(this).prop("checked"))
          if (!jExportToEsd.prop("checked"))
            jExportToEsd.prop("checked", true);
      });

    },
    close: function () {
      clearAllModalDivs();
      key.setScope('common');
    },
    ok: OK,
    params: {
      EDocID: id,
      ShowLock: showLock,
      VerNumber: verNumber,
      Mode: openRead ? "VIEW" : "EDIT",
      IsExport: AgentCallback ? false : true,
      ShowTransformations: true,
      ShowToEsd: true,
      DecryptKey: decryptKey,
    }
  });

  if (showLock) {
    $('#modal_window').data('warnlocked', function () {
      $('#modal_window').data('warning')(L('WRN_CANT_EXPORT_DOC_VER_LOCKED_DB_NO_PARAMS'));
    });
  } else if (!openRead) {
    $('#modal_window').data('warnlocked', function () {
      $('#modal_window').data('warning')(L('WRN_EXPORT_READONLY'));
    });
  } else {
    $('#modal_window').data('warnlocked', $.noop);
  }
}

/**
* Экспорт документа из карточки.
* @global
* @function ExportEDocToolBar
*/
function ExportEDocToolBar() {
  var docID = WA.CR.ID;
  var encoding = WA.CR.Encoding;
  var pluginName = WA.CR.PluginName;
  var callback = function (decryptedKey) {
    ExportEDoc(docID, false, null, null, null, null, decryptedKey)
  };

  getDecryptedKey(docID, encoding, pluginName, callback);
}

/**
* Отправка документа вложением из карточки.
* @global
* @function SendDocByMailToolBar
*/
function SendDocByMailToolBar() {
  const docID = WA.CR.ID;
  const encoding = WA.CR.Encoding;
  const pluginName = WA.CR.PluginName;
  getDecryptedKey(docID, encoding, pluginName, (decryptedKey) => {
    ExportEDoc(docID, false, null, null, null, null, decryptedKey, true)
  });
}

function CheckLock(event, el) {
  if (event.keyCode == 32 || event.which == 32) {
    if (el.checked) {
      el.checked = false;
    }
    else {
      el.checked = true;
    }
  }
}

var UpdateExportDialog = function () {
  var radio = $(this);
  if (radio.is(':checked')) {
    var modal = $('#modal_window');
    var lock = modal.find('#lock');
    var lock_label = modal.find('#lock_label');

    if (radio.data('document_id')) {
      var transformationsPick = new WebAccess.components.wrappers.form.requisites.Pick('transformation', 'transformation');
      transformationsPick.clearValues();
      transformationsPick.addValue(L('NO'), L('NO'));
      transformationsPick.setValue(L('NO'));

      WA.SRV.call("/EDocument.asmx/GetTransformationsForVersion",
        { DocumentId: radio.data('document_id'), VersionNum: radio.val() }).
        success(function (res) {
          const availableTransformationNames = Object.keys(res);
          for (const name of availableTransformationNames) {
            if (name !== L('NO')) {
              transformationsPick.addValue(name, res[name]);
            }
          }

          if (availableTransformationNames.length === 1 && availableTransformationNames[0] === L('NO')) {
            transformationsPick.disable();
          } else {
            transformationsPick.enable();
          }
        });
    }

    if (radio.data('islocked') == '1') {
      lock.attr('disabled', 'disabled').removeAttr('checked');
      if (lock_label.is(":visible")) modal.data('warning')(radio.data('locked_msg').d);
    } else {
      lock.removeAttr('disabled');
      modal.data('warning')(null);
      if (!lock_label.is(':visible')) {
        modal.data('enable_ok')();
      }
    }
  }
};

function CreateVersionToolbar(DocID, VersionNumber, Encoding, PluginName) {
  var encoding = Encoding;
  var docID = DocID;
  var verNum = (!!VersionNumber ? VersionNumber : null);

  // Если агент доступен, проверяем зашифрован ли документ
  WA.agent.isPluginAvailable('CryptographyPlugin').done((isPluginAvailable) => {
    if (isPluginAvailable && encoding > 0) {
      var onError = function (error) { ShowError(error, null, 350); };
      var pluginName = PluginName;
      switch (encoding + '') {
        case '1':
          //FIXME: переделать на WA.agent.getDocumentDecryptionKey
          GetEncryptionKeyForDoc(docID, encoding, pluginName, '',
            function (encryptionKey) { ImportEDocNew(docID, 'create', verNum, null, '', encryptionKey); },
            onError);
          break;
        case '2':
          //FIXME: переделать на WA.agent.getDocumentDecryptionKey
          RequestPasswordForDecryption('', function (password) {
            ImportEDocNew(docID, 'create', verNum, null, password);
          });
          break;
        case '3':
          //FIXME: переделать на WA.agent.getDocumentDecryptionKey
          RequestPasswordForDecryption('', function (password) {
            GetEncryptionKeyForDoc(docID, encoding, pluginName, password,
              function (encryptionKey) { ImportEDocNew(docID, 'create', verNum, null, password, encryptionKey); },
              onError);
          });
          break;
      }
      return;
    }
    ImportEDocNew(docID, "create", verNum);
  }).fail(function () {
    ImportEDocNew(docID, "create", verNum);
  });
}

// Выводит диалоговое окно импорта документа.
// id - ид документа (если не задан, берется из url)
// mode - режим (по умолчанию import):
//     import - импорт документа
//     return - вернуть документ
//     return_showversions - вернуть документ, при этом вывести окно версий
//     create - создать новую версию
// verNumber - номер версии
function ImportEDoc(id, mode, verNumber, callback) {
  var helpContextId = 'Import';
  if ($.ipad && !WA.ENV.isAndroid()) {
    ShowError(L("NO_FILES_FOR_IPAD"), null, 350);
    return;
  }
  id = id || GetParamInURL('id');
  mode = mode || "import";
  if (!verNumber) verNumber = 0;
  var settings = GetImportModeSettings(mode);
  ShowModalWindow("import", $.extend(settings, {
    afterOpen: function () {
      BindHelpIcoClickOnModalWindow(helpContextId);
    },
    ok: function () {
      var modalWindow = $("#modal_window");
      $(modalWindow.dialog("option", "buttons")).each(function () { if (this.text == L("IMPORT")) g_import_btn = this; });

      var checkFileSize = CheckFileSize(modalWindow.find('input[type="file"]')[0], modalWindow.data('error'));
      // Сделал для того, чтоб при повторном нажатии на "Импорт" документ не импортировался повторно (замечание 56158).
      if (settings.isImporting) {
        if (typeof g_import_btn.isPressed == 'undefined') {
          g_import_btn.isPressed = true;
          if (checkFileSize) {
            modalWindow.find('form').submit();
          }
        }
        else if (!g_import_btn.isPressed) {
          g_import_btn.isPressed = true;
          if (CheckFileSize($('#modal_window form input[type="file"]')[0], $('#modal_window').data('error'))) {
            modalWindow.find('form').submit();
          }
        }
      }
      else {
        if (CheckFileSize($('#modal_window form input[type="file"]')[0], $('#modal_window').data('error'))) {
          modalWindow.find('form').submit();
        }
      }

      return false;
    },
    params: { EDocID: id, DisplayMode: mode, VerNumber: verNumber }
  }));
  $('#modal_window').data('success', function () {
    $('#modal_window').dialog('close');
    ShowTopSpinnerResult(successText, 2000, callback);
    if (!callback && typeof ReloadVersionList != "undefined")
      ReloadVersionList();
  });
}

function ImportEDocNewToolbar() {
  var DocID = GetParamInURL('id');
  var DoIt = function (decryptedKey) {
    ImportEDocNew(DocID, 'import', null, null, null, decryptedKey);
  };

  var encoding = WA.Document.Encoding;

  if (encoding > 0) {
    Core.agent.getPlugin('CryptographyPlugin').done((plugin) => {
      var onError = function (error) { ShowError(error, null, 350); };
      var pluginName = WA.Document.PluginName;
      switch (encoding + '') {
        case '1':
          WebAccess.agent.emds.getDocumentDecryptedKey(DocID, encoding, pluginName, "", DoIt, onError);
          break;
        case '2':
        case '3':
          RequestPasswordForDecryption('', function (password) { WebAccess.agent.edms.getDocumentDecryptedKey(DocID, encoding, pluginName, password, DoIt, onError); });
          break;
      }
    }).fail(function () {
      ImportEDocNew(DocID);
    });
  } else {
    ImportEDocNew(DocID);
  }
}

function ImportEDocNew(DocID, Mode, VersionNumber, Callback, password, encryptionKey) {
  if ($.ipad && !WA.ENV.isAndroid() && (Mode !== 'create')) {
    ShowError(L("NO_FILES_FOR_IPAD"), null, 350);
    return;
  }
  Mode = !!Mode ? Mode : 'import';
  VersionNumber = !!VersionNumber ? VersionNumber : '0';

  var decryptKey = !!encryptionKey ? encryptionKey : '';
  var pass = !!password ? password : '';

  CallService("/ModalWindow.asmx/Create", {
    ControlName: "import", Params: $.toJSON({
      EDocID: DocID,
      DisplayMode: Mode,
      VerNumber: VersionNumber,
      DecryptKey: decryptKey,
      Pass: pass
    })
  }, function (res) {
    if (res.Success) {
      var settings = GetImportModeSettings(Mode);
      var dialog = new WA.components.dialogs.BaseDialog();
      dialog.title = settings.title;
      dialog.isShowOkButton = false;
      dialog.isShowCancelButton = true;
      dialog.setHtml($('<div id="modal_window">').css('overflow', 'hidden').html(res.Result.html)[0].outerHTML);
      dialog.width = 610;
      dialog.onClose = function () {
        // Обновить список версий
        if (typeof ReloadVersionList != 'undefined') ReloadVersionList();
      };

      dialog.modalWindowButtons.push({
        id: 'modal_ok_button',
        'class': 'primary',
        text: settings.okText,
        click: function () {
          dialog.disableButton('modal_ok_button');
          ShowTopSpinner('', true, true);
          return OnImportOkClick(settings.isImporting);
        },
        closeDialog: false
      });
      dialog.onOpen = function () {
        $('#modal_window:visible').
          data('isFileAccepted', false).
          data('success', function () {
            dialog.close();
            ShowTopSpinnerResult(settings.successText, 2000, Callback);
            if (!Callback && typeof ReloadVersionList != "undefined")
              ReloadVersionList();
          }).
          data('error', function (error) {
            var wnd = $('#modal_window:visible');
            if (!!error) {
              wnd.data('isFileAccepted', false);
              dialog.enableButton('modal_ok_button');
              ShowMessageInDialog(wnd, error, 'error');
            }
            HideTopSpinner('', 0, null, true);
          }).
          data('warning', function (warning) {
            var wnd = $('#modal_window:visible');
            if (!!warning) {
              wnd.data('isFileAccepted', false);
              dialog.enableButton('modal_ok_button');
              ShowMessageInDialog(wnd, warning, 'warning');
            }
            HideTopSpinner('', 0, null, true);
          }).
          data('disable_ok', function () { dialog.disableButton('modal_ok_button'); }).
          data('enable_ok', function () { dialog.enableButton('modal_ok_button'); });
      };
      dialog.show();
      BindHelpIcoClickOnModalWindow(settings.helpContextId);

      if (res.Result.initJs) {
        var f = new Function(res.Result.initJs);
        setTimeout(function () {
          f.apply(window);
        }, 10);
      }
    }
    else {
      if (!!res.Error) {
        ShowError(res.Error, null, 350);
      }
    }
  });
}

function GetImportModeSettings(mode) {
  var title, okText, successText, height, isImporting, helpContextId;
  switch (mode) {
    case "import":
      title = L("EDOCUMENT_IMPORT");
      okText = L("IMPORT");
      successText = L("EDOCUMENT_IMPORT_SUCCESS");
      height = 375;
      isImporting = true;
      helpContextId = 'Import';
      break;
    case "return":
      title = L("EDOCUMENT_VERSION_RETURN");
      okText = L("RETURN_EDOC");
      successText = L("EDOCUMENT_VERSION_RETURN_SUCCESS");
      height = 200;
      helpContextId = 'Import';
      break;
    case "return_showversions":
      title = L("EDOCUMENT_RETURN");
      okText = L("RETURN_EDOC");
      successText = L("EDOCUMENT_RETURN_SUCCESS");
      height = 375;
      helpContextId = 'Import';
      break;
    case "create":
      title = L("EDOCUMENT_CREATE_VERSION");
      okText = L("CREATE_VERSION");
      successText = L("EDOCUMENT_CREATE_VERSION_SUCCESS");
      height = 270;
      helpContextId = 'CreateNewVersion';
      break;
    default:
      throw new Error("Invalid mode");
  }
  var settings = {
    "title": title,
    "okText": okText,
    "successText": successText,
    "height": height,
    "isImporting": isImporting,
    "helpContextId": helpContextId
  };
  return settings;
}

function ShowMessageInDialog(wnd, errMsg, msgType) {
  if (!!errMsg) {
    errMsg = errMsg.replace(/\\n/g, "<br>");
    wnd.find('.error_msg_container').remove();
    wnd.prepend((msgType == "error" ? MakeErrorMessage : MakeWarningMessage)(errMsg));
    //wnd.find('.error_msg').html(errMsg);
  }
  else {
    wnd.find('.error_msg_container').hide();
  }
}

function OnImportOkClick(IsImporting) {
  var modalWindow = $('#modal_window');
  var isFileSizeAccepted = CheckFileSize(modalWindow.find('input[type="file"]')[0], modalWindow.data('error'));
  var allowCreateActiveVersion = CheckAllowCreateActiveVersion();
  var currentState = modalWindow.find('#version_state').find('.pickFieldHidden').val();

  if ((currentState == "2") && (!allowCreateActiveVersion)) {
    //выдать модалку на установку устаревших версий
    var dialog = new WA.CMP.dialogs.MessageBox();
    dialog.removeDefaultButtons();
    dialog.addButton('YesButton', L('YES'), function () {
      //пометить что нужно сделать устаревшими все остальные
      modalWindow.find('#set_obsolete_versions').val('true');
      modalWindow.find('form').submit();
    });
    dialog.addButton('NoButton', L('NO'), function () { dialog.close(); HideTopSpinner(); $('#modal_ok_button').removeClass('disabled').removeAttr('disabled'); });
    var kindName;
    if (typeof WA.current.EDocKind == 'undefined') {
      var importEdocId = modalWindow.find('input[name="import_edocid"]').val();
      var jEDocTr = $('#' + importEdocId + '');
      kindName = jEDocTr.attr('data-kind-name');
    } else {
      kindName = WA.current.EDocKind;
    }

    dialog.show(L('CONFIRM_SET_OBSOLETE_STATE_MAIN_TEXT'), format(L("CONFIRM_SET_OBSOLETE_STATE_ADDITIONAL_TEXT"), { '0': kindName }), L('CONFIRMATION'), 'question');
  } else {
    if (IsImporting) {
      if (!modalWindow.data('isFileAccepted') && isFileSizeAccepted) {
        modalWindow.data('isFileAccepted', true);
        modalWindow.find('form').submit();
      }
    } else {
      if (isFileSizeAccepted) {
        modalWindow.find('form').submit();
      }
    }
  }

}

//Проверяет возможность создания действующей версии
function CheckAllowCreateActiveVersion() {
  var res = true;
  if (typeof WA.current.AllowMultipleActiveVersions !== 'undefined') {
    if ((WA.current.AllowMultipleActiveVersions === false) && (WA.current.CountActiveVersions > 0)) {
      res = false;
    }
  } else {
    var importEdocId = $('#modal_window').find('input[name="import_edocid"]').val();
    var jEDocTr = $('#' + importEdocId + '');
    if ((jEDocTr.attr('data-allow-multiple-versions') === "False") && (jEDocTr.attr('data-count-active-versions') != "0")) {
      res = false;
    }
  }
  return res;
}

//Проверяет возможность создания действующей версии
function CheckAllowCreateActiveVersion() {
  var res = true;
  if (typeof WA.current.AllowMultipleActiveVersions !== 'undefined') {
    if ((WA.current.AllowMultipleActiveVersions === false) && (WA.current.CountActiveVersions > 0)) {
      res = false;
    }
  } else {
    var importEdocId = $('#modal_window').find('input[name="import_edocid"]').val();
    var jEDocTr = $('#' + importEdocId + '');
    if (jEDocTr.attr('data-allow-multiple-versions') === "False") {
      //проверяем, есть ли у докемента уже активные версии
      WA.SRV.callSync('/Document.asmx/HasDocumentAnyActiveVersion', { DocumentID: importEdocId }).done(function (result) {
        res = !result;
      });
    }
  }
  return res;
}

function CheckVersionAllowLock() {
  var modalWindow = $('#modal_window');
  var unlockDocLabel = modalWindow.find('#unlock_label');
  var unlockDoc = modalWindow.find('#unlock');
  var allowLock = function () {
    var radio = $(this);
    if (radio.is(':checked')) {
      if (radio.data('islocked') != '1' || radio.parent().find('.Version_Table_Sign_Img:visible').length > 0) {
        unlockDocLabel.addClass('field_disabled');
        unlockDoc.attr('disabled', 'disabled').removeAttr('checked');
      }
      else {
        unlockDocLabel.removeClass('field_disabled');
        unlockDoc.removeAttr('disabled').attr('checked', true);
      }
      //Для закрепленных версий за сервером
      if (radio.data('islockedforserver') == 'True') {
        modalWindow.data('warning')(L("WRN_UNABLE_IMPORT_VERSION_IS_LOCKED_FOR_SERVER", radio.val(), radio.data('lockedservername')));
        modalWindow.data('disable_ok')();
        unlockDocLabel.addClass('field_disabled').children().attr('disabled', 'disabled').removeAttr('checked');
      } else {
        modalWindow.find('.error_msg_container').hide();
        modalWindow.data('enable_ok')();
      }
      modalWindow.find('#import_note').val(radio.data('note'));
    }
  };
  var radios = modalWindow.find('input[type="radio"]').change(allowLock);
  allowLock.call(radios.filter(':checked'));//modalWindow.find('input[type="radio"]:checked'));
}

//Копирование документа
function CopyEdoc() {
  // Копирование зашифрованных документов не поддерживается.
  if (WA.CR.Encoding > 0) {
    ShowError(L("ERR_ENCRYPTED_DOCUMENT_COPY_UNSUPPORTED"), null, 400);
    return;
  }
  CreateNewDocument('copy', WA.FC.folders.getRootFolderID(FOLDER_TYPE.FAVORITES), WA.CR.ID);
}

// Создание нового документа (модальное окно).
// mode - режим template, file или copy
// folder_id - ид папки, куда сохранить документ
// source_id - ид исходного документа (если копирование)
// success - опционально - коллбек после создания, но перед открытием окна. Аргумент - id документа
// decryptedKey - опционально - ключ для расшифровки документа (имеет смысл только для случая source_id != null)
function CreateNewDocument(mode, folder_id, source_id, success, decryptedKey) {
  var data = { Mode: mode, FolderID: folder_id };
  if (source_id) {
    data.SourceID = source_id;
  }
  var title;
  switch (mode.toLowerCase()) {
    case "template":
      title = L("CREATE_DOCUMENT_FROM_TEMPLATE");
      break;
    case "file":
      title = L("CREATE_DOCUMENT_FROM_FILE");
      break;
    case "create":
      title = L("CREATE_DOCUMENT");
      break;
    case "copy":
      title = L("COPY_DOCUMENT");
      break;
  }
  var rnd = Math.floor(Math.random() * 10000).toString();
  var popup;

  function isFormValid(jModalWindow) {
    if (!jModalWindow.find('input[name=refVid]').val()) return false;
    if (!jModalWindow.find('input[name=refCardType]').val()) return false;
    if (mode == 'copy') return true;
    if ($('#radio_from_template').is(':checked')) {
      if (!jModalWindow.find('input[name=refTempl]').val()) return false;
    } else {
      if (!jModalWindow.find('input[type=file]').val()) return false;
      if (!jModalWindow.find('input[name=refApp]').val()) return false;
    }
    return true;
  };

  ShowModalWindow("new_document", {
    title: title,
    okText: mode == "copy" ? L("COPY") : L("CREATE"),
    afterOpen: function () {
      //Сохраняем ключ для дешифрования
      $('#new_decryptionKey').val(decryptedKey);
      if (mode != "copy") {
        BindHelpIcoClickOnModalWindow('NewDoc');
      } else {
        BindHelpIcoClickOnModalWindow('CopyDoc');
      }

      // Убрать лишние отступы, если не нужны
      if (mode === 'file' || mode === 'template') {
        $('#modal_window .modal_td_padded').removeClass('modal_td_padded');
      }

      key.setScope('baseDialog');
    },
    ok: function () {
      var modalWindow = $('#modal_window');
      var validForm = isFormValid(modalWindow);
      if (validForm && CheckFileSize(modalWindow.find('form input[type="file"]')[0], modalWindow.data('error'))) {

        var pleaseWait = new WA.URL('/PleaseWait.aspx');
        pleaseWait.setParam('message', L('PLEASE_WAIT_EDOCUMENT'));
        popup = pleaseWait.open('wnd' + rnd);

        //Шамов А.: Так делать в IE9 нельзя, т.к. после этого не работает импорт документа (form.submit в модальном окне).
        //popup.document.write('<img src="/images/spinner.gif"/><span>&nbsp;' + L('PLEASE_WAIT_EDOCUMENT') + '</span>');
        //popup.document.close();
        modalWindow.find('form').submit();
      }
      else if (!validForm) {
        modalWindow.data('error')(L('NOT_ALL_REQUIRED_FIELDS_FILLED'));
      }
      return false;
    },
    close: function () {
      setTimeout(function () {
        var modalWindow = $('#modal_window');
        if (!!modalWindow) {
          modalWindow.remove();
        }
      }, 50)
    },
    cancel: function () {
      if (onClose) onClose();
    },
    params: data
  });

  var modalWindow = $('#modal_window');
  modalWindow.data('success', function (res) {
    modalWindow.dialog('close');
    if (success) success(GetParamInURL('id', res));
    var resArr = res.split(';');
    var windowName = 'wnd' + rnd;
    resArr.forEach(function (item, i, arr) {
      window.open(item, windowName);
      windowName = "";
    });
    window.open(res, 'wnd' + rnd);
  }).data('fail', function (res) {
    modalWindow.data('error')(res);
    popup.close();
  });
}

function InitCreateNewDocumentControl() {
  $('#modal_window [name="is_from_file"]').change(function () {
    if ($('#modal_window #radio_from_file').is(':checked')) {
      $('#new_div_file input').removeAttr('disabled');
      setTimeout(function () { //setTimeout нужно т.к. инициализация "выбора из справочника" проходит немного позже этого события.
        $('#new_div_app input').SetEnabled();
        $('#new_div_template input').SetDisabled();
      }, 50);
      $('#new_div_file, #new_div_app').removeClass('field_disabled');
      $('#new_div_template').addClass('field_disabled');
    } else {
      $('#new_div_file input').attr('disabled', 'disabled');
      setTimeout(function () { //setTimeout нужно т.к. инициализация "выбора из справочника" проходит немного позже этого события.
        $('#new_div_app input').SetDisabled();
        $('#new_div_template input').SetEnabled();
      }, 50);
      $('#new_div_file, #new_div_app').addClass('field_disabled');
      $('#new_div_template').removeClass('field_disabled');
    }
  }).trigger('change');
  if ($.ipad && !WA.ENV.isAndroid()) {
    $('#modal_window #radio_from_file').attr('disabled', 'disabled');
  }
}

(function () { // Функции для работы с отчетами.

  var lastWnd; // последнее модальное окно.
  var _fillHiddenParamsCallback;

  /**
  * Запустить диалог для получения параметров если указан.
  * @inner
  */
  var showReportDialog = function (params) {
    if (!params.dialogName) {
      WA.FC.reports(params.name).execute().done(function (report) {
        report.open();
      });
    };

    // Интегрированный отчет.
    if (params.referenceName) {
      var referenceRecord = new WA.Link(params.recordId, OBJECT_TYPE.REFERENCE_RECORD, params.referenceName);
      return WA.FC.reports(params.name).showDialogAndExecuteIntegrated(referenceRecord, params.dialogName).done(function (report) {
        report.open();
      });
    } else {
      return WA.FC.reports(params.name).showDialogAndExecute(params.dialogName).done(function (report) {
        report.open();
      });
    }
  };

  // Показывает окно запрашиваемых параметров для отчета.
  // Если все параметры заполнены, или параметров нет, то сразу показывает отчет.
  var ShowReportParams = window.ShowReportParams = function (reportName, id, refcode, opt_reportCaption) {

    var dialog = new WA.CMP.dialogs.BaseDialog;
    dialog.isShowOkButton = false;
    dialog.width = 'auto';
    dialog.height = 'auto';
    dialog.closeOnEscape = false;

    // Невидимая кнопка для того, чтобы сработал setScope и нельзя было на клавиатуре по странице гулять.
    dialog.modalWindowButtons.push({
      id: "hiddenButton",
      text: "",
      click: buttonClick = function () { return false; },
      Class: "dialog_hidden_button"
    });

    var report = WA.factories.reports(reportName);

    var executeFunction = "queryParamsAndExecute";
    var link = "";

    if (id && refcode) {
      link = new WA.Link(id, OBJECT_TYPE.REFERENCE_RECORD, refcode);
      executeFunction = "queryParamsAndExecuteIntegrated";
    }

    report.bind(report['class'].EVENT.BEFORE_EXECUTING, function () {
      dialog.setSpinner(L('PLEASE_WAIT_DONT_CLOSE_PAGE'));
      dialog.setTitle(format(L('PLEASE_WAIT_REPORT'), opt_reportCaption || reportName));
      dialog.show();
      dialog.removeCloseButton();
    });

    report[executeFunction](link).always(function () {
      dialog.close();
    }).done(function (res) {
      res.open();
    }).fail(function (err) {
      // Ошибка должна быть только в модалке.
      $.when(WA.FormControlsInit).then(() => {
        WA.CMP.NTF.InlineHint.hideAll();
      });
      ShowError(err);
    });
  }

  // Инициализирует компоненту "Параметры отчета".
  var InitReportParams = window.InitReportParams = function (params, fillHiddenParamsCallback) {
    _fillHiddenParamsCallback = fillHiddenParamsCallback;
    // Получает контроль для параметра.
    function GetParamControl(name) {
      var reqID = 'rp_' + name;
      var res = $('#' + reqID + '[data-requisite]');
      if (!res.length) {
        res = $(':not(span)#' + reqID);
        if (!res.length) {
          res = $('input[name="' + reqID + '"],textarea[name="' + reqID + '"]');
        }
      }
      return res;
    }

    // Получает значение параметра.
    function GetParamValue(name) {
      var control = GetParamControl(name);
      if (control.data('requisite')) {
        return control.data('requisite').val();
      }
      var hidden = $('#hSelID_rp_' + name);
      if (hidden.length) {
        control = hidden;
      }
      return control.val();
    }

    // additionalParams {'param1_Name': 'param1_Value', 'param2_Name': 'param2_Value'}
    var wnd = lastWnd.data('ok', function () {
      var data = {};
      var err = false;
      $.each(params, function (_, param) {
        var val = GetParamValue(param.name);
        if (!val && param.required) {
          err = L('NOT_ALL_REQUIRED_FIELDS_FILLED');
          return false;
        } else {
          data[param.name] = val;
        }
      });

      if (typeof _fillHiddenParamsCallback != 'undefined') {
        var hiddenParams = _fillHiddenParamsCallback();
        data = $.extend(data, hiddenParams);
      }

      //      logDebug($.toJSON(data));
      //      return false;
      if (err) {
        wnd.data('error')(err);
        return false;
      } else {
        ShowReport(wnd.data('report'), data);
      }
    });
    wnd.find('input.hasDatepicker').attr('tabindex', '-1');
    wnd.dialog('open');
    wnd.find('input.hasDatepicker').removeAttr('tabindex');
    var h = Math.min(450, $('.modal_table', wnd).height() + 5);
    wnd.css('height', h);
  }

  function getIframeDocument(iframeNode) {
    if (iframeNode.contentDocument) return iframeNode.contentDocument
    if (iframeNode.contentWindow) return iframeNode.contentWindow.document
    return iframeNode.document
  }

  // Выводит отчет.
  // report - dict с параметрами name[, id, refcode]
  // params - параметры отчета
  var ShowReport = window.ShowReport = function (report, params) {
    $('#report_iframe').remove();

    var url = format('/Report.aspx?{0}&__go=1&{1}', $.param(report), $.param(params));
    if (($.ipad || WA.ENV.isAndroid()) && !isOpera()) {
      //      var hFrame = $('<div id="report_iframe" style="display:none"><iframe name="hframe"></iframe><form method="get" target="hframe" action="/Report.aspx"></form></div>').appendTo('body');
      //      var form = $('form', hFrame);
      //      $.each(report, addParam);
      //      $.each(params, addParam);
      //      function addParam(name, val) {
      //        $(format('<input type="hidden" name="{0}" />', name)).appendTo(form).val(val);
      //      }
      //      form.submit();
      window.open(url, '_blank'); //location.href = url; // не работает открытие аттачмента в iframe :(
    }
    else {
      var hFrame = $('<div id="report_iframe" style="display:none"><iframe></iframe></div>').appendTo('body');
      getIframeDocument($('iframe', hFrame)[0]).location.replace(url);
    }
  }

  // Выводит отчет без запроса параметров.
  var ShowReportWithoutParams = window.ShowReportWithoutParams = function (report) {
    if (lastWnd) {
      lastWnd.remove();
      lastWnd = null;
    }
    ShowReport(report, {});
  }

})();

// Выводит ошибку при создании отчета.
function ReportError(err) {
  ShowMessage(err, L("ERROR_WHILE_GENERATING_REPORT"), null, null, null, null, true);
}

(function () {
  var divDebug = null;
  var num = 0;

  window.logDebug = function (msg) {
    if (!divDebug) {
      divDebug = $('<div></div>', { css: { 'z-index': '1000000', position: 'fixed', top: '20px', right: '20px', padding: '10px', opacity: 0.5, color: 'red', backgroundColor: 'black' } }).appendTo($('body'));
    }
    divDebug.prepend('<div>' + (num++) + ': ' + msg + '</div>');
  }

})();

// Устанавливает приложение-редактор по имени файла.
// $file - контроль <input type=file>
// req_id - ид контроля-реквизита
function SetEditorAppFromFile($file, req_id) {
  var re = new RegExp('.*\\.([^.]*)', 'gi');
  var m = re.exec($file.val());
  ext = (m != null ? m[1] : "");
  var res = GetImgByExt(ext);
  $("#" + req_id).SetValue(['' + res.analit, '' + encodeURI(res.name), '' + res.name, {}]);
}


function myDateSort(x, y, dir) {
  x = ParseDateTime(x);
  y = ParseDateTime(y);
  return dir * ((x < y) ? 1 : ((x > y) ? -1 : 0));
}

if (jQuery.fn.dataTableExt) {
  jQuery.fn.dataTableExt.oSort['mydate-asc'] = function (x, y) {
    return myDateSort(x, y, -1);
  };
  jQuery.fn.dataTableExt.oSort['mydate-desc'] = function (x, y) {
    return myDateSort(x, y, 1);
  };
}

function ConfirmDelete(num, text) {
  var promise = $.Deferred();
  ConfirmDialogNew({
    text: $.trim(text || (num > 1 ? L("CONFIRM_DELETE_LINKS", num) : L("CONFIRM_DELETE_LINK"))).replace('\n', '<br>'),
    ok: $.proxy(promise.resolve, promise),
    cancel: $.proxy(promise.reject, promise),
    width: 'auto'
  });
  return promise;
}

// Проверяет размер файла в форме. Возвращает true, если файл допустимого размера (или если проверка не удалась).
// input - элемент <input type="file">
// onError - функция, вызываемая в случае если файл слишком велик. В качестве параметра передается сообщение об ошибке.
function CheckFileSize(input, onError) {
  try {
    var f;
    var size;
    // можно проверить для IE < 10, но тогда будет использоваться ActiveX и пользователю будет выдаваться "непонятный запрос"
    if (input && input.files && input.files.length > 0) {
      f = input.files[0];
      size = f.size || f.fileSize;
    } else {
      return true;
    }
    if (typeof size == "number" && size > MaxRequestLength) {
      if (onError) onError(L("FILE_TOO_LARGE", MaxRequestLength));
      return false;
    }
  } catch (e) {
    console.log(e.message);
  }
  return true;
}

function ReferenceOpen(name, viewname) {
  var viewNameParam = '';

  if (viewname) {
    viewNameParam = '&refview=' + viewname;
  }

  window.open(format("/explorer.aspx?sys={sys}&ext={ext}&mode=RefRecords&compcode={name}{viewNameParam}&toolitem=Run",
    { sys: GetParamInURL('sys'), ext: GetParamInURL('ext'), name: name, viewNameParam: viewNameParam }));
}

function WizardExecute(name) {
  window.open(format("/wizard.aspx?code={name}", { name: name }));
}

// Инициализация обложки папки.
function InitFolderCover() {

  var methods = {
    ReferenceOpen: function (name, viewname) {
      return top.ReferenceOpen(name, viewname);
    },

    WizardExecute: function (name) {
      return top.WizardExecute(name);
    },

    TMExecute: function (code) {
      window.open("/task.aspx?sys=" + g_SysCode + "&ext=" + g_ExtName + '&mode=newSR&routecode=' + encodeURIComponent(code));
      return;
    },

    ComponentExecuteInNewProcess: function (_, type, name) {
      if (type == 'Report') {
        top.ShowReportParams(name);
        return;
      }
      top.ShowMessage(L('NO_FILES_FOR_IPAD'));
    },

    IsWebAccess: true
  };

  var iframe = $('#folder_cover_frame');

  if (iframe.length) {
    // Добавить к родительской области соответствующий класс.
    var jRightColumn = $("#right_column");
    jRightColumn.addClass("folder_has_cover");

    // Расширить стили для панели фильтрации.
    var jFiltrationPanel = $(".filtration-panel");
    jFiltrationPanel.addClass("filtration-panel__has_cover");

    if (iframe.attr('src').indexOf('users/foldercovers/') != 0) // non-local frame
      return;

    var iframe_wnd = iframe[0].contentWindow || iframe[0].contentDocument.parentWindow;
    iframe_wnd.onload = function () {
      $.extend(iframe_wnd, methods);
      Object.defineProperty(iframe_wnd, "external", { get: function () { top.ShowMessage(L('NO_FILES_FOR_IPAD')); return undefined; } });

      // Добавить кастомные стили для обложки
      changeCoverStylesImages($('#folder_cover_frame'));
    }
  }
}

// Использовать кастомные стили обложки
function changeCoverStylesImages(jFrame) {
  jFrame.on('load', function () {
    var imagesPath = "/images/covers";
    var jFrameContents = $(this).contents();
    var jFrameHead = jFrameContents.find("head");

    //Подключаем свои стили
    jFrameHead.append($("<link/>",
      { rel: "stylesheet", href: "/css/covers.css", type: "text/css" }));

    //Заменяем иконки
    jFrameContents.find('img[src$="icon_1.gif"]').each(function () {
      $(this).attr('src', imagesPath + '/folder-32.svg');
      $(this).width(40);
    });
    jFrameContents.find('img[src$="icon_2.gif"]').each(function () {
      $(this).attr('src', imagesPath + '/report-32.svg');
      $(this).width(40);
    });
    jFrameContents.find('img[src$="icon_3.gif"]').each(function () {
      $(this).attr('src', imagesPath + '/folderComponents-32.svg');
      $(this).width(40);
    });

    //Заменяем(убираем) логотип
    jFrameContents.find('img.logo').each(function () {
      $(this).attr('src', imagesPath + '/dot.gif');
    });
  });
}

function InsertRouteSchemaImage() {
  if (RouteSchemaPath != '') {
    var img = $('<img src="' + RouteSchemaPath + '" id="RouteSchemaImage">');
    img.bind('load', function () {
      //setRealHeightAndWidth();
    }).appendTo($('#ctl00_MainContent_CardContainer'));
  }
}

function InitTooltips() {
  if (typeof showHints === 'undefined' || showHints === "true" || showHints) {
    $(".hint").each(function () {
      // Убираем title у ячейки-родителя (проставляется slick-grid'ом), чтобы не всплывал браузерный toolptip одновоременно с кастомным.
      $(this).parent().attr('title', '');
      InitAdditionalInfoTooltip($(this));
    });
  }
}

function ContextMenuCheckAll() {
  var check = $('.chkAll').eq(0);
  if (WA.ENV.browser.name.toLowerCase() === 'IE') {
    if (check.attr('CHECKED') == 'checked') check.removeAttr('checked');
    else check.attr('CHECKED', 'checked');
  }
  check.click();
}

// Показать модалку заполенения исполнителей в задаче.
function showRouteModal() {
  var inp = $("#CardContrrolRoute");
  if (inp.length == 0) {
    inp = $('#CardContrrolStandartRoute');
    // У стартованых по ТМ нельзя сбрасывать маршрут.
    if (WA.CR.State !== 0 && inp.hasClass('Req_Disabled')) return;
    ConfirmDialogNew({
      text: L('CONFIRM_TEXT_CLEAR_ROUTE')
    }, function () {
      SetStandardRoute(GetParamInURL('id'), 0, function () {
        $.cookie('showroutemw', '1');
      });
    });
  } else {
    inp.ShowMultiSelectModalWindow();
  };
}

// Показать модалку заполенения наблюдателей в задаче.
function showObserversModal() {
  var threeDotsDiv = $("#CardContrrolObservers").parents(".rs_SelItems_cont").next(".RefSelect_Arrow");
  threeDotsDiv.click();
}

function BindHelpIcoClick(links, ico) {
  $(function () {
    if (g_IsExtHelpAvailable) {
      // Внешняя справка есть.
      var isExplorerAboutIco = false;

      if (!ico) {
        ico = $('#info').find('.HelpIco');
        // Если кнопка в проводнике и шапке, то нужно еще отобразить "О программе".
        isExplorerAboutIco = (WA.getLocation() === 'explorer');
      };

      // Сбрасываем click на иконку Справки и запрещаем дальнейшую инициализацию в Core
      ico.off('click').addClass('inited').attr('title', L('HELP'));

      if (links === null) {
        // Справка по объекту не найдена.
        if (isExplorerAboutIco) {
          // Открываем "О программе".
          ico.attr('title', L('ABOUT')).on('click', function () {
            window.open("/Settings.aspx?view=About", 'settings');
          });
        } else {
          ico.on('click.ExtHelp', function () {
            // Шамов А.: Убрал для исправления замечания http://directum.npo-comp.ru/reference.asp?sys=TEHKASNPO&compcode=%C7%C7%CF&id=5642859
            //ShowMessage(L('INSTRUCTIONS_ARE_NOT_FOUND_FOR_THIS_OBJECT'), L('ERROR'), null, L('OK'), 400, null, true);
          });
        };
      } else {
        var lastUrl;
        var menu_items = [];
        for (lastUrl in links) {
          var click = (function (_lastUrl) {
            return function () { window.open(_lastUrl); };
          })(lastUrl);
          menu_items.push({ text: links[lastUrl], onClick: click });
        };
        if (menu_items.length > 0) {
          menu_items[menu_items.length - 1].separator = true;
        }

        if (isExplorerAboutIco) {
          // Добавляем пункт меню "Справка: <система>"
          if (typeof g_UserMenuHelpItem != 'undefined' && !!g_UserMenuHelpItem) {
            menu_items.push(g_UserMenuHelpItem);
          };
        };

        if (menu_items.length === 1) {
          ico.on('click.ExtHelp', function () {
            window.open(lastUrl);
          });
        } else {
          var menu = new ContextMenu(menu_items, { width: 'auto', "shiftX": -225 });
          $(ico).contextMenu(menu, "click.ExtHelp");
        }
      };
    };

  });
}

// Навешивает открытие справки на иконку в модальном диалоге.
function BindHelpIcoClickOnModalWindow(contextId, wnd) {
  // Проверяем есть ли внешняя справка.
  if (g_IsExtHelpAvailable) {
    if (!wnd) {
      wnd = $('.ui-dialog').filter(':visible');
    };
    var ico = wnd.find('.DialogHelpIco');
    if (!!window['g_ModalWindowExtHelpLinks']) BindHelpIcoClick(window['g_ModalWindowExtHelpLinks'][contextId], ico);
    ico.show();
  }
};

// Обновляет список ссылок внешней справки модальных диалогов.
function UpdateModalWindowExtHelpLinks(newLinks) {
  if (!window['g_ModalWindowExtHelpLinks']) window['g_ModalWindowExtHelpLinks'] = {};
  window['g_ModalWindowExtHelpLinks'] = $.extend(window['g_ModalWindowExtHelpLinks'], newLinks);
};

function AdjustDialogIfIpad(dialogWidth) {

  var width = 0;
  if (dialogWidth) width = dialogWidth;
  if ($.ipad) { $('[role=dialog]').last().css('left', Math.max(($(document).width() - width) / 2, 0)).css('top', 200); }
}

function clearAllModalDivs() {
  $('body').find('> div[role=dialog]').filter(':not(:visible)').children().remove();
}

function ViewOnDesktop(sender, isForEdit) {
  var currentVersion = null;
  var jSender = $(sender);
  //TODO: решение с блокировкой не сработало, много точек, где необходимо снять блокировку, но этого не происходит. Необходимо комплексное решение.
  //jSender.addClass('disabled');
  if (GetParamInURL('view').toLowerCase() == "preview" && WA.Document.Encoding == 0) {
    var versionName = $('#versionSelect').find('input.pickField').val();
    currentVersion = !!versionName ? versionName.substring(0, versionName.indexOf(".")) : null;
  }

  // Если передано все что угодно, но не False, то открывает на редактирование.
  if (isForEdit !== false) isForEdit = true;

  OpenWithAgent({ id: WebAccess.Document.ID }, isForEdit, currentVersion, function () {
    //jSender.removeClass('disabled');
    //jSender.removeClass('hover');
  });
}

function OpenWithAgent(Doc, Lock, Version, callback) {
  var jDoc = $('#' + Doc.id);

  // Убирает иконку загрузки
  function removeDownloadInProgressStatus() {
    if (jDoc.length > 0) {
      jDoc.find('.object-list-item__upload-icon').remove();
      var jDocIcon = jDoc.find('.object-list-item__icon');
      jDocIcon.attr('class', 'object-list-item__icon');
    } else {
      $.when(WA.FormControlsInit).done(function () {
        WA.CR.spinner.hide();
      });
    }
  }
  // Устанавливает иконку загрузки на 3 сек
  function setDownloadInProgressStatus() {
    if (jDoc.length > 0) {
      var jUploadIcon = $('<svg class="object-list-item__upload-icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#download-16"></use></svg>');
      var jDocIcon = jDoc.find('.object-list-item__icon');
      jDocIcon.attr('class', jDocIcon.attr('class') + ' object-list-item__icon_uploaded');
      jDoc.find('.object-list-item__column_type_icon').eq(0).append(jUploadIcon);
    } else {
      $.when(WA.FormControlsInit).done(function () {
        if (WA.getLocation() === "wizard") {
          WA.CR.spinner.showInDialog();
        } else {
          WA.CR.spinner.show();
        }
      });
    }
    setTimeout(removeDownloadInProgressStatus, 4000);
  }

  setDownloadInProgressStatus();

  Core.agent.getPlugin('DocumentPlugin').done((plugin) => {
    WebAccess.agent.edms.checkDocumentHasLocalCopy(Doc.id).always(function (localCopies) {
      if (localCopies.length > 0) {
        removeDownloadInProgressStatus();
        GetEDocumentObject(Doc.id, function (docObj) {
          AskForActionOnDocument(docObj, localCopies, Lock);
        });
      } else {
        ExportEDoc(Doc.id, true, Version, !Lock, function () { // функция при нажатии на ОК при выборе версии
          var selectedVerRadio = $('#modal_window input[type="radio"]:checked');
          var verNumber = selectedVerRadio.val();
          var canExportWithLock = selectedVerRadio.data('islocked') != '1';
          if (canExportWithLock) {
            if (verNumber) {
              SendEDocToAgent(Doc.id, verNumber, Lock);
              // TODO: Получать колбэк
              if (typeof callback === 'function' || callback instanceof Function)
                callback();
            }
          } else {
            AskOpenForView(selectedVerRadio.data('locked_msg').d, Doc.id, verNumber);
            // TODO: Получать колбэк
            if (typeof callback === 'function' || callback instanceof Function)
              callback();
          }
        }, function () {
          SendEDocToAgent(Doc.id, "lastver", Lock);
          // TODO: Получать колбэк
          if (typeof callback === 'function' || callback instanceof Function)
            callback();
        });
      }
    });
  }).fail(function () {
    // TODO: Убрать стрелку
    log.error('Can not open document with agent. Document plugin is not available');
    if (typeof callback === 'function' || callback instanceof Function)
      callback();
  });
}

function SendVersionToAgent(version, lock) {
  var Version = EDocumentVersion(version);
  var docID = Version.GetDocID();

  //FIXME: always переделать на done и fail
  WebAccess.agent.edms.checkDocumentHasLocalCopy(docID).always(function (localCopies) {
    if (localCopies.length > 0) {
      GetEDocumentObject(docID,
        function (docObj) {
          AskForActionOnDocument(docObj, localCopies, lock);
        });
      return;
    }

    SendEDocToAgent(Version.GetDocID(), Version.GetCurrentVersion().Number, lock);
  });
}

function SendEDocToAgent(EDocID, verNumber, Lock) {
  GetEDocumentObject(EDocID, function (Doc) {
    Core.agent.getPlugin('DocumentPlugin').done((plugin) => {
      const operation = Lock ? (TOKEN_OPERATION.DOWNLOAD_DOCUMENT_BODY | TOKEN_OPERATION.UPLOAD_DOCUMENT_BODY | TOKEN_OPERATION.UNLOCK_VERSION) : TOKEN_OPERATION.DOWNLOAD_DOCUMENT_BODY;
      if (verNumber === "lastver") verNumber = Doc.Versions[Doc.Versions.length - 1].Number;
      if (Lock) {
        CallServiceSync("/EDocument.asmx/CheckVersionStateForExport", { "EDocID": Doc.ID, "VerNum": verNumber, "IsExport": false }, function (res) {
          if (res.EnableLock === "false" || res.Error !== "") {
            // предупреждение что нельзя экспортировать и предложение открыть на просмотр
            AskOpenForView(res.Error ? res.Error : res.Warning, Doc.ID, verNumber);
          }
          else {
            RequestTokenAndContinue(operation, Doc, verNumber, Lock);
          }
        }, null);
      }
      else {
        RequestTokenAndContinue(operation, Doc, verNumber, Lock);
      }

    }).fail(function () {
      log.error('Can not open document with agent. Document plugin is not available');
    });
  });
}

function AskOpenForView(message, id, verNumber) {
  var ver = !!verNumber ? verNumber : 0;
  var radio = $('#modal_window input[type="radio"]:checked:visible');
  var okCallback;
  if (radio.length > 0) {
    ver = radio.val();
    okCallback = function () { SendEDocToAgent(id, ver, false); }; // ExportEDocNow(id, ver, false, false); };
  }
  else {
    okCallback = function () { SendEDocToAgent(id, ver, false); }; // ExportEDoc(id, true, 0, true); };
  }

  WA.SRV.call('/EDocument.asmx/CheckVersionFormatForPreview', { EDocID: id, VerNum: verNumber === "lastver" ? 0 : ver })
    .success(function (isPreviewSupported) {
      var mbox = new WA.CMP.dialogs.MessageBox();
      mbox.addButton('ViewInEditor', L('OPEN_IN_EDITOR_FOR_VIEW'), okCallback);
      mbox.addButton('Preview', L('OPEN_IN_PREVIEW'), function () {
        ShowTopSpinner(L("PLEASE_WAIT"), true);
        window.open(GetPreviewEDocUrl(id, ver), 'EDoc' + id);
        HideTopSpinner("", 1);
      });
      mbox.addButton('cancel', L('CANCEL'));
      mbox.isShowCancelButton = false;
      mbox.isShowOkButton = false;
      mbox._setDefaultButton('ViewInEditor');
      mbox.width = 520;
      mbox.showInfo(message);
      if (!isPreviewSupported) mbox.baseDialog.disableButton('preview');
    });

  //ConfirmDialogNew({
  //  text: L("OPEN_FOR_VIEW_QUESTION") + '^' + message, // MakeWarningMessage(message).add($("<div> " + L("OPEN_FOR_VIEW_QUESTION") + "</div>")),
  //  width: 600,
  //  height: "auto",
  //  ok: okCallback, // OpenEDocForView(id, verNumber); },
  //  cancel: null
  //});
}

function OpenEDocForView(id, verNumber) {
  CallServiceSync("/EDocument.asmx/CheckVersionFormatForPreview", { EDocID: id, VerNum: verNumber == "lastver" ? 0 : verNumber },
    function (res) {
      var hrefForExport = format("Doc.aspx?sys={code}&ext={ext}&ID={doc_id}&view=ShowVerList&ver={ver_num}{explock}",
        { code: g_SysCode, ext: g_ExtName, doc_id: id, ver_num: verNumber, explock: "&mode=EXPORT" });
      if (res.Success) {
        var formatSupported = res.Result;
        if (formatSupported || ($.ipad)) {
          ShowTopSpinner(L("PLEASE_WAIT"), true);
          window.open(GetPreviewEDocUrl(id, verNumber), 'EDoc' + id);
          HideTopSpinner("", 1);
        }
        else {
          location.href = hrefForExport;
        }
      }
      else {
        location.href = hrefForExport;
      }
    },
    function (err) {
      let severity;
      if (res.Severity !== '-1') severity = Number(res.Severity);
      WA.CR.inlineHint.show(err.error, null, severity, INLINE_HINT_PRIORITY.PRIMARY);
    });
}

function RequestTokenAndContinue(Operation, Doc, verNumber, Lock) {
  const OpenDoc = (decryptedKey) => {
    RequestToken(Operation, (token) => {
      try {
        ShowTopSpinner(L("EDOC_OPENING"));
        const params = GetAgentOpenDocRequestParamsObject(Doc, verNumber, token, Lock, decryptedKey);
        WebAccess.agent.transmitRequest('opendocument', 'DocumentPlugin', params).fail((response) => {
          if (response.message == "CONNECTION_NOT_AVAILABLE") {
            // Значит агент отвалился. Очистим кэш и попытаемся снова.
            if (typeof WA.CR.agent !== 'undefined') {
              WA.CR.agent.clearPluginCache();
            }
            RequestTokenAndContinue(Operation, Doc, verNumber, Lock);
          } else {
            if (response.message) {
              //Пустые сообщения не выводим
              ShowError(response.message);
            }
            if (params.lock === "y") {
              //Необходимо снять блокировку
              WA.SRV.call("Document.asmx/UnlockVersion", {
                DocumentID: Doc,
                VersionNumber: verNumber,
                UseGlobalLock: false
              });
            }
          }
          console.log(response);
        });
      }
      catch (ex) {
        console.log(ex);
      }

      HideTopSpinner("", 4000);
    }, Doc.ID, verNumber);
  }

  getDecryptedKey(Doc.ID, Doc.Encoding, Doc.PluginName, OpenDoc);
}

function GetEDocumentObject(docID, callback) {
  //if (WebAccess.Document.ID == docID) {
  //  if (callback) callback(WebAccess.Document);
  //}
  //else {
  WA.SRV.call("EDocument.asmx/GetEDocObject", { EDocID: docID }).done(function (res) {
    if (callback) callback(res);
  });
  //}
}

function RequestToken(Operation, RequestTokenCallback) {
  if (arguments.length >= 2 && arguments.length <= 5) {
    var svcParams = { "Operation": Operation };
    for (var i = 2; i < arguments.length; i++) {
      svcParams["Param" + (i - 1)] = arguments[i];
    }
    WA.SRV.call("/Security.asmx/GetOpToken" + (arguments.length - 2), svcParams).done(function (res) {
      if (RequestTokenCallback) RequestTokenCallback(res);
    });
  }
}

/**
 * Формирование URL-параметров для Get-запроса к агенту при редактировании.
 *
 * @function GetAgentOpenDocRequestParams
 * @param Doc {object} Модель отркываемого документа.
 * @param Version {number} Номер версии.
 * @param Token {string} Токен для получения документа с веб-сервера.
 * @param needLock {boolean} Признак необходимости блокировки документа на сервере.
 * @param decryptedKey {string} Ключ для расшифрования тела документа.
 * @return {string} URL-параметры для Get-запроса к агенту при редактировании.
 */
function GetAgentOpenDocRequestParamsObject(Doc, Version, Token, needLock, decryptedKey) {
  var verIndex = -1;
  for (var i = 0; i < Doc.Versions.length; i++) {
    if (Doc.Versions[i].Number == Version) { verIndex = i; break; }
  }
  //FIXME: убрать лишние параметры, названия привести в Pascal стиль.
  return {
    callback: "ProcessResponse",
    id: Doc.ID,
    name: Doc.ClientName.replaceAll('#', '%23'),
    ver: Version,
    ext: (Doc.Versions[verIndex] ? Doc.Versions[verIndex].Editor.Extension : $('#' + Doc.ID + '_' + Version).data('verinfo').Extension),
    editor: (Doc.Versions[verIndex] ? Doc.Versions[verIndex].Editor.EditorCode : $('#' + Doc.ID + '_' + Version).data('verinfo').EditorCode),
    DecryptedKey: decryptedKey || '',
    observetype: (Doc.Versions[verIndex] ? Doc.Versions[verIndex].Editor.CloseObservingType : $('#' + Doc.ID + '_' + Version).data('verinfo').CloseObservingType),
    loc: document.location.host,
    lock: (needLock ? (needLock ? 'y' : 'n') : ($('#lock:checked').length == 1 ? 'y' : 'n')),
    token: Token,
    secure: (document.location.protocol == 'http:' ? 'n' : 'y'),
    culture: currentCultureName,
    sys: g_SysCode
  };
}

/**
 * Формирование URL-параметров для Get-запроса к агенту при редактировании.
 *
 * @function GetAgentOpenDocRequestParams
 * @param Doc {object} Модель отркываемого документа.
 * @param Version {number} Номер версии.
 * @param Token {string} Токен для получения документа с веб-сервера.
 * @param needLock {boolean} Признак необходимости блокировки документа на сервере.
 * @return {string} URL-параметры для Get-запроса к агенту при редактировании.
 * @deprecated Use GetAgentOpenDocRequestParamsObject instead.
 */
function GetAgentOpenDocRequestParams(Doc, Version, Token, needLock) {
  var verIndex = -1;
  for (var i = 0; i < Doc.Versions.length; i++) {
    if (Doc.Versions[i].Number == Version) { verIndex = i; break; }
  }
  return '&id=' + Doc.ID +
    '&name=' + Doc.ClientName.replaceAll('#', '%23') +
    '&ver=' + Version +
    '&ext=' + (Doc.Versions[verIndex] ? Doc.Versions[verIndex].Editor.Extension : $('#' + Doc.ID + '_' + Version).data('verinfo').Extension) +
    '&editor=' + (Doc.Versions[verIndex] ? Doc.Versions[verIndex].Editor.EditorCode : $('#' + Doc.ID + '_' + Version).data('verinfo').EditorCode) +
    '&observetype=' + (Doc.Versions[verIndex] ? Doc.Versions[verIndex].Editor.CloseObservingType : $('#' + Doc.ID + '_' + Version).data('verinfo').CloseObservingType) +
    '&loc=' + document.location.host +
    '&lock=' + (needLock ? (needLock ? 'y' : 'n') : ($('#lock:checked').length == 1 ? 'y' : 'n')) +
    '&method=' + 'opendocument' +
    '&plugin=documentplugin' +
    '&token=' + Token +
    '&secure=' + (document.location.protocol == 'http:' ? 'n' : 'y') +
    '&culture=' + currentCultureName +
    '&sys=' + g_SysCode;
}

function ProcessResponse(data) {
  if (data.ok) {
    HideTopSpinner(data.message, 2500);
  } else {
    HideTopSpinner(data.message, 2500);
  }
}

/**
* Используется в WebAccess для проверки наличия биндингов
* @function jQuery.hasAttr
* @return {jQuery}
*/
$.fn.hasAttr = function (name) {
  return this.attr(name) !== undefined;
};

/**
* Форсирует обновление элемента(для IE и андроида например), когда остаются
* артефакты.
* @function jQuery.redraw
* @return {jQuery}
*/
$.fn.redraw = function () {
  var me = $(this);
  setTimeout(function () { me.css({ "outline": "0px solid white" }) }, 50);
  setTimeout(function () { me.css({ "outline": "none" }) }, 100);
  return $(this);
}

function ShutdownAgentSession() {
  log.info('AGENT', 'End of the session');
  WebAccess.agent.endSession();
}

function selectToolbarBtnOnShowContextMenu(btn) {
  return {
    onShow: function () {
      $(btn).addClass('menu_select');
    },
    onHide: function () {
      $('#toolbar_container').find('.menu_select').removeClass('menu_select');
    }
  };
}


$(function () {
  if ((WA.getLocation() === 'explorer' || WA.getLocation() === 'referencerecords') && WA.ENV.browser.name === 'IE') {
    //Замечание №74474. Что бы после того как нажали "Назад в браузере" чекбоксы были выключены.
    $('#main_container').find('.List input').add('#chkAll').attr('checked', false);
  }
});

function OpenEDocByAgent(id, ver, lock) {
  OpenWithAgent({ id: id }, lock, ver);
};

var wizardLinkRegExp = /compcode=WIZARDS&id=(\d+)/i;

function ReplaceWizardLinks(TaskID) {
  $(function () {
    $('.Card_Task_SavedText').find('a').each(function () {
      var $this = $(this);
      var href = $this.attr('href');
      var b = href.match(wizardLinkRegExp);
      if ((b !== null) && (b.length > 0)) {
        $this.attr('href', '/wizard.aspx?id=' + b[1] + '&TaskID=' + TaskID);
      }
    });
  });
}
/**
* Получает ключ для дешифрования документа.
* @global
* @function getDecryptedKey
* @param {Object} docID - ид документа.
* @param {Object} encoding - тип шифрования.
* @param {Object} pluginName - имя плагина.
* @param {Object} callback - функция обратного вызова.
* @return {Object}
*/
function getDecryptedKey(docID, encoding, pluginName, callback) {
  if (encoding && encoding > 0) {
    if (WA.ENV.platform !== 'linux') {
      Core.agent.getPlugin('CryptographyPlugin').done((plugin) => {
        var onError = function (error) {
          ShowError(error, null, 350);
        };
        switch (encoding) {
          case 1:
            WebAccess.agent.edms.getDocumentDecryptedKey(docID, encoding, pluginName, '', callback, onError);
            break;
          case 2:
          case 3:
            RequestPasswordForDecryption('', function (password) {
              WebAccess.agent.edms.getDocumentDecryptedKey(docID, encoding, pluginName, password, callback, onError);
            });
            break;
        }
      }).fail(function () {
        if (callback instanceof Function) callback();
      });
    } else {
      ShowWarning(L("ERR_ENCODED_OBJECT_ARE_NOT_SUPPORTED"));
    }
  } else {
    if (callback instanceof Function) callback();
  }
}